import React from "react";

export const words = {
  Welcome: {
    en: "Welcome",
    es: "Bienvenidoc",
    fr: "Bienvenue",
  },
  "Bulk Print": {
    en: "Bulk Print",
    es: "Impresión a granel",
    fr: "Impression en masse",
  },
  Dashboard: {
    en: "Dashboard",
    es: "Tablero",
    fr: "Tableau de bord",
  },
  Issues: {
    en: "Issues",
    es: "Cuestiones",
    fr: "Problèmes",
  },
  Info: {
    en: "Info",
    es: "Información",
    fr: "Info",
  },
  Priority: {
    en: "Priority",
    es: "Prioridad",
    fr: "Priorité",
  },
  High: {
    en: "High",
    es: "Alto",
    fr: "Haute",
  },
  Site: {
    en: "Site",
    es: "Sitio",
    fr: "Site",
  },
  Track: {
    en: "Track",
    es: "Pista",
    fr: "Piste",
  },
  User: {
    en: "User",
    es: "Usuario",
    fr: "Utilisateur",
  },
  Marked: {
    en: "Marked",
    es: "Marcado",
    fr: "Marqué",
  },
  Resolved: {
    en: "Resolved",
    es: "Resuelto",
    fr: "Résolu",
  },
  Defect: {
    en: "Defect",
    es: "Defecto",
    fr: "Défaut",
  },
  Inspections: {
    en: "Inspections",
    es: "Inspecciones",
    fr: "Inspections",
  },
  Not: {
    en: "Not",
    es: "No",
    fr: "ne pas",
  },
  Started: {
    en: "Started",
    es: "Empezado",
    fr: "Commencé",
  },
  Today: {
    en: "Today",
    es: "Hoy",
    fr: "Aujourd'hui",
  },
  Logout: {
    en: "Log Out",
    es: "Cerrar sesión",
    fr: "Se déconnecter",
  },
  Finished: {
    en: "Finished",
    es: "Terminado",
    fr: "Fini",
  },
  In: {
    en: "In",
    es: "En",
    fr: "Dans",
  },
  progress: {
    en: "progress",
    es: "Progreso",
    fr: "le progrès",
  },
  Start: {
    en: "Start",
    es: "Comienzo",
    fr: "Début",
  },
  Time: {
    en: "Time",
    es: "Hora",
    fr: "Temps",
  },
  Finish: {
    en: "Finish",
    es: "Terminar",
    fr: "terminer",
  },
  Status: {
    en: "Status",
    es: "Estado",
    fr: "Statut",
  },
  Issue: {
    en: "Issue",
    es: "Problema",
    fr: "Problème",
  },
  Reported: {
    en: "Reported",
    es: "Informado",
    fr: "Signalé",
  },
  Low: {
    en: "Low",
    es: "Bajo",
    fr: "Faible",
  },
  Medium: {
    en: "Medium",
    es: "Medio",
    fr: "Moyen",
  },
  On: {
    en: "On",
    es: "en",
    fr: "Sur",
  },
  Rail: {
    en: "Rail",
    es: "Vía o riel",
    fr: "Rail",
  },
  Ties: {
    en: "Ties",
    es: "durmiente",
    fr: "Liens",
  },
  Switch: {
    en: "Switch",
    es: "Cambiar",
    fr: "Aiguillage",
  },
  Line: {
    en: "Line",
    es: "Línea",
    fr: "Ligne",
  },
  Stone: {
    en: "Stone",
    es: "Piedra",
    fr: "Calcul",
  },
  Xing: {
    en: "Xing",
    es: "crucero",
    fr: "Xing",
  },
  Platform: {
    en: "Platform",
    es: "Plataforma",
    fr: "Plate-forme",
  },
  Speed: {
    en: "Speed",
    es: "Velocidad",
    fr: "La vitesse",
  },
  Change: {
    en: "Change",
    es: "Cambio",
    fr: "Changement",
  },
  Gas: {
    en: "Gas",
    es: "Gas",
    fr: "Gaz",
  },
  Pipeline: {
    en: "Pipeline",
    es: "Tubería",
    fr: "Pipeline",
  },
  Norristone: {
    en: "Norristone",
    es: "Norristone",
    fr: "Norristone",
  },
  Station: {
    en: "Station",
    es: "Estación",
    fr: "Station",
  },
  Assets: {
    en: "Assets",
    es: "Bienes",
    fr: "Les atouts",
  },
  id: {
    en: "id",
    es: "identificacion",
    fr: "id",
  },
  Actions: {
    en: "Actions",
    es: "Acciones",
    fr: "Actions",
  },
  trackType: {
    en: "trackType",
    es: "tipo de pista",
    fr: "trackType",
  },
  class: {
    en: "class",
    es: "clase",
    fr: "classe",
  },
  trackNumber: {
    en: "trackNumber",
    es: "número de pista",
    fr: "numéro de piste",
  },
  Company: {
    en: "Company",
    es: "Empresa",
    fr: "Compagnie",
  },
  Contact: {
    en: "Contact",
    es: "Contacto",
    fr: "Contact",
  },
  Templates: {
    en: "Templates",
    es: "Plantilla",
    fr: "Modèles",
  },
  Zone: {
    en: "Zone",
    es: "zona",
    fr: "Zone",
  },
  Foul: {
    en: "Foul",
    es: "Ocupar",
    fr: "Faute",
  },
  Inspector: {
    en: "Inspector",
    es: "Inspector",
    fr: "Inspecteur",
  },
  Total: {
    en: "Total",
    es: "Total",
    fr: "Le total",
  },
  Watchmen: {
    en: "Watchmen",
    es: "Vigilantes",
    fr: "Gardiens",
  },
  Last: {
    en: "Last",
    es: "Última",
    fr: "Dernier",
  },
  Next: {
    en: "Next",
    es: "Siguiente",
    fr: "Suivant",
  },
  Special: {
    en: "Special",
    es: "Especial",
    fr: "Spécial",
  },
  Generic: {
    en: "Generic",
    es: "Genérico",
    fr: "Générique",
  },
  "Staff List": {
    en: "Staff List",
    es: "lista de personal",
    fr: "Liste du personnel",
  },
  Setup: {
    en: "Setup",
    es: "Preparar",
    fr: "Installer",
  },
  password: {
    en: "password",
    es: "Contraseña",
    fr: "mot de passe",
  },
  Group: {
    en: "Group",
    es: "Grupo",
    fr: "Groupe",
  },
  Departments: {
    en: "Departments",
    es: "Departamentos",
    fr: "Départements",
  },
  Subdivision: {
    en: "Subdivision",
    es: "Subdivisión",
    fr: "Subdivision",
  },
  Submit: {
    en: "Submit",
    es: "Enviar",
    fr: "Soumettre",
  },
  Email: {
    en: "Email",
    es: "Email",
    fr: "Email",
  },
  email: {
    en: "Email",
    es: "Email",
    fr: "Email",
  },
  Maintenance: {
    en: "Maintenance",
    es: "Mantenimiento",
    fr: "Entretien",
  },
  Work: {
    en: "Work",
    es: "trabajo",
    fr: "Travail",
  },
  Order: {
    en: "Order",
    es: "orden",
    fr: "Commande",
  },
  Due: {
    en: "Due",
    es: "Debido",
    fr: "Dû",
  },
  Created: {
    en: "Created",
    es: "Creado",
    fr: "Créé",
  },
  Plan: {
    en: "Plan",
    es: "plan",
    fr: "Plan",
  },
  Execution: {
    en: "Execution",
    es: "Ejecución",
    fr: "Exécution",
  },
  Action: {
    en: "Action",
    es: "Accion",
    fr: "Action",
  },
  Summary: {
    en: "Summary",
    es: "Resumen",
    fr: "Résumé",
  },
  Heading: {
    en: "Heading",
    es: "encabezado",
    fr: "Titre",
  },
  Planned: {
    en: " Planned",
    es: "Planeado",
    fr: " Prévu",
  },
  Pending: {
    en: "Pending",
    es: "Cerrado",
    fr: "En attente",
  },
  Closed: {
    en: "Closed",
    es: "Cerrado",
    fr: "Fermé",
  },
  Name: {
    en: "Name",
    es: "Nombre",
    fr: "Nom",
  },
  "Issues Summary": {
    en: "Issues Summary",
    es: "Resumen de problemas",
    fr: "Résumé des problèmes",
  },
  "Inspections Summary": {
    en: "Inspections Summary",
    es: "Resumen de inspecciones",
    fr: "Résumé des inspections",
  },
  "Issues Reported": {
    en: "Issues Reported",
    es: "Problemas reportados",
    fr: "Problèmes signalés",
  },
  "Total Issues": {
    en: "Total Issues",
    es: "Total de problemas",
    fr: "Nombre total de problèmes",
  },
  "Low Priority": {
    en: "Low Priority",
    es: "Baja prioridad",
    fr: "Priorité basse",
  },
  "Medium Priority": {
    en: "Medium Priority",
    es: "Prioridad media",
    fr: "Priorité moyenne",
  },
  "High Priority": {
    en: "High Priority",
    es: "Alta prioridad",
    fr: "Haute priorité",
  },
  "Marked On Site": {
    en: "Marked On Site",
    es: "Marcado en el sitio",
    fr: "Marqué sur place",
  },
  "Total Inspections": {
    en: "Total Inspections",
    es: "Total inspecciones",
    fr: "Inspections totales",
  },
  "Not Started": {
    en: "Not Started",
    es: "No empezado",
    fr: "Pas commencé",
  },
  "Inspection Run Name": {
    en: "Inspection Run Name",
    es: "Nombre de inspección",
    fr: "Nom du cycle d'inspection",
  },
  "Start Time": {
    en: "Start Time",
    es: "Hora de inicio",
    fr: "Heure de début",
  },
  "Finish Time": {
    en: "Finish Time",
    es: "Hora de terminó",
    fr: "Heure de fin",
  },
  "In Progress": {
    en: "In Progress",
    es: "En progreso",
    fr: "En cours",
  },
  "Track ID": {
    en: "Track ID",
    es: "Número de vía",
    fr: "ID de piste",
  },
  Audio: {
    en: "Audio",
    es: "Audio",
    fr: "l'audio",
  },
  Description: {
    en: "Description",
    es: "Descripción",
    fr: "La description",
  },
  "Maintenance Summary": {
    en: "Maintenance Summary",
    es: "Resumen de mantenimiento",
    fr: "Résumé de la maintenance",
  },
  "Maintenance Request": {
    en: "Maintenance Request",
    es: "Peticion de mantenimiento",
    fr: "Demande d'entretien",
  },
  "Not Planned": {
    en: "Not Planned",
    es: "No estaba planeado",
    fr: "Pas prévu",
  },
  "Date Created": {
    en: "Date Created",
    es: "Fecha de creación",
    fr: "date créée",
  },
  "Plan Date": {
    en: "Plan Date",
    es: "Fecha del plan",
    fr: "Date du plan",
  },
  "Execution Date": {
    en: "Execution Date",
    es: "Fecha ejecución",
    fr: "Date d'éxecution",
  },
  "Date Closed": {
    en: "Date Closed",
    es: "Fecha de cierre",
    fr: "Date de fermeture",
  },
  "Asset Id": {
    en: "Asset Id",
    es: "Identificación del activo",
    fr: "ID d'élément",
  },
  "Fix Type": {
    en: "Fix Type",
    es: "Tipo de arreglo",
    fr: "Type de correction",
  },
  "Fix Images": {
    en: "Fix Images",
    es: "Reparar Imágenes",
    fr: "Corriger les images",
  },
  "Safety Briefing": {
    en: "Safety Briefing",
    es: "Instrucción de seguridad",
    fr: "Briefing de sécurité",
  },
  Safety: {
    en: "Safety",
    es: "La seguridad",
    fr: "sécurité",
  },
  "Asset Id ": {
    en: "Asset Id",
    es: "Identificación del activo",
    fr: "ID d'élément",
  },
  "Start (milepost)": {
    en: "Start (milepost)",
    es: "Comienzo (placa kilométrica)",
    fr: "Début (milepost)",
  },
  "End (milepost)": {
    en: "End (milepost)",
    es: "Fin (placa kilométrica)",
    fr: "Fin (milepost)",
  },
  "Length (milepost)": {
    en: "Length (milepost)",
    es: "Longitud (placa kilométrica)",
    fr: "Longueur (milepost)",
  },
  Runs: {
    en: "Runs",
    es: "Carreras",
    fr: "Tournées",
  },
  Run: {
    en: "Run",
    es: "correr",
    fr: "Tourner",
  },
  Staff: {
    en: "Staff",
    es: "Personal",
    fr: "Personnel",
  },
  Team: {
    en: "Team",
    es: "Equipo",
    fr: "Équipe",
  },
  "Inspection Run Planning": {
    en: "Inspection Run Planning",
    es: "Plan de inspección",
    fr: "Planification des cycles d'inspection",
  },
  "Company Name": {
    en: "Company Name",
    es: "Nombre de empresa",
    fr: "Nom de la compagnie",
  },
  "Contact Email": {
    en: "Contact Email",
    es: "Correo de contacto",
    fr: "Email du contact",
  },
  "Inspection Run Summary": {
    en: "Inspection Run Summary",
    es: "Resumen de la ejecución de la inspección",
    fr: "Résumé du cycle d'inspection",
  },
  "Inspection Run Plans": {
    en: "Inspection Run Plans",
    es: "Planes de ejecución de inspección",
    fr: "Plans d'exécution d'inspection",
  },
  "Inspection Plan": {
    en: "Inspection Plan",
    es: "Plan de inspección",
    fr: "Plan d'inspection",
  },
  "Add Plan": {
    en: "Add Plan",
    es: "Añadir plan",
    fr: "Ajouter un plan",
  },
  "Total Templates": {
    en: "Total Templates",
    es: "Plantillas totales",
    fr: "Total des modèles",
  },
  "Crew Groups": {
    en: "Crew Groups",
    es: "Grupos de tripulación",
    fr: "Groupes d'équipage",
  },
  "Road Masters": {
    en: "Road Masters",
    es: "Road Masters",
    fr: "Maîtres de la route",
  },
  "Staff Profile": {
    en: "Staff Profile",
    es: "Perfil del personal",
    fr: "Profil du personnel",
  },
  "Add New Staff": {
    en: "Add New Staff",
    es: "Añadir nuevo personal",
    fr: "Ajouter un nouveau personnel",
  },
  "Generic Email": {
    en: "Generic Email",
    es: "Correo genérico",
    fr: "Courriel générique",
  },
  Phone: {
    en: "Phone",
    es: "Teléfono",
    fr: "Téléphone",
  },
  Mobile: {
    en: "Mobile",
    es: "teléfono celular",
    fr: "Mobile",
  },
  "Confirm Password": {
    en: "Confirm Password",
    es: "Confirmar contraseña",
    fr: "Confirmez le mot de passe",
  },
  "Add Run": {
    en: "Add Run",
    es: "Añadir Run",
    fr: "Ajouter une course",
  },
  "Run ID": {
    en: "Run ID",
    es: "ID de ejecución",
    fr: "ID d'exécution",
  },
  "Run Name": {
    en: "Run Name",
    es: "Nombre de ejecución",
    fr: "Nom de la course",
  },
  "Add Asset": {
    en: "Add Asset",
    es: "Añadir activo",
    fr: "Ajouter un élément",
  },
  "Add Inspection": {
    en: "Add Inspection",
    es: "Añadir Plan de inspección",
    fr: "Ajouter une inspection",
  },
  "Update Inspection": {
    en: "Update Inspection",
    es: "Plan de trabajo de actualización",
    fr: "Inspection des mises à jour",
  },
  Update: {
    en: "Update",
    es: "Actualizar",
    fr: "Mise à jour",
  },
  "Day Of Week / Year": {
    en: "Day Of Week / Year",
    es: "Día de la semana / año",
    fr: "Jour de la semaine / année",
  },
  Title: {
    en: "Title",
    es: "Título",
    fr: "Titre",
  },
  Close: {
    en: "Close",
    es: "Cerrar",
    fr: "proche",
  },
  "Add New Run": {
    en: "Add New Run",
    es: "Añadir nuevo del funcionamiento",
    fr: "Ajouter une nouvelle course",
  },
  "Edit Run": {
    en: "Edit Run",
    es: "Ejecutar",
    fr: "Modifier l'exécution",
  },
  "Set Password": {
    en: "Set Password",
    es: "Configurar la clave",
    fr: "Définir le mot de passe",
  },
  "Hide Password": {
    en: "Hide Password",
    es: "Contraseña oculta",
    fr: "Masquer le mot de passe",
  },
  "Add New Asset": {
    en: "Add New Asset",
    es: "Añadir nuevo activo",
    fr: "Ajouter un nouvel élément",
  },
  "Edit Asset": {
    en: "Edit Asset",
    es: "Editar Activo",
    fr: "Modifier l'élément",
  },
  "Asset Attributes": {
    en: "Asset Attributes",
    es: "Atributos de los activos",
    fr: "Attributs des actifs",
  },
  "Manage Equipments": {
    en: "Manage Equipments",
    es: "Administrar Equipos",
    fr: "Gérer les équipements",
  },
  "Manage Relays": {
    en: "Manage Relays",
    es: "Administrar retransmisiones",
    fr: "Gérer les relais",
  },
  Login: {
    en: "Log in",
    es: "Iniciar Sesión",
    fr: "S'identifier",
  },
  LOGIN: {
    en: "LOGIN",
    es: "Niciar sesión",
    fr: "S'identifier",
  },
  "Sign in": {
    en: "Sign in",
    es: "Registrarse",
    fr: "se connecter",
  },
  Proceed: {
    en: "Proceed",
    es: "Continuar",
    fr: "Procéder",
  },
  "This email address is invalid": {
    en: "This email address is invalid",
    es: "Esta dirección de correo electrónico no es válida.",
    fr: "Cette adresse e-mail n'est pas valide",
  },
  "Log Out": {
    en: "Log Out",
    es: "Cerrar sesión",
    fr: "Se déconnecter",
  },
  "Select Date(s)": {
    en: "Select Date(s)",
    es: "Seleccionar fecha (s)",
    fr: "Sélectionnez la (les) date (s)",
  },
  Reset: {
    en: "Reset",
    es: "Reiniciar",
    fr: "Réinitialiser",
  },
  Cancel: {
    en: "Cancel",
    es: "Cancelar",
    fr: "Annuler",
  },
  Ok: {
    en: "Ok",
    es: "Aceptar",
    fr: "D'accord",
  },
  "Work Zone": {
    en: "Work Zone",
    es: "Zona de trabajo",
    fr: "Zone de travail",
  },
  "Foul Time": {
    en: "Foul Time",
    es: "Tiempo de falta",
    fr: "Mauvais temps",
  },
  View: {
    en: "View",
    es: "Ver",
    fr: "Vue",
  },
  "MP Start": {
    en: "MP Start",
    es: "MP Comenzar",
    fr: "Début MP",
  },
  "MP End": {
    en: "MP End",
    es: "MP Final",
    fr: "Fin MP",
  },
  "Run Description": {
    en: "Run Description",
    es: "Ejecutar Descripción",
    fr: "Description de l'exécution",
  },
  "Run/Range": {
    en: "Run/Range",
    es: "Ejecutar / Rango",
    fr: "Course/Plage",
  },
  "Add Range": {
    en: "Add Range",
    es: "Agregar rango",
    fr: "Ajouter une plage",
  },
  "Add New Run Range": {
    en: "Add New Run Range",
    es: "Agregar nuevo rango de ejecución",
    fr: "Ajouter une nouvelle plage de tir",
  },
  "Edit Run Range": {
    en: "Edit Run Range",
    es: "Editar rango de ejecución",
    fr: "Modifier la plage de tir",
  },
  "Station Start": {
    en: "Station Start",
    es: "Inicio de estacion",
    fr: "Début de la station",
  },
  "Station End": {
    en: "Station End",
    es: "Fin de estacion",
    fr: "Fin de la station",
  },
  Tracks: {
    en: "Tracks",
    es: "Vía",
    fr: "Des pistes",
  },
  "Select Line": {
    en: "Select Line",
    es: "Seleccionar linea",
    fr: "Sélectionnez une ligne",
  },
  "Available Inspectors": {
    en: "Available Inspectors",
    es: "Inspectores disponibles",
    fr: "Inspecteurs disponibles",
  },
  Confirm: {
    en: "Confirm",
    es: "Confirmar",
    fr: "Confirmer",
  },
  Remove: {
    en: "Remove",
    es: "Retirar",
    fr: "Retirer",
  },
  Monday: {
    en: "Monday",
    es: "Lunes",
    fr: "Lundi",
  },
  Tuesday: {
    en: "Tuesday",
    es: "Martes",
    fr: "Mardi",
  },
  Wednesday: {
    en: "Wednesday",
    es: "Miércoles",
    fr: "Mercredi",
  },
  Thursday: {
    en: "Thursday",
    es: "Jueves",
    fr: "Jeudi",
  },
  Friday: {
    en: "Friday",
    es: "Viernes",
    fr: "Vendredi",
  },
  Saturday: {
    en: "Saturday",
    es: "Sábado",
    fr: "samedi",
  },
  Sunday: {
    en: "Sunday",
    es: "Domingo",
    fr: "dimanche",
  },
  "Last Inspection": {
    en: "Last Inspection",
    es: "Última inspección",
    fr: "Dernière inspection",
  },
  "Next Inspection": {
    en: "Next Inspection",
    es: "Próxima inspección",
    fr: "Prochaine inspection",
  },
  "Inspection Run Plan Detail": {
    en: "Inspection Run Plan Detail",
    es: "Detalle del plan de ejecución de inspección",
    fr: "Détail du plan d'exécution d'inspection",
  },
  "Task List": {
    en: "Task List",
    es: "Lista de tareas",
    fr: "Liste de tâches",
  },
  Task: {
    en: "Task",
    es: "Tarea",
    fr: "Tâche",
  },
  "Add Special Task": {
    en: "Add Special Task",
    es: "Añadir tarea especial",
    fr: "Ajouter une tâche spéciale",
  },
  "Edit Task": {
    en: "Edit Task",
    es: "Editar tarea",
    fr: "Modifier la tâche",
  },
  Notes: {
    en: "Notes",
    es: "Notas",
    fr: "Remarques",
  },
  Image: {
    en: "Image",
    es: "Imagen",
    fr: "Image",
  },
  "Select Existing Images": {
    en: "Select Existing Images",
    es: "Seleccione las imágenes existentes",
    fr: "Sélectionnez les images existantes",
  },
  Location: {
    en: "Location",
    es: "Ubicación",
    fr: "Emplacement",
  },
  "Asset Type": {
    en: "Asset Type",
    es: "Tipo de activo",
    fr: "Type d'actif",
  },
  "Location Latitude": {
    en: "Location Latitude",
    es: "Latitud de ubicación",
    fr: "Latitude de l'emplacement",
  },
  "Maintenance Detail": {
    en: "Maintenance Detail",
    es: "Detalle de mantenimiento",
    fr: "Détail de la maintenance",
  },
  "Maintenance Work Order": {
    en: "Maintenance Work Order",
    es: "De orden de trabajo de mantenimiento",
    fr: "Bon de travail de maintenance",
  },
  "Created at": {
    en: "Created at",
    es: "Creado en",
    fr: "Créé à",
  },
  "Created by": {
    en: "Created by",
    es: "Creado por",
    fr: "Créé par",
  },
  Source: {
    en: "Source",
    es: "Fuente",
    fr: "La source",
  },
  "Assigned To": {
    en: "Assigned To",
    es: "Asignado a",
    fr: "Assigné à",
  },
  "Work Order": {
    en: "Work Order",
    es: "Orden de trabajo",
    fr: "Demande de service",
  },
  "Work Order Tab": {
    en: "Work Order",
    es: "Orden de trabajo",
    fr: "Demande de service",
  },
  "Closed date": {
    en: "Closed date",
    es: "Fecha cerrada",
    fr: "Date de fermeture",
  },
  "Maintenance Estimate": {
    en: "Maintenance Estimate",
    es: "Estimado de mantenimiento",
    fr: "Estimation de la maintenance",
  },
  LABOR: {
    en: "LABOR",
    es: "LABOR",
    fr: "LA MAIN D'OEUVRE",
  },
  "Required Crew Skill": {
    en: "Required Crew Skill",
    es: "Habilidad de tripulación requerida",
    fr: "Compétence requise pour l'équipage",
  },
  CREW: {
    en: "CREW",
    es: "PERSONAL",
    fr: "ÉQUIPAGE",
  },
  "Please enter valid email address": {
    en: "Please enter valid email address",
    es: "Por favor ingrese una dirección de correo electrónico válida",
    fr: "Veuillez saisir une adresse e-mail valide",
  },
  "Password Required": {
    en: "Password Required",
    es: "Se requiere contraseña",
    fr: "Mot de passe requis",
  },
  "Work Plan": {
    en: "Work Plan",
    es: "El plan de trabajo",
    fr: "Plan de travail",
  },
  Tasks: {
    en: "Tasks",
    es: "Tareas",
    fr: "Tâches",
  },
  "Problem connecting to server": {
    en: "Problem connecting to server",
    es: "Problema al conectarse al servidor",
    fr: "Problème de connexion au serveur",
  },
  "Failed to Create User !": {
    en: "Failed to Create User !",
    es: "Error al crear el usuario!",
    fr: "Échec de la création de l'utilisateur!",
  },
  Error: {
    en: "Error",
    es: "Error",
    fr: "Erreur",
  },
  "Failed to Delete User!": {
    en: "Failed to Delete User!",
    es: "Error al eliminar el usuario!",
    fr: "Échec de la suppression de l'utilisateur!",
  },
  "Unable to checkout before 1m": {
    en: "Unable to checkout before 1m",
    es: "No se puede pagar antes de 1m",
    fr: "Impossible de passer à la caisse avant 1 m",
  },
  "Please Wait ": {
    en: "Please Wait ",
    es: "Por favor espera ",
    fr: "S'il vous plaît, attendez ",
  },
  "Track Assets": {
    en: "Track Assets",
    es: "Seguimiento de los activos",
    fr: "Suivre les actifs",
  },
  "Inspection Created Successfully !": {
    en: "Inspection Created Successfully !",
    es: "Plan de trabajo creado con éxito!",
    fr: "Inspection créée avec succès!",
  },
  "Inspection Deleted Successfully !": {
    en: "Inspection Deleted Successfully !",
    es: "Plan de trabajo eliminado con éxito!",
    fr: "Inspection supprimée avec succès!",
  },
  "Inspection Updated Successfully !": {
    en: "Inspection Updated Successfully !",
    es: "Plan de trabajo actualizado con éxito!",
    fr: "Inspection mise à jour avec succès!",
  },
  "Task Updated Successfully!": {
    en: "Task Updated Successfully!",
    es: "Tarea actualizada con éxito!",
    fr: "Tâche mise à jour avec succès!",
  },
  "Task Created Successfully!": {
    en: "Task Created Successfully!",
    es: "Tarea creada con éxito!",
    fr: "Tâche créée avec succès!",
  },
  "Task Deleted Successfully": {
    en: "Task Deleted Successfully",
    es: "Tarea eliminada con éxito",
    fr: "Tâche supprimée avec succès",
  },
  "User Updated Successfully !": {
    en: "User Updated Successfully!",
    es: "Usuario Creado con Éxito",
    fr: "Utilisateur mis à jour avec succès!",
  },
  "User Deleted Successfully  !": {
    en: "User Deleted Successfully !",
    es: "Contraseña Actualizada",
    fr: "L'utilisateur a bien été supprimé!",
  },
  "User Created Successfully !": {
    en: "User Created Successfully !",
    es: "¡Usuario creado correctamente!",
    fr: "L'utilisateur a été créé avec succès!",
  },
  "Password Updated !": {
    en: "Password Updated !",
    es: "Contraseña actualiza !",
    fr: "Mot de passe mis à jour !",
  },
  "User Created Successfully !": {
    en: "User Created Successfully !",
    es: "Usuario creado con éxito!",
    fr: "L'utilisateur a été créé avec succès!",
  },
  "Track Added Successfully !": {
    en: "Track Added Successfully !",
    es: "La pista se ha añadido correctamente!",
    fr: "Piste ajoutée avec succès!",
  },
  "Track Deleted Successfully !": {
    en: "Track Deleted Successfully !",
    es: "Pista eliminada con éxito!",
    fr: "Piste supprimée avec succès!",
  },
  "Track Updated Successfully !": {
    en: "Track Updated Successfully !",
    es: "Seguimiento actualizado con éxito!",
    fr: "Suivi mis à jour avec succès!",
  },
  "Track Assets Updated Successfully!": {
    en: "Track Assets Updated Successfully!",
    es: "Seguimiento de los activos actualizados con éxito!",
    fr: "Suivi des actifs mis à jour avec succès!",
  },
  "User Availability": {
    en: "User Availability",
    es: "Disponibilidad del usuario",
    fr: "Disponibilité des utilisateurs",
  },
  "Add Break!": {
    en: "Add Break!",
    es: "Añadir Break!",
    fr: "Ajoutez une pause!",
  },
  "Please provide mobile": {
    en: "Please provide mobile",
    es: "Por favor proporcione móvil",
    fr: "Veuillez fournir un mobile",
  },
  "Please enter complete mobile number": {
    en: "Please enter complete mobile number.",
    es: "Editar Mantenimiento",
    fr: "Veuillez saisir le numéro de portable complet.",
  },
  "Add New Maintenance": {
    en: "Add New Maintenance",
    es: "Agregar nuevo mantenimiento",
    fr: "Ajouter une nouvelle maintenance",
  },
  "Edit Maintenance": {
    en: "Edit Maintenance",
    es: "Editar mantenimiento",
    fr: "Modifier la maintenance",
  },
  "Maintenance Attributes": {
    en: "Maintenance Attributes",
    es: "Atributos de mantenimiento",
    fr: "Attributs de maintenance",
  },
  "Due Date": {
    en: "Due Date",
    es: "Fecha de vencimiento",
    fr: "Date d'échéance",
  },
  Latitude: {
    en: "Latitude",
    es: "Latitud",
    fr: "Latitude",
  },
  Longitude: {
    en: "Longitude",
    es: "Longitud",
    fr: "Longitude",
  },
  "Location Longitude": {
    en: "Location Longitude",
    es: "Longitud de ubicación",
    fr: "Localisation Longitude",
  },
  "GPS Latitude": {
    en: "GPS Latitude",
    es: "GPS Latitud",
    fr: "Latitude GPS",
  },
  "GPS Longitude": {
    en: "GPS Longitude",
    es: "Longitud GPS",
    fr: "Longitude GPS",
  },
  Milepost: {
    en: "Milepost",
    es: "Mojón",
    fr: "Millage",
  },
  "Location Attributes": {
    en: "Location Attributes",
    es: "Atributos de ubicación",
    fr: "Attributs d'emplacement",
  },
  "Future Inspection": {
    en: "Upcoming",
    es: "Próximo",
    fr: "A venir",
  },
  "Mark Work Order Complete": {
    en: "Mark Work Order Complete",
    es: "Marcar orden de trabajo completada",
    fr: "Marquer l'ordre de travail comme terminé",
  },
  "Add Work Order": {
    en: "Add Work Order",
    es: "Añadir",
    fr: "Ajouter un bon de travail",
  },
  "Work Orders": {
    en: "Work Orders",
    es: "Órdenes de trabajo",
    fr: "Bons de travail",
  },
  "Run List": {
    en: "Run List",
    es: "Lista de ejecución",
    fr: "Liste des courses",
  },
  "Select Close Date For Work Order": {
    en: "Select Close Date For Work Order",
    es: "Seleccione la fecha de cierre de la orden de trabajo",
    fr: "Sélectionnez la date de clôture pour l'ordre de travail",
  },
  "to work orders": {
    en: "to work orders",
    es: "a la orden de trabajo",
    fr: "aux bons de travail",
  },
  "Tasks List": {
    en: "Tasks List",
    es: "Lista de tareas",
    fr: "Liste des tâches",
  },
  "Inspection Detail": {
    en: "Inspection Detail",
    es: "Detalle de inspección",
    fr: "Détail d'inspection",
  },
  "Asset ID": {
    en: "Asset ID",
    es: "ID de activo",
    fr: "ID d'élément",
  },
  "Locations Issue Overview": {
    en: "Locations Issue Overview",
    es: "Descripción general del problema de ubicaciones",
    fr: "Présentation des problèmes liés aux emplacements",
  },
  "Locations Inspection Overview": {
    en: "Locations Inspection Overview",
    es: "Descripción general de la inspección de ubicaciones",
    fr: "Aperçu de l'inspection des emplacements",
  },
  "Last Inspection Date": {
    en: "Last Inspection Date",
    es: "Fecha de última inspección",
    fr: "Date de la dernière inspection",
  },
  Overdue: {
    en: "Overdue",
    es: "Atrasada",
    fr: "En retard",
  },
  Missed: {
    en: "Missed",
    es: "Perdido",
    fr: "Manqué",
  },
  Multiple: {
    en: "Multiple",
    es: "Múltiple",
    fr: "Plusieurs",
  },
  Sun: {
    en: "Sun",
    es: "dom",
    fr: "Soleil",
  },
  Mon: {
    en: "Mon",
    es: "lun",
    fr: "lun",
  },
  Tue: {
    en: "Tue",
    es: "mar",
    fr: "Mar",
  },
  Wed: {
    en: "Wed",
    es: "mié",
    fr: "mer",
  },
  Thu: {
    en: "Thu",
    es: "jue",
    fr: "jeu",
  },
  Fri: {
    en: "Fri",
    es: "vie",
    fr: "ven",
  },
  Sat: {
    en: "Sat",
    es: "sáb",
    fr: "Sam",
  },
  List: {
    en: "List",
    es: "Lista",
    fr: "liste",
  },
  Calendar: {
    en: "Calendar",
    es: "Calendario",
    fr: "Calendrier",
  },
  January: {
    en: "January",
    es: "enero",
    fr: "janvier",
  },
  February: {
    en: "February",
    es: "febrero",
    fr: "février",
  },
  March: {
    en: "March",
    es: "marzo",
    fr: "Mars",
  },
  April: {
    en: "April",
    es: "abril",
    fr: "avril",
  },
  May: {
    en: "May",
    es: "Mayo",
    fr: "Peut",
  },
  June: {
    en: "June",
    es: "junio",
    fr: "juin",
  },
  July: {
    en: "July",
    es: "julio",
    fr: "juillet",
  },
  August: {
    en: "August",
    es: "agosto",
    fr: "août",
  },
  September: {
    en: "September",
    es: "septiembre",
    fr: "septembre",
  },
  October: {
    en: "October",
    es: "octubre",
    fr: "octobre",
  },
  November: {
    en: "November",
    es: "noviembre",
    fr: "novembre",
  },
  December: {
    en: "December",
    es: "diciembre",
    fr: "décembre",
  },
  "Add Task": {
    en: "Add Task",
    es: "Agregar tarea",
    fr: "Ajouter une tâche",
  },
  Forms: {
    en: "Forms",
    es: "Formas",
    fr: "Formulaire",
  },
  Units: {
    en: "Units",
    es: "Unidades",
    fr: "Unités",
  },
  "End Time": {
    en: "End Time",
    es: "Hora de finalización",
    fr: "Heure de fin",
  },
  "Asset Name": {
    en: "Asset Name",
    es: "Nombre de activo",
    fr: "Nom de l'élément",
  },
  "Please provide": {
    en: "Please provide",
    es: "Por favor proporcione",
    fr: "Veuillez fournir",
  },
  "Please provide Notes": {
    en: "Please provide Notes",
    es: "Por favor proporcione notas",
    fr: "Veuillez fournir des notes",
  },
  "Please provide Description": {
    en: "Please provide Description",
    es: "Por favor proporcione Descripción",
    fr: "Veuillez fournir une description",
  },
  "Upload New File": {
    en: "Upload New File",
    es: "Subir nuevo archivo",
    fr: "Télécharger un nouveau fichier",
  },
  "Select Location": {
    en: "Select Location",
    es: "Seleccionar ubicación",
    fr: "Sélectionnez l'emplacement",
  },
  "Work Location": {
    en: "Work Location",
    es: "Ubicación de trabajo",
    fr: "Lieu de travail",
  },
  "Rotate anti-clockwise": {
    en: "Rotate anti-clockwise",
    es: "Girar en sentido antihorario",
    fr: "Tourner dans le sens anti-horaire",
  },
  "Rotate clockwise": {
    en: "Rotate clockwise",
    es: "Rotar las agujas del reloj",
    fr: "Le sens des aiguilles d'une montre",
  },
  "Assets List View": {
    en: "Assets List View",
    es: "Vista de lista de activos",
    fr: "Affichage de la liste des actifs",
  },
  "Please Select at least one Asset": {
    en: "Please Select at least one Asset",
    es: "Seleccione al menos un activo",
    fr: "Veuillez sélectionner au moins un élément",
  },
  "No Form Exist": {
    en: "No Form Exist",
    es: "No existe forma",
    fr: "Aucune forme n'existe",
  },
  "Date and Time": {
    en: "Date and Time",
    es: "Fecha y hora",
    fr: "Date et l'heure",
  },
  "Description of Work Assignment": {
    en: "Description of Work Assignment",
    es: "Descripción de la asignación de trabajo",
    fr: "Description de l'affectation des travaux",
  },
  next: {
    en: "Next",
    es: "Siguiente",
    fr: "Prochain",
  },
  previous: {
    en: "Previous",
    es: "Anterior",
    fr: "Précédent",
  },
  Previous: {
    en: "Previous",
    es: "Anterior",
    fr: "Précédent",
  },
  prev: {
    en: "Previous",
    es: "Anterior",
    fr: "Précédent",
  },
  Page: {
    en: "Page",
    es: "Página",
    fr: "Page",
  },
  of: {
    en: "of",
    es: "de",
    fr: "de",
  },
  rows: {
    en: "rows",
    es: "filas",
    fr: "Lignes",
  },
  "No rows found": {
    en: "No rows found",
    es: "No se encontraron filas",
    fr: "Aucune ligne trouvée",
  },
  "jump to page": {
    en: "jump to page",
    es: "saltar a la página",
    fr: "aller à la page",
  },
  "rows per page": {
    en: "rows per page",
    es: "saltar a la página",
    fr: "lignes par page",
  },
  "Loading...": {
    en: "Loading...",
    es: "Cargando...",
    fr: "Chargement...",
  },
  "Fixed On Site": {
    en: "Fixed On Site",
    es: "Fijo en el sitio",
    fr: "Fixé sur place",
  },
  Select: {
    en: "Select",
    es: "Seleccione",
    fr: "Sélectionner",
  },
  Selected: {
    en: "Selected",
    es: "Seleccionada",
    fr: "Choisi",
  },
  Upcoming: {
    en: "Upcoming",
    es: "Próxima",
    fr: "A venir",
  },
  Fixed: {
    en: "Fixed",
    es: "Fija",
    fr: "Fixé",
  },
  Open: {
    en: "Open",
    es: "Abierto",
    fr: "Ouvert",
  },
  Detail: {
    en: "Detail",
    es: "Detalle",
    fr: "Détail",
  },
  Reason: {
    en: "Reason",
    es: "Razón",
    fr: "Raison",
  },
  Normal: {
    en: "Normal",
    es: "Normal",
    fr: "Ordinaire",
  },
  Planning: {
    en: "Planning",
    es: "Planificación",
    fr: "Planification",
  },
  Documents: {
    en: "Documents",
    es: "Documentos",
    fr: "Des documents",
  },
  Upload: {
    en: "Upload",
    es: "Subir",
    fr: "Télécharger",
  },
  Attributes: {
    en: "Attributes",
    es: "Atributos",
    fr: "Les attributs",
  },
  Rotate: {
    en: "Rotate",
    es: "Girar",
    fr: "Tourner",
  },
  clockwise: {
    en: "clockwise",
    es: "agujas del reloj",
    fr: "sens horaire",
  },
  "anti clockwise": {
    en: "anti clockwise",
    es: "antihorario",
    fr: "anti-horaire",
  },
  "In progress": {
    en: "In progress",
    es: "En progreso",
    fr: "En cours",
  },
  "View Detail": {
    en: "View Detail",
    es: "Ver Detalle",
    fr: "Voir les détails",
  },
  "Fixed on Site": {
    en: "Fixed on Site",
    es: "Fijo en el sitio",
    fr: "Fixé sur site",
  },
  "Create MR": {
    en: "Create MR",
    es: "Crear MR",
    fr: "Créer MR",
  },
  "Enter Description": {
    en: "Enter Description",
    es: "Ingrese la descripción",
    fr: "Entrez la description",
  },
  "Maintenance Type": {
    en: "Maintenance Type",
    es: "Tipo de mantenimiento",
    fr: "Type d'entretien",
  },
  "Track Chart": {
    en: "Track Chart",
    es: "Gráfico de seguimiento",
    fr: "Graphique de suivi",
  },
  "Created By": {
    en: "Created By",
    es: "Creado por",
    fr: "Créé par",
  },
  "Closed Date": {
    en: "Closed Date",
    es: "Fecha de cierre",
    fr: "Date de fermeture",
  },
  "Add Maintenance Work Order": {
    en: "Add Maintenance Work Order",
    es: "Agregar orden de trabajo de mantenimiento",
    fr: "Ajouter un ordre de travail de maintenance",
  },
  "Edit Maintenance Work Order": {
    en: "Edit Maintenance Work Order",
    es: "Editar orden de trabajo de mantenimiento",
    fr: "Modifier l'ordre de travail de maintenance",
  },
  "Add Maintenance Requests": {
    en: "Add Maintenance Requests",
    es: "Agregar solicitudes de mantenimiento",
    fr: "Ajouter des demandes de maintenance",
  },
  "Work Order No": {
    en: "Work Order No",
    es: "Orden de trabajo no",
    fr: "Bon de travail No",
  },
  "No Option Selected": {
    en: "No Option Selected",
    es: "Ninguna opción seleccionada",
    fr: "Aucune option sélectionnée",
  },
  "Confirm Deletion": {
    en: "Confirm Deletion",
    es: "Confirmar la eliminación",
    fr: "Confirmer la suppression",
  },
  "Old data": {
    en: "Old data",
    es: "Datos antiguos",
    fr: "Anciennes données",
  },
  "Previous Data": {
    en: "Previous Data",
    es: "Datos anteriores",
    fr: "Données précédentes",
  },
  "Deleted Data": {
    en: "Deleted Data",
    es: "Datos eliminados",
    fr: "Données supprimées",
  },
  "Updated Data": {
    en: "Updated Data",
    es: "Datos actualizados",
    fr: "Données mises à jour",
  },
  "Estimate History": {
    en: "Estimate History",
    es: "Historia estimada",
    fr: "Estimer l'historique",
  },
  "Add Maintenance Work To add this Maintenance Plan to a new Work Order, click + icon on the right, OR to add this to an existing Work Order for":
    {
      en: "Add Maintenance Work To add this Maintenance Plan to a new Work Order, click + icon on the right, OR to add this to an existing Work Order for",
      es: "Agregar trabajo de mantenimiento Para agregar este plan de mantenimiento a una nueva orden de trabajo, haga clic en el ícono + a la derecha, O para agregarlo a una orden de trabajo existente para",
      fr: "Ajouter des travaux de maintenance Pour ajouter ce plan de maintenance à un nouvel ordre de travail, cliquez sur l'icône + à droite, OU pour l'ajouter à un ordre de travail existant pour",
    },
  "click on 'Select' link under 'Actions' column below OR press 'Cancel' to go back": {
    en: "click on 'Select' link under 'Actions' column below OR press 'Cancel' to go back",
    es: "haga clic en el enlace 'Seleccionar' en la columna 'Acciones' a continuación O presione 'Cancelar' para volver",
    fr: "cliquez sur le lien «Sélectionner» dans la colonne «Actions» ci-dessous OU appuyez sur «Annuler» pour revenir en arrière",
  },
  "Need Help": {
    en: "Need Help",
    es: "Necesitas ayuda",
    fr: "Besoin d'aide",
  },
  "New data": {
    en: "New data",
    es: "Nuevos datos",
    fr: "Nouvelles données",
  },
  "Time Stamp": {
    en: "Time Stamp",
    es: "Sello de tiempo",
    fr: "Horodatage",
  },
  "Created Successfully": {
    en: "Created Successfully",
    es: "Creado con éxito",
    fr: "Créé avec succès",
  },
  "Deleted Successfully": {
    en: "Deleted Successfully",
    es: "Borrado exitosamente",
    fr: "Supprimé avec succès",
  },
  "You cannot delete this Run": {
    en: "You cannot delete this Run",
    es: "No puedes eliminar esta ejecución",
    fr: "Vous ne pouvez pas supprimer cette course",
  },
  "No Data Available or Selected": {
    en: "No Data Available or Selected",
    es: "No hay datos disponibles o seleccionados",
    fr: "Aucune donnée disponible ou sélectionnée",
  },
  "Are you sure you want to delete": {
    en: "Are you sure you want to delete?",
    es: "¿Está seguro de que desea eliminar?",
    fr: "Etes-vous sûr que vous voulez supprimer?",
  },
  "All ranges in this run will also be deleted": {
    en: "All ranges in this run will also be deleted",
    es: "Todos los rangos de esta ejecución también se eliminarán.",
    fr: "Toutes les plages de cette exécution seront également supprimées",
  },
  "All the children asset in the selected asset will also be deleted": {
    en: "All the children asset in the selected asset will also be deleted",
    es: "Todos los elementos secundarios del elemento seleccionado también se eliminarán.",
    fr: "Tous les éléments enfants de l'élément sélectionné seront également supprimés",
  },
  New: {
    en: "New",
    es: "Nuevo",
    fr: "Nouveau",
  },
  Warning: {
    en: "Warning",
    es: "Advertencia",
    fr: "avertissement",
  },
  Added: {
    en: "Added",
    es: "Adicional",
    fr: "Ajoutée",
  },
  Changed: {
    en: "Changed",
    es: "Cambiada",
    fr: "Modifié",
  },
  Deleted: {
    en: "Deleted",
    es: "Eliminada",
    fr: "Supprimé",
  },
  Asset: {
    en: "Asset",
    es: "Activo",
    fr: "Actif",
  },
  Note: {
    en: "Note",
    es: "Nota",
    fr: "Remarque",
  },
  "AssetTypes Tests": {
    en: "Asset Type Tests",
    es: "Pruebas de tipos de activos",
    fr: "Tests des types d'actifs",
  },
  Tests: {
    en: "Tests",
    es: "Pruebas",
    fr: "Essais",
  },
  End: {
    en: "End",
    es: "Final",
    fr: "Fin",
  },
  "Asset Types Tests": {
    en: "Asset Type Tests",
    es: "Pruebas por Tipo de Activo",
    fr: "Tests de types d'actifs",
  },
  Type: {
    en: "Type",
    es: "Tipo",
    fr: "Type",
  },
  Execute: {
    en: "Execute",
    es: "Ejecutar",
    fr: "Exécuter",
  },
  Request: {
    en: "Request",
    es: "Solicitud",
    fr: "Demande",
  },
  Settings: {
    en: "Settings",
    es: "Configuraciones",
    fr: "Réglages",
  },
  Lists: {
    en: "Lists",
    es: "Liza",
    fr: "Listes",
  },
  Frequency: {
    en: "Frequency",
    es: "Frecuencia",
    fr: "La fréquence",
  },
  Password: {
    en: "Password",
    es: "Contraseña",
    fr: "Mot de passe",
  },
  Department: {
    en: "Department",
    es: "Departamento",
    fr: "département",
  },
  Value: {
    en: "Value",
    es: "Valor",
    fr: "Valeur",
  },
  Data: {
    en: "Data",
    es: "Datos",
    fr: "Les données",
  },
  Hi: {
    en: "Hi",
    es: "Hola",
    fr: "Salut",
  },
  Forgot: {
    en: "Forgot",
    es: "Olvidó",
    fr: "Oublié",
  },
  "User Deleted !": {
    en: "User Deleted !",
    es: "Usuario eliminado !",
    fr: "Utilisateur supprimé!",
  },
  "Adjust Availability Hours": {
    en: "Adjust Availability Hours",
    es: "Ajustar horas de disponibilidad",
    fr: "Ajuster les heures de disponibilité",
  },
  "GPS Location Recording of Users In System": {
    en: "GPS Location Recording of Users In System",
    es: "Grabación de ubicación GPS de usuarios en el sistema",
    fr: "Enregistrement de la position GPS des utilisateurs dans le système",
  },
  "Are you sure you want to delete ?": {
    en: "Are you sure you want to delete ?",
    es: "Estas seguro que quieres borrarlo ?",
    fr: "Etes-vous sûr que vous voulez supprimer ?",
  },
  "Assigned Location": {
    en: "Assigned Location",
    es: "Lugar asignado",
    fr: "Emplacement attribué",
  },
  "Select one": {
    en: "Select one",
    es: "Seleccione uno",
    fr: "Sélectionnez un",
  },
  "Asset type": {
    en: "Asset type",
    es: "Tipo de activo",
    fr: "Type d'actif",
  },
  "Total plans": {
    en: "Total plans",
    es: "Planes totales",
    fr: "Total des plans",
  },
  "Assign To": {
    en: "Assign To",
    es: "Asignar a",
    fr: "Affecter à",
  },
  "Assign to...": {
    en: "Assign To...",
    es: "Asignar a...",
    fr: "Affecter à...",
  },
  "Start Date": {
    en: "Start Date",
    es: "Fecha de inicio",
    fr: "Date de début",
  },
  "Select Date": {
    en: "Select Date",
    es: "Seleccione fecha",
    fr: "Sélectionner une date",
  },
  "Repeat after days": {
    en: "Repeat after days",
    es: "Repita despues de dias",
    fr: "Répéter après des jours",
  },
  "Maintenance Types": {
    en: "Maintenance Types",
    es: "Tipos de mantenimiento",
    fr: "Types de maintenance",
  },
  "Crew Skills": {
    en: "Crew Skills",
    es: "Habilidades de la tripulación",
    fr: "Compétences de l'équipage",
  },
  "Equipment Types": {
    en: "Equipment Types",
    es: "Tipos de equipamiento",
    fr: "Types d'équipement",
  },
  "Material Types": {
    en: "Material Types",
    es: "Tipos de materiales",
    fr: "Types de matériaux",
  },
  "Close Date": {
    en: "Close Date",
    es: "Fecha de cierre",
    fr: "Date de clôture",
  },
  "Defect Codes": {
    en: "Defect Codes",
    es: "Códigos de defectos",
    fr: "Codes de défaut",
  },
  "Show Inactive": {
    en: "Show Inactive",
    es: "Mostrar inactivo",
    fr: "Afficher inactif",
  },
  "How Many": {
    en: "How Many",
    es: "Cuántos",
    fr: "Combien",
  },
  "Start Day": {
    en: "Start Day",
    es: "Día de inicio",
    fr: "Commence jour",
  },
  "End Day": {
    en: "End Day",
    es: "Día final",
    fr: "Jour de fin",
  },
  "Start Location": {
    en: "Start Location",
    es: "Lugar de inicio",
    fr: "Lieu de départ",
  },
  "End Location": {
    en: "End Location",
    es: "Ubicación final",
    fr: "Emplacement final",
  },
  "Select Assets": {
    en: "Select Assets",
    es: "Seleccionar activos",
    fr: "Sélectionnez les actifs",
  },
  Resource: {
    en: "Resource",
    es: "Recurso",
    fr: "Ressource",
  },
  Popup: {
    en: "Popup",
    es: "Surgir",
    fr: "Notification",
  },
  PLATES: {
    en: "PLATES",
    es: "PLATOS",
    fr: "PLAQUES",
  },
  BOLTS: {
    en: "BOLTS",
    es: "PERNOS",
    fr: "BOULONS",
  },
  Create: {
    en: "Create",
    es: "Crear",
    fr: "Créer",
  },
  briefing: {
    en: "briefing",
    es: "instrucciones",
    fr: "Compte rendu",
  },
  workers: {
    en: "workers",
    es: "trabajadoras",
    fr: "travailleurs",
  },
  comments: {
    en: "comments",
    es: "comentarios",
    fr: "commentaires",
  },
  days: {
    en: "Days",
    es: "Días",
    fr: "journées",
  },
  Signature: {
    en: "Signature",
    es: "Firma",
    fr: "Signature",
  },
  Briefings: {
    en: "Briefings",
    es: "Reuniones informativas",
    fr: "Briefings",
  },
  Briefing: {
    en: "Briefing",
    es: "Instrucciones",
    fr: "Compte rendu",
  },
  Number: {
    en: "Number",
    es: "Número",
    fr: "Nombre",
  },
  "Image display area": {
    en: "Image display area",
    es: "Área de visualización de imagen",
    fr: "Zone d'affichage de l'image",
  },
  "Track Managers": {
    en: "Track Managers",
    es: "Seguimiento de gerentes",
    fr: "Gestionnaires de piste",
  },
  "Track Manager": {
    en: "Track Manager",
    es: "Gerente de pista",
    fr: "Gestionnaire de piste",
  },
  "Team Member": {
    en: "Team Member",
    es: "Miembro del equipo",
    fr: "Membre de l'équipe",
  },
  "Inspection Deleted Successfully": {
    en: "Inspection Deleted Successfully",
    es: "Inspección eliminada exitosamente",
    fr: "Inspection supprimée avec succès",
  },
  "Inspection Updated Successfully": {
    en: "Inspection Updated Successfully",
    es: "Inspección actualizada exitosamente",
    fr: "Inspection mise à jour avec succès",
  },
  "Asset Removed Successfully": {
    en: "Asset Removed Successfully",
    es: "Activo eliminado con éxito",
    fr: "L'élément a bien été supprimé",
  },
  "Team Detail": {
    en: "Team Detail",
    es: "Detalle del equipo",
    fr: "Détail de l'équipe",
  },
  "Milepost start must be less than or equal to Milepost End": {
    en: "Milepost start must be less than or equal to Milepost End",
    es: "Milepost start debe ser menor o igual que Milepost End",
    fr: "Le début de Milepost doit être inférieur ou égal à Milepost End",
  },
  "Add Estimate": {
    en: "Add Estimate",
    es: "Añadir presupuesto",
    fr: "Ajouter une estimation",
  },
  "Milepost start must be less than Milepost End": {
    en: "Milepost start must be less than Milepost End",
    es: "El inicio de Milepost debe ser inferior al final de Milepost",
    fr: "Le début de Milepost doit être inférieur à Milepost End",
  },
  "Milepost Start": {
    en: "MP Start",
    es: "MP Comenzar",
    fr: "Début MP",
  },
  "Milepost End": {
    en: "MP End",
    es: "MP Final",
    fr: "Fin MP",
  },
  "Select Execution Date For Work Order": {
    en: "Select Execution Date For Work Order",
    es: "Seleccione la fecha de ejecución para la orden de trabajo",
    fr: "Sélectionnez la date d'exécution pour l'ordre de travail",
  },
  "SWITCH NUMBER": {
    en: "SWITCH NUMBER",
    es: "NÚMERO DE INTERRUPTOR",
    fr: "NUMÉRO DE COMMUTATEUR",
  },
  "Email sent, please check your email": {
    en: "Email sent, please check your email",
    es: "Correo electrónico enviado, por favor revise su correo electrónico",
    fr: "Email envoyé, veuillez vérifier votre email",
  },
  "Unable to Send Email or Email Address not found": {
    en: "Unable to Send Email or Email Address not found",
    es: "No se puede enviar correo electrónico o dirección de correo electrónico no encontrada",
    fr: "Impossible d'envoyer l'e-mail ou l'adresse e-mail introuvable",
  },
  "SPLIT RAILS": {
    en: "SPLIT RAILS",
    es: "RIELES DIVIDIDOS",
    fr: "RAILS SPLIT",
  },
  "View Change Log": {
    en: "View Change Log",
    es: "Ver registro de cambios",
    fr: "Voir la log des modifications",
  },
  "Hide Inactive": {
    en: "Hide Inactive",
    es: "Ocultar inactivo",
    fr: "Masquer inactif",
  },
  "Run Id": {
    en: "Run Id",
    es: "ID de ejecución",
    fr: "ID d'exécution",
  },
  "created at": {
    en: "created at",
    es: "Creado en",
    fr: "créé à",
  },
  "Run Location": {
    en: "Run Location",
    es: "Ejecutar ubicación",
    fr: "Emplacement de la course",
  },
  // validtion start
  "This field is required": {
    en: "This field is required",
    es: "Este campo es requerido",
    fr: "Ce champ est requis",
  },
  "Min length limit is ": {
    en: "Min length limit is ",
    es: "La longitud mínima es",
    fr: "La limite de longueur minimale est ",
  },
  "Max length limit is ": {
    en: "Max length limit is ",
    es: "La longitud máxima es",
    fr: "La limite de longueur maximale est ",
  },
  "Value must be a number": {
    en: "Value must be a number",
    es: "El valor debe ser un número ",
    fr: "La valeur doit être un nombre ",
  },
  "Value must be atleast greater than or equal to ": {
    en: "Value must be atleast greater than or equal to ",
    es: "El valor debe ser mayor o igual a ",
    fr: "La valeur doit être au moins supérieure ou égale à ",
  },
  "Value must not be greater than ": {
    en: "Value must not be greater than ",
    es: "El valor no debe ser mayor que ",
    fr: "La valeur ne doit pas être supérieure à ",
  },
  "This pattern is invalid": {
    en: "This pattern is invalid",
    es: "Este patrón no es válido",
    fr: "Ce modèle n'est pas valide",
  },
  //  validation end
  "Please Select Valid Location": {
    en: "Please Select Valid Location",
    es: "Por favor, seleccione una ubicación válida",
    fr: "Veuillez sélectionner un emplacement valide",
  },
  "Please enter reason for closing": {
    en: "Please enter reason for closing",
    es: "Por favor, introduzca el motivo del cierre",
    fr: "Veuillez saisir la raison de la fermeture",
  },
  "Length must be greater or equal to": {
    en: "Length must be greater or equal to",
    es: "La longitud debe ser mayor o igual a",
    fr: "La longueur doit être supérieure ou égale à",
  },
  "Length must be less or equal to": {
    en: "Length must be less or equal to",
    es: "La longitud debe ser menor o igual a",
    fr: "La longueur doit être inférieure ou égale à",
  },
  "Must be greater or equal to": {
    en: "Must be greater or equal to",
    es: "Debe ser mayor o igual a",
    fr: "Doit être supérieur ou égal à",
  },
  "Must be less or equal to": {
    en: "Must be less or equal to",
    es: "Debe ser menor o igual a",
    fr: "Doit être inférieur ou égal à",
  },
  "Must be equal to": {
    en: "Must be equal to",
    es: "Debe ser igual a",
    fr: "Doit être égal à",
  },
  "doesn't match, please verify": {
    en: "doesn't match, please verify",
    es: "no coincide, por favor verifique",
    fr: "ne correspond pas, veuillez vérifier",
  },
  "Number is not valid": {
    en: "Number is not valid",
    es: "El número no es válido.",
    fr: "Le numéro n'est pas valide",
  },
  "Validation failed": {
    en: "Validation failed",
    es: "Validación fallida",
    fr: "Validation échouée",
  },
  "Unable to Create": {
    en: "Unable to Create",
    es: "Incapaz de crear",
    fr: "Incapable de créer",
  },
  "Unable to Delete": {
    en: "Unable to Delete",
    es: "No se puede eliminar",
    fr: "Impossible de supprimer",
  },
  "Error Occurred": {
    en: "Error Occurred",
    es: "Se produjo un error",
    fr: "Erreur est survenue",
  },
  "Inspection recurs at day": {
    en: "Inspection recurs at day",
    es: "La inspección se repite en el día.",
    fr: "L'inspection se répète le jour",
  },
  "Inspection due at day": {
    en: "Inspection due at day",
    es: "Inspección por día",
    fr: "Inspection due le jour",
  },
  "Must be performed once within": {
    en: "Must be performed once within",
    es: "Debe realizarse una vez dentro",
    fr: "Doit être effectué une fois dans",
  },
  "Must be performed once in days": {
    en: "Must be performed once in days",
    es: "Debe realizarse una vez en días",
    fr: "Doit être effectué une fois tous les jours",
  },
  "Add Team Member": {
    en: "Add Team Member",
    es: "Agregar miembro del equipo",
    fr: "Ajouter un membre de l'équipe",
  },
  "Run Detail": {
    en: "Run Detail",
    es: "Detalle de ejecución",
    fr: "Détail de l'exécution",
  },
  "Maintenance List": {
    en: "Maintenance List",
    es: "Lista de mantenimiento",
    fr: "Liste de maintenance",
  },
  "Add User": {
    en: "Add User",
    es: "Agregar usuario",
    fr: "Ajouter un utilisateur",
  },
  "Select Document": {
    en: "Select Document",
    es: "Seleccionar documento",
    fr: "Sélectionnez un document",
  },
  "Selected Document": {
    en: "Selected Document",
    es: "Documento seleccionado",
    fr: "Document sélectionné",
  },
  "Upload Document": {
    en: "Upload Document",
    es: "Subir documento",
    fr: "Télécharger le document",
  },
  "Forgot Password": {
    en: "Forgot Password",
    es: "Se te olvidó tu contraseña",
    fr: "Mot de passe oublié",
  },
  "Select Image": {
    en: "Select Image",
    es: "Seleccionar imagen",
    fr: "Sélectionnez une image",
  },
  "Upload Image": {
    en: "Upload Image",
    es: "Cargar imagen",
    fr: "Télécharger l'image",
  },
  "Unable to Create Run": {
    en: "Unable to Create Run",
    es: "Ejecutar creado correctamente",
    fr: "Impossible de créer une analyse",
  },
  "Run Created Successfully": {
    en: "Run Created Successfully",
    es: "Ejecutar creado correctamente",
    fr: "Exécution créée avec succès",
  },
  "Inspection Created Successfully": {
    en: "Inspection Created Successfully",
    es: "Inspección creada con éxito",
    fr: "Inspection créée avec succès",
  },
  "Work Order Number": {
    en: "Work Order Number",
    es: "Número de Orden de Trabajo",
    fr: "Numéro de bon de travail",
  },
  "Update Attribute": {
    en: "Update Attribute",
    es: "Actualizar atributo",
    fr: "Mettre à jour l'attribut",
  },
  "Selected Image": {
    en: "Selected Image",
    es: "Imagen seleccionada",
    fr: "Image sélectionnée",
  },
  "Unable to Delete Run": {
    en: "Unable to Delete Run",
    es: "No se puede eliminar Ejecutar",
    fr: "Impossible de supprimer l'analyse",
  },
  "Run Deleted Successfully": {
    en: "Run Deleted Successfully",
    es: "Ejecutar eliminado correctamente",
    fr: "Exécution supprimée avec succès",
  },
  "Please provide Title": {
    en: "Please provide Title",
    es: "Por favor proporcione el título",
    fr: "Veuillez fournir le titre",
  },
  "Work Orders List": {
    en: "Work Orders List",
    es: "Lista de órdenes de trabajo",
    fr: "Liste des bons de travail",
  },
  "Create Maintenance Request": {
    en: "Create Maintenance Request",
    es: "Crear solicitud de mantenimiento",
    fr: "Créer une demande de maintenance",
  },
  "Update Inspection Plan": {
    en: "Update Inspection Plan",
    es: "Actualizar plan de inspección",
    fr: "Mettre à jour le plan d'inspection",
  },
  "Start must be less than or equal to end": {
    en: "Start must be less than or equal to end",
    es: "El inicio debe ser menor o igual que el final",
    fr: "Le début doit être inférieur ou égal à la fin",
  },
  "Options Preset": {
    en: "Options Preset",
    es: "Opciones preestablecidas",
    fr: "Options prédéfinies",
  },
  "Days between Inspections": {
    en: "Days between Inspections",
    es: "Días entre inspecciones",
    fr: "Jours entre les inspections",
  },
  "30 Days": {
    en: "30 Days",
    es: "30 dias",
    fr: "30 jours",
  },
  "Optional Info": {
    en: "Optional Info",
    es: "Información opcional",
    fr: "Informations facultatives",
  },
  "Issue Details": {
    en: "Issue Details",
    es: "Detalles del problema",
    fr: "Détails du problème",
  },
  "Inspections & Tests": {
    en: "Inspections & Tests",
    es: "Inspecciones & pruebas",
    fr: "Inspections et tests",
  },
  "Inspection & Testing Reports": {
    en: "Inspection & Testing Reports",
    es: "Informes de inspección y prueba",
    fr: "Rapports d'inspection et d'essai",
  },
  "Signal Maintainence": {
    en: "Signal Maintainence",
    es: "Informes de inspección y prueba",
    fr: "Maintenance du signal",
  },
  "Signal WO": {
    en: "Signal WO",
    es: "Señal WO",
    fr: "Signal WO",
  },
  "Inspection Name": {
    en: "Inspection Name",
    es: "Nombre de inspección",
    fr: "Nom de l'inspection",
  },
  "Inspection Type": {
    en: "Inspection Type",
    es: "Tipo de inspección",
    fr: "Type d'inspection",
  },
  Weather: {
    en: "Weather",
    es: "Clima",
    fr: "La météo",
  },
  Required: {
    en: "Required",
    es: "Requerida",
    fr: "Obligatoire",
  },
  From: {
    en: "From",
    es: "desde",
    fr: "De",
  },
  To: {
    en: "To",
    es: "a",
    fr: "À",
  },
  Walk: {
    en: "Walking",
    es: "Caminar",
    fr: "En marchant",
  },
  Observe: {
    en: "Observe",
    es: "Observar",
    fr: "Observer",
  },
  Deficiency: {
    en: "Deficiency",
    es: "Deficiencia",
    fr: "Déviation",
  },
  "FRA Defect": {
    en: "FRA Defect",
    es: "Defecto de FRA",
    fr: "Défaut FRA",
  },
  Code: {
    en: "Code",
    es: "Código",
    fr: "Code",
  },
  "Defect Description": {
    en: "Defect Description",
    es: "Descripción del defecto",
    fr: "description du défaut",
  },
  "Remedial Action": {
    en: "Remedial Action",
    es: "Acción correctiva",
    fr: "Des mesures correctives",
  },
  "213.9B Needed": {
    en: "213.9B Needed",
    es: "213.9B Necesario",
    fr: "213.9B nécessaire",
  },
  "Inspector Signature": {
    en: "Inspector Signature",
    es: "Firma del inspector",
    fr: "Signature de l'inspecteur",
  },
  "Track Inspection & Repair Report": {
    en: "Track Inspection & Repair Report",
    es: "Informe de inspección y reparación de seguimiento",
    fr: "Suivi du rapport d'inspection et de réparation",
  },
  "Detailed Switch Inspection": {
    en: "Detailed Switch Inspection",
    es: "Inspección detallada del interruptor",
    fr: "Rapport Aiguillage",
  },
  "Select a Date Range": {
    en: "Select a Date Range",
    es: "Seleccione un rango de fechas",
    fr: "Sélectionnez une plage de dates",
  },
  All: {
    en: "All",
    es: "Todo",
    fr: "Tout",
  },
  "Issue Type": {
    en: "Issue Type",
    es: "Tipo de problema",
    fr: "type de probleme",
  },
  "Add Deficiency to FRA Report": {
    en: "Add Deficiency to FRA Report",
    es: "Agregar deficiencia al informe de FRA",
    fr: "Ajouter une anomalie au rapport FRA",
  },
  "Select Priority": {
    en: "Select Priority",
    es: "Seleccionar prioridad",
    fr: "Sélectionnez la priorité",
  },
  "Rail Side": {
    en: "Rail Side",
    es: "Dirección del carril",
    fr: "Direction du rail",
  },
  Information: {
    en: "Information",
    es: "Información",
    fr: "Information",
  },
  "Add Comment": {
    en: "Add Comment",
    es: "Agregar comentario",
    fr: "Ajouter un commentaire",
  },
  "Track Manager Comments": {
    en: "Track Manager Comments",
    es: "Comentarios del administrador de seguimiento",
    fr: "Commentaires du gestionnaire de suivi",
  },
  "Rule 213.9(b) Applied": {
    en: "Rule 213.9(b) Applied",
    es: "Se aplica la regla 213.9 (b)",
    fr: "Règle 213.9 (b) appliquée",
  },
  Yes: {
    en: "Yes",
    es: "si",
    fr: "Oui",
  },
  Rails: {
    en: "Rails",
    es: "Rieles",
    fr: "Rails",
  },
  Spikes: {
    en: "Spikes",
    es: "Picos",
    fr: "Clou",
  },
  Tiles: {
    en: "Tiles",
    es: "Losas",
    fr: "Dormant",
  },
  "Joint Bar": {
    en: "Joint Bar",
    es: "Barra conjunta",
    fr: "Joint",
  },
  "Weather Conditions": {
    en: "Weather Conditions",
    es: "Las condiciones climáticas",
    fr: "Conditions météorologiques",
  },
  Temperature: {
    en: "Temperature",
    es: "Temperatura",
    fr: "Température",
  },
  "Issue Priority": {
    en: "Issue Priority",
    es: "Prioridad de problemas",
    fr: "Priorité du problème",
  },
  open: {
    en: "open",
    es: "abierto",
    fr: "ouvert",
  },
  "Image Before": {
    en: "Image Before",
    es: "Imagen antes",
    fr: "Image avant",
  },
  "No user": {
    en: "No user",
    es: "Sin usuario",
    fr: "Aucun utilisateur",
  },
  Completed: {
    en: "Completed",
    es: "Terminado",
    fr: "Terminé",
  },
  "link to the audio": {
    en: "link to the audio",
    es: "enlace al audio",
    fr: "lien vers l'audio",
  },
  "Include in FRA": {
    en: "Include in FRA",
    es: "Incluir en FRA",
    fr: "Inclure dans FRA",
  },
  "Inspection Frequency": {
    en: "Inspection Frequency",
    es: "Frecuencia de inspección",
    fr: "Fréquence d'inspection",
  },
  in: {
    en: "in",
    es: "en",
    fr: "dans",
  },
  every: {
    en: "every",
    es: "cada",
    fr: "chaque",
  },
  Day: {
    en: "Day",
    es: "Dia",
    fr: "journée",
  },
  Week: {
    en: "Week",
    es: "Semana",
    fr: "La semaine",
  },
  Month: {
    en: "Month",
    es: "Mes",
    fr: "Mois",
  },
  Year: {
    en: "Year",
    es: "Año",
    fr: "Année",
  },
  Repaired: {
    en: "Repaired",
    es: "Reparado",
    fr: "Réparé",
  },
  Describe: {
    en: "Describe",
    es: "Notas",
    fr: "Décris",
  },
  hugging: {
    en: "hugging",
    es: "abrazar",
    fr: "étreindre",
  },

  "Milepost Start Limit": {
    en: "Milepost Start Limit",
    es: "Límite de inicio de poste de milla",
    fr: "Limite de départ Milepost",
  },
  "Milepost End Limit": {
    en: "Milepost End Limit",
    es: "Límite final de poste de señalización",
    fr: "Limite de fin de Milepost",
  },
  "Start Of Week": {
    en: "Start Of Week",
    es: "Inicio de semana",
    fr: "Début de semaine",
  },
  "Force Input Start/End Milepost on Mobile App": {
    en: "Force Input Start/End Milepost on Mobile App",
    es: "Forzar entrada de hito de inicio / fin en la aplicación móvil",
    fr: "Forcer l'entrée au début / à la fin du point milliaire sur l'application mobile",
  },
  "Force Input Traverse Track on Mobile App": {
    en: "Force Input Traverse Track on Mobile App",
    es: "Forzar entrada de recorrido transversal en la aplicación móvil",
    fr: "Forcer le suivi de la trajectoire d'entrée sur l'application mobile",
  },
  "Working Week days": {
    en: "Working Week days",
    es: "Días laborables laborables",
    fr: "Jours ouvrables",
  },
  Holidays: {
    en: "Holidays",
    es: "Días festivos",
    fr: "Vacances",
  },
  "Review Remedial Action Before Resolving Issue": {
    en: "Review Remedial Action Before Resolving Issue",
    es: "Revise la acción correctiva antes de resolver el problema",
    fr: "Examiner les mesures correctives avant de résoudre le problème",
  },
  "Force app to use single clock for Inspection": {
    en: "Force app to use single clock for Inspection",
    es: "Obligar a la aplicación a utilizar un solo reloj para la inspección",
    fr: "Forcer l'application à utiliser une seule horloge pour l'inspection",
  },
  "Allow selection of track direction in Mobile app (if available)": {
    en: "Allow selection of track direction in Mobile app (if available)",
    es: "Permitir la selección de la dirección de la pista en la aplicación móvil (si está disponible)",
    fr: "Autoriser la sélection de la direction du tracé dans l'application mobile (si disponible)",
  },
  "Force Mobile app to select Main Track as default asset": {
    en: "Force Mobile app to select Main Track as default asset",
    es: "Obligar a la aplicación móvil a seleccionar Main Track como activo predeterminado",
    fr: "Forcer l'application mobile à sélectionner la piste principale comme actif par défaut",
  },
  "Allow Inspector to select Inspection type before starting": {
    en: "Allow Inspector to select Inspection type before starting",
    es: "Permita que el inspector seleccione el tipo de inspección antes de comenzar",
    fr: "Autoriser l'inspecteur à sélectionner le type d'inspection avant de commencer",
  },
  "Allow inspector to add weather condition before starting inspection": {
    en: "Allow inspector to add weather condition before starting inspection",
    es: "Permita que el inspector agregue las condiciones climáticas antes de comenzar la inspección",
    fr: "Permettre à l'inspecteur d'ajouter les conditions météorologiques avant de commencer l'inspection",
  },
  "Switch Alert Days": {
    en: "Switch Alert Days",
    es: "Cambiar días de alerta",
    fr: "Changer de jours d'alerte",
  },
  "Use the temperature sign i.e (F: Fahrenheit, C: Celsius)": {
    en: "Use the temperature sign i.e (F: Fahrenheit, C: Celsius)",
    es: "Utilice el signo de temperatura, es decir, (F: Fahrenheit, C: Celsius)",
    fr: "Utilisez le signe de la température, c'est-à-dire (F: Fahrenheit, C: Celsius)",
  },
  "Use the distance sign i.e (M: Miles, K: Kilometers)": {
    en: "Use the distance sign i.e (M: Miles, K: Kilometers)",
    es: "Utilice el signo de distancia, es decir, (M: millas, K: kilómetros)",
    fr: "Utilisez le signe de distance, c'est-à-dire (M: Miles, K: Kilomètres)",
  },
  "Use the sign posts i.e (MP: Milepost, KP: Kilometre Post)": {
    en: "Use the sign posts i.e (MP: Milepost, KP: Kilometre Post)",
    es: "Utilice los postes de señalización, es decir (MP: Milepost, KP: Kilometer Post)",
    fr: "Utilisez les poteaux de signalisation, c'est-à-dire (MP: Milepost, KP: Kilometer Post)",
  },
  Region: {
    en: "Region",
    es: "Región",
    fr: "Région",
  },
  "Sub-Division": {
    en: "Sub-Division",
    es: "Subdivisión",
    fr: "Subdivision",
  },
  Lines: {
    en: "Lines",
    es: "Líneas",
    fr: "Lignes",
  },
  Add: {
    en: "Add",
    es: "Añadir",
    fr: "Ajouter",
  },
  Edit: {
    en: "Edit",
    es: "Editar",
    fr: "Éditer",
  },
  Setting: {
    en: "Setting",
    es: "Ajuste",
    fr: "Réglage",
  },
  Delete: {
    en: "Delete",
    es: "Eliminar",
    fr: "Effacer",
  },
  "View Only": {
    en: "View Only",
    es: "Sólo vista",
    fr: "Lecture seul",
  },
  "Add Asset Type": {
    en: "Add Asset Type",
    es: "Agregar tipo de activo",
    fr: "Ajouter un type d'actif",
  },
  "Add Line": {
    en: "Add Line",
    es: "Añadir línea",
    fr: "Ajouter une ligne",
  },
  Save: {
    en: "Save",
    es: "Salvar",
    fr: "Sauvegarder",
  },
  "Fixed Asset Inspection Status": {
    en: "Fixed Asset Inspection Status",
    es: "Estado de inspección de activos fijos",
    fr: "Statut d'inspection des immobilisations",
  },
  "Track Inspection Status": {
    en: "Track Inspection Status",
    es: "Seguimiento del estado de inspección",
    fr: "Suivi du statut d'inspection",
  },
  "Calendar of Inspections": {
    en: "Calendar of Inspections",
    es: "Calendario de inspecciones",
    fr: "Calendrier des inspections",
  },
  "List of Inspections": {
    en: "List of Inspections",
    es: "Lista de inspecciones",
    fr: "Liste des inspections",
  },
  "Signal Tests": {
    en: "Signal Tests",
    es: "Pruebas de señal",
    fr: "Tests de signal",
  },
  "Are you sure you want to perform this action": {
    en: "Are you sure you want to perform this action",
    es: "¿Estás seguro de que quieres realizar esta acción?",
    fr: "Êtes-vous sûr de vouloir effectuer cette action",
  },
  "This would cause changes in assets and will impact inspection/maintenance planning": {
    en: "This would cause changes in assets and will impact inspection/maintenance planning",
    es: "Esto provocaría cambios en los activos y afectaría la planificación de la inspección / mantenimiento",
    fr: "Cela entraînerait des changements dans les actifs et aura un impact sur la planification des inspections / maintenance",
  },
  Confirmation: {
    en: "Confirmation",
    es: "Confirmación",
    fr: "Confirmation",
  },
  "Image After": {
    en: "Image After",
    es: "Imagen después",
    fr: "Image après",
  },
  "Max Interval": {
    en: "Max Interval",
    es: "Intervalo máximo",
    fr: "Intervalle max",
  },
  "Add Inspection Plan": {
    en: "Add Inspection Plan",
    es: "Agregar plan de inspección",
    fr: "Ajouter un plan d'inspection",
  },
  "Track OOS(Out of Service)": {
    en: "Track OOS(Out of Service)",
    es: "Seguimiento de OOS (fuera de servicio",
    fr: "Suivre OOS (hors service)",
  },
  "Setup Tracks": {
    en: "Setup Tracks",
    es: "Configurar pistas",
    fr: "Configurer les pistes",
  },
  "Track Setup": {
    en: "Track Setup",
    es: "Configuración de pista",
    fr: "Configuration de la piste",
  },
  "GeoJson Data": {
    en: "GeoJson Data",
    es: "Datos GeoJson",
    fr: "Données GeoJson",
  },
  "Length (miles)": {
    en: "Length (miles)",
    es: "Longitud (millas)",
    fr: "Longueur (miles)",
  },
  "Length (km)": {
    en: "Length (km)",
    es: "Longitud (km)",
    fr: "Longueur (km)",
  },
  "Local Track Name": {
    en: "Local Track Name",
    es: "Nombre de la pista local",
    fr: "Nom de la piste locale",
  },
  "Track Orientation": {
    en: "Track Orientation",
    es: "Orientación de la pista",
    fr: "Orientation de la piste",
  },
  "North/South": {
    en: "North/South",
    es: "Norte/Sur",
    fr: "Nord/Sud",
  },
  "East/West": {
    en: "East/West",
    es: "Derecha/Ambos",
    fr: "Est/Ouest",
  },
  "Electrified Territory": {
    en: "Electrified Territory",
    es: "Territorio electrificado",
    fr: "Territoire électrifié",
  },
  "Primary Track": {
    en: "Primary Track",
    es: "Pista principal",
    fr: "Piste principale",
  },
  primaryTrack: {
    en: "Primary Track",
    es: "Pista principal",
    fr: "Piste principale",
  },
  "Invalid Json file": {
    en: "Invalid Json file",
    es: "Archivo Json no válido",
    fr: "Fichier Json non valide",
  },
  "Please enter track name": {
    en: "Please enter track name",
    es: "Ingrese el nombre de la pista",
    fr: "Veuillez saisir le nom de la piste",
  },
  "Track length is not valid, Please provide valid values for track start and end": {
    en: "Track length is not valid, Please provide valid values for track start and end",
    es: "La longitud de la pista no es válida. Proporcione valores válidos para el inicio y el final de la pista.",
    fr: "La longueur de la piste n'est pas valide, veuillez fournir des valeurs valides pour le début et la fin de la piste",
  },
  "Values of MP Start or  MP End has negative value": {
    en: "Values of MP Start or  MP End has negative value",
    es: "Los valores de MP Start o MP End tienen un valor negativo",
    fr: "Les valeurs de MP Start ou MP End ont une valeur négative",
  },
  "Values of MP Start & MP End are out of range": {
    en: "Values of MP Start & MP End are out of range",
    es: "Los valores de MP Start y MP End están fuera de rango",
    fr: "Les valeurs de MP Start et MP End sont hors limites",
  },
  "Server is not accessible, Please retry in few seconds...": {
    en: "Server is not accessible, Please retry in few seconds...",
    es: "El servidor no es accesible. Vuelva a intentarlo en unos segundos ...",
    fr: "Le serveur n'est pas accessible, veuillez réessayer dans quelques secondes ...",
  },
  "Track > Assets": {
    en: "Track > Assets",
    es: "Seguimiento> Activos",
    fr: "Suivre> Actifs",
  },
  "Track GeoJson": {
    en: "Track GeoJson",
    es: "Seguimiento de GeoJson",
    fr: "Suivre GeoJson",
  },
  "3rd Rail Power": {
    en: "3rd Rail Power",
    es: "Energía del tercer carril",
    fr: "3e rail d'alimentation",
  },
  "Catenary Power": {
    en: "Catenary Power",
    es: "Poder de catenaria",
    fr: "Puissance caténaire",
  },
  "New track": {
    en: "New track",
    es: "Nueva pista",
    fr: "Nouvelle piste",
  },
  "New Track": {
    en: "New Track",
    es: "Nueva Pista",
    fr: "Nouvelle Piste",
  },
  "Add New Unit": {
    en: "Add New Unit",
    es: "Agregar nueva unidad",
    fr: "Ajouter une nouvelle unité",
  },
  "Add Category List": {
    en: "Add Category List",
    es: "Agregar lista de categorías",
    fr: "Ajouter une liste de catégories",
  },
  "Edit Category List": {
    en: "Edit Category List",
    es: "Editar lista de categorías",
    fr: "Modifier la liste des catégories",
  },
  "Track Report": {
    en: "Track Report",
    es: "Informe de seguimiento",
    fr: "Rapport de suivi",
  },
  "Defects Report": {
    en: "Defects Report",
    es: "Informe de defectos",
    fr: "Rapport de défauts",
  },
  "Un-Categorized": {
    en: "Un-Categorized",
    es: "Sin categorizar",
    fr: "Non classé",
  },
  Common: {
    en: "Common",
    es: "común",
    fr: "Commun",
  },
  Scheduling: {
    en: "Scheduling",
    es: "Planificación",
    fr: "Planification",
  },
  "Mobile App": {
    en: "Mobile App",
    es: "Aplicación movil",
    fr: "Application mobile",
  },
  "Location Created Successfully": {
    en: "Location Created Successfully",
    es: "Ubicación creada correctamente",
    fr: "Emplacement créé avec succès",
  },
  "GPS Latitude Start": {
    en: "GPS Latitude Start",
    es: "Inicio de GPS Latitude",
    fr: "Début de la latitude GPS",
  },
  "GPS Latitude End": {
    en: "GPS Latitude End",
    es: "Fin de latitud GPS",
    fr: "Latitude GPS Fin",
  },
  "GPS Longitude Start": {
    en: "GPS Longitude Start",
    es: "Inicio de longitud GPS",
    fr: "Début de la longitude GPS",
  },
  "GPS Longitude End": {
    en: "GPS Longitude End",
    es: "Final de longitud GPS",
    fr: "Fin de longitude GPS",
  },
  "Default Traverse by ": {
    en: "Default Traverse by",
    es: "Recorrido Predeterminado por",
    fr: "Traversée par défaut par",
  },
  "Lamp Attributes": {
    en: "Lamp Attributes",
    es: "Atributos de la lámpara",
    fr: "Attributs de la lampe",
  },
  timezone: {
    en: "Timezone",
    es: "Zona horaria",
    fr: "Fuseau horaire",
  },
  "Total Length Miles": {
    en: "Total Length Miles",
    es: "Millas de longitud total",
    fr: "Miles de longueur totale",
  },
  "Total Length Km": {
    en: "Total Length Km",
    es: "Longitud total Km",
    fr: "Longueur totale km",
  },
  Reverse: {
    en: "Reverse",
    es: "Inverso",
    fr: "Inverser",
  },
  "Password does not match": {
    en: "Password does not match",
    es: "Las contraseñas no coinciden",
    fr: "Le mot de passe ne correspond pas",
  },
  "Location Updated Successfully": {
    en: "Location Updated Successfully",
    es: "Ubicación actualizada correctamente",
    fr: "Emplacement mis à jour avec succès",
  },
  "Allow selection of rail direction in Mobile app (if available)": {
    en: "Allow selection of rail direction in Mobile app (if available)",
    es: "Permitir la selección de la dirección del carril en la aplicación móvil (si está disponible)",
    fr: "Autoriser la sélection de la direction du rail dans l'application mobile (si disponible)",
  },
  "Alert Email": {
    en: "Alert Email",
    es: "Correo electrónico de alerta",
    fr: "Email d'alerte",
  },
  "All the locations and assets in the selected location will also be deleted": {
    en: "All the locations and assets in the selected location will also be deleted",
    es: "Todas las ubicaciones y activos en la ubicación seleccionada también se eliminarán",
    fr: "Tous les emplacements et ressources de l'emplacement sélectionné seront également supprimés",
  },
  "Cost Base": {
    en: "Cost Base",
    es: "Base de costos",
    fr: "Base de coût",
  },
  "Select Recepient(s)": {
    en: "Select Recepient(s)",
    es: "Seleccionar destinatario (s)",
    fr: "Sélectionnez le (s) destinataire (s)",
  },
  "Track Disturbance Report": {
    en: "Track Disturbance Report",
    es: "Seguimiento del informe de erturbaciones",
    fr: "Suivi du rapport de perturbation",
  },
  "Switch Inspection & Repair Report": {
    en: "Switch Inspection & Repair Report",
    es: "Informe de inspección y reparación de interruptores",
    fr: "Rapport d'inspection et de réparation des commutateurs",
  },
  Reports: {
    en: "Reports",
    es: "Informes",
    fr: "Rapports",
  },
  Report: {
    en: "Report",
    es: "Reporte",
    fr: "rapport",
  },
  "Date of Disturbance:": {
    en: "Date of Disturbance:",
    es: "Fecha de la perturbación:",
    fr: "Date de la perturbation:",
  },
  "Railroad Name:": {
    en: "Railroad Name:",
    es: "Nombre del ferrocarril:",
    fr: "Nom du chemin de fer:",
  },
  "Track Name:": {
    en: "Track Name:",
    es: "Nombre de la pista:",
    fr: "Nom de la piste:",
  },
  "Location:from MP": {
    en: "Location:from MP",
    es: "Ubicación: desde MP",
    fr: "Lieu: de MP",
  },
  "to MP:": {
    en: "to MP:",
    es: "Y MP:",
    fr: "Et MP:",
  },
  "Alignment:(T/C)": {
    en: "Alignment:(T/C)",
    es: "Alineación: (T / C)",
    fr: "Alignment:(T/C)",
  },
  "Degree of Curve": {
    en: "Degree of Curve",
    es: "Grado de curva",
    fr: "Degré de courbe",
  },
  "Side of Rail(facing ascending milepost)(L,R,B)": {
    en: "Side of Rail(facing ascending milepost)(L,R,B)",
    es: "Lado del carril (mirando hacia el poste de la milla ascendente) (L, R, B)",
    fr: "Côté du rail (face au poteau kilométrique ascendant) (L, R, B)",
  },
  "Desired Rail Neutral": {
    en: "Desired Rail Neutral",
    es: "Neutral de carril deseado",
    fr: "Rail neutre souhaité",
  },
  "Temperature:Ambient": {
    en: "Temperature:Ambient",
    es: "Temperatura: ambiente",
    fr: "Température: ambiante",
  },
  "Type of Disturbance": {
    en: "Type of Disturbance",
    es: "Tipo de perturbación",
    fr: "Type de perturbation",
  },
  "Rail Layed (fill out Rail Laying Report)": {
    en: "Rail Layed (fill out Rail Laying Report)",
    es: "Instalación de rieles (complete el Informe de tendido de rieles",
    fr: "Rail posé (remplir le rapport de pose de rail",
  },
  "Rail plug Installed :(Gap produced by rail pullback)": {
    en: "Rail plug Installed :(Gap produced by rail pullback)",
    es: "Tapón de riel instalado: (espacio producido por el retroceso del riel)",
    fr: "Bouchon de rail installé: (Espace produit par le retrait du rail)",
  },
  "Reference Mark Length before:": {
    en: "Reference Mark Length before:",
    es: "Longitud de la marca de referencia antes:",
    fr: "Longueur de la marque de référence avant:",
  },
  "Reference Mark Length after:": {
    en: "Reference Mark Length after:",
    es: "Longitud de la marca de referencia después de:",
    fr: "Longueur de la marque de référence après:",
  },
  "Welds Made (Y/N) (how many)": {
    en: "Welds Made (Y/N) (how many)",
    es: "Soldaduras hechas (S / N) (cuántos)",
    fr: "Soudures effectuées (O / N) (combien)",
  },
  "Welds Made (rail separation)(Gap produces by pullback):": {
    en: "Welds Made (rail separation)(Gap produces by pullback):",
    es: "Soldaduras hechas (separación de rieles) (el espacio se produce por retroceso):",
    fr: "Soudures réalisées (séparation de rail) (Gap produit par retrait):",
  },
  "Turnout Installed:": {
    en: "Turnout Installed:",
    es: "Participación instalada:",
    fr: "Participation installée:",
  },
  "Track Panel Installed:": {
    en: "Track Panel Installed:",
    es: "Panel de seguimiento instalado:",
    fr: "Panneau de suivi installé:",
  },
  "Ties Installed:": {
    en: "Ties Installed:",
    es: "Lazos instalados:",
    fr: "Liens installés:",
  },
  "Surfacing out-of-face or spot surfacing:": {
    en: "Surfacing out-of-face or spot surfacing:",
    es: "Superficie exterior o superficie puntual:",
    fr: "Revêtement extérieur ou surfaçage ponctuel:",
  },
  "Track cribbed, undercut, washout": {
    en: "Track cribbed, undercut, washout",
    es: "Pista cribbed, socavado, lavado",
    fr: "Rail lit de bébé, dégagement, lavage",
  },
  "Track Buckle:": {
    en: "Track Buckle:",
    es: "Hebilla de pista:",
    fr: "Boucle de piste:",
  },
  "Pull-apart:": {
    en: "Pull-apart:",
    es: "Separar:",
    fr: "Démonter:",
  },
  "Other:(describe)": {
    en: "Other:(describe)",
    es: "Otro: (describir)",
    fr: "Autre: (décrire)",
  },
  "Disturbance Corrected:": {
    en: "Disturbance Corrected:",
    es: "Perturbación corregida:",
    fr: "Perturbation corrigée:",
  },
  "Adjusted Rail:Date": {
    en: "Adjusted Rail:Date",
    es: "Carril ajustado: fecha",
    fr: "Rail ajusté: date",
  },
  "Adjust RNT": {
    en: "Adjust RNT",
    es: "Ajustar RNT",
    fr: "Ajuster RNT",
  },
  "Reference mark distance:Before": {
    en: "Reference mark distance:Before",
    es: "Distancia de la marca de referencia: antes",
    fr: "Distance de repère de référence: avant",
  },
  After: {
    en: "After",
    es: "Después",
    fr: "Après",
  },
  "Rail Temperature": {
    en: "Rail Temperature",
    es: "Temperatura del carril",
    fr: "Température du rail",
  },
  "Ballast Restored:Date": {
    en: "Ballast Restored:Date",
    es: "Lastre Restaurado: Fecha",
    fr: "Ballast restauré: Date",
  },
  "Blast Compacted: Mechanical": {
    en: "Blast Compacted: Mechanical",
    es: "Explosión compactada: Mecánico",
    fr: "Blast compacté: mécanique",
  },
  "Time and Tonnage": {
    en: "Time and Tonnage",
    es: "Tiempo y tonelaje",
    fr: "Temps et tonnage",
  },
  "Alinement restored: Date": {
    en: "Alinement restored: Date",
    es: "Alineamiento restaurado: Fecha",
    fr: "Alinement restauré: Date",
  },
  "Stakes Monitored:": {
    en: "Stakes Monitored:",
    es: "Apuestas supervisadas:",
    fr: "Enjeux surveillés:",
  },
  "RNT Adjustment:": {
    en: "RNT Adjustment:",
    es: "Ajuste RNT:",
    fr: "Ajustement RNT:",
  },
  "Restored Anchor pattern to standard or added to prevent movement:": {
    en: "Restored Anchor pattern to standard or added to prevent movement:",
    es: "Patrón de anclaje restaurado a estándar o agregado para evitar movimiento:",
    fr: "Motif d'ancrage restauré à la norme ou ajouté pour empêcher le mouvement:",
  },
  "Other:": {
    en: "Other:",
    es: "Otro:",
    fr: "Autre:",
  },
  other: {
    en: "Other",
    es: "Otro",
    fr: "Autre",
  },
  "Speed Restriction place:(date and speed)": {
    en: "Speed Restriction place:(date and speed)",
    es: "Lugar de restricción de velocidad: (fecha y velocidad)",
    fr: "Lieu de restriction de vitesse: (date et vitesse)",
  },
  "Speed Restriction removed:(date)": {
    en: "Speed Restriction removed:(date)",
    es: "Se eliminó la restricción de velocidad: (fecha)",
    fr: "Restriction de vitesse supprimée: (date)",
  },
  "Name:": {
    en: "Name:",
    es: "Nombre:",
    fr: "Nom:",
  },
  "Date: ": {
    en: "Date: ",
    es: "Fecha: ",
    fr: "Date: ",
  },
  "Inspector(s): ": {
    en: "Inspector(s): ",
    es: "Inspector(es): ",
    fr: "Inspecteur(s): ",
  },
  "Weather: ": {
    en: "Weather: ",
    es: "Clima: ",
    fr: "La météo: ",
  },
  "Operated Y/N": {
    en: "Operated Y/N",
    es: "Operado Y/N",
    fr: "Opéré O/N",
  },
  "Gage at Point": {
    en: "Gage at Point",
    es: "Gage en el punto",
    fr: "Gage au point",
  },
  "Guard Check Gage - Straight": {
    en: "Guard Check Gage - Straight",
    es: "Medidor de control de guardia - Recto",
    fr: "Jauge de contrôle de garde - droite",
  },
  "Guard Check Gage - Turn Out:": {
    en: "Guard Check Gage - Turn Out:",
    es: "Guard Check Gage - Turn Out:",
    fr: "Jauge de contrôle de garde - Turn Out:",
  },
  "Guard Face Gage- Turn Out ": {
    en: "Guard Face Gage- Turn Out ",
    es: "Calibre de Cara de Guardia - Desvío ",
    fr: "Guard Face Gage - Turn Out ",
  },
  "Guard Face Gage - Straight": {
    en: "Guard Face Gage - Straight",
    es: "Medidor de cara de guardia - Recto",
    fr: "Guard Face Gage - Droit",
  },
  "Defects/Comments": {
    en: "Defects/Comments",
    es: "Defectos / Comentarios",
    fr: "Défauts / Commentaires",
  },
  "Defect Repaired": {
    en: "Defect Repaired",
    es: "Defecto reparado",
    fr: "Défaut réparé",
  },
  "Switch and Side Track Inspection Form": {
    en: "Switch and Side Track Inspection Form",
    es: "Formulario de inspección de interruptores y vías laterales",
    fr: "Formulaire d'inspection des interrupteurs et des rails latéraux",
  },
  "Track Inspection and Repair Report": {
    en: "Track Inspection and Repair Report",
    es: "Informe de inspección y reparación de seguimiento",
    fr: "Suivi du rapport d'inspection et de réparation",
  },
  "Defects Inspection and Repair Report": {
    en: "Defects Inspection and Repair Report",
    es: "Informe de inspección y reparación de defectos",
    fr: "Rapport d'inspection et de réparation des défauts",
  },
  Support: {
    en: "Support",
    es: "Apoyo",
    fr: "Soutien",
  },
  "Switch Report": {
    en: "Switch Report",
    es: "Informe de cambio",
    fr: "Rapport de commutation",
  },
  "Welcome Back": {
    en: "Welcome Back",
    es: "Dar una buena acogida",
    fr: "Bon retour",
  },
  "Server unreachable": {
    en: "Server unreachable",
    es: "Servidor inalcanzable",
    fr: "Serveur inaccessible",
  },
  "Issues Activity": {
    en: "Issues Activity",
    es: "Actividad de problemas",
    fr: "Activité du problème",
  },
  // "ISSUES": { en: "Support", es: "Apoyo", fr: "Soutien" },
  "Select Plannable Location": {
    en: "Select Plannable Location",
    fr: "Sélectionnez un emplacement planifiable",
  },

  "Instruction File": {
    en: "Instruction File",
    es: "Archivo de instrucciones",
    fr: "Fichier d'instructions",
  },
  "Validation failed , please fill required fields": {
    en: "Validation failed , please fill required fields",
    es: "La validación falló, complete los campos obligatorios",
    fr: "Validation échouée",
  },
  "Pending Priority": {
    en: "Pending Priority",
    es: "Prioridad pendiente",
    fr: "Priorité en attente",
  },

  "Unit of time": {
    en: "Unit of time",
    es: "Unidad de tiempo",
    fr: "Unité de temps",
  },
  "Fixed Assets Tests Reports": {
    en: "Fixed Assets Tests Reports",
    es: "Informes de pruebas de activos fijos",
    fr: "Rapports de tests d'immobilisations",
  },
  Test: {
    en: "Test",
    es: "Prueba",
    fr: "Tester",
  },
  "Before you change the group, assign following inspection to other inspector": {
    en: "Before you change the group, assign following inspection to other inspector",
    es: "Antes de cambiar el grupo, asigne la siguiente inspección a otro inspector",
    fr: "Avant de modifier le groupe, attribuez l'inspection suivante à un autre inspecteur",
  },
  "is currently assigned to a Team. If you change the role, this team member will be removed from current team and will need to be re-assigned to a new team":
    {
      en: "is currently assigned to a Team. If you change the role, this team member will be removed from current team and will need to be re-assigned to a new team",
      es: "está actualmente asignado a un equipo. Si cambia el rol, este miembro del equipo será eliminado del equipo actual y deberá ser reasignado a un nuevo equipo.",
      fr: "est actuellement affecté à une équipe. Si vous modifiez le rôle, ce membre de l'équipe sera supprimé de l'équipe actuelle et devra être réaffecté à une nouvelle équipe",
    },
  "is currently leading a Team. If you change the role, team will no longer exist and team members will need to be re-assigned to a new team":
    {
      en: "is currently leading a Team. If you change the role, team will no longer exist and team members will need to be re-assigned to a new team",
      es: "actualmente lidera un equipo. Si cambia el rol, el equipo dejará de existir y los miembros del equipo deberán ser reasignados a un nuevo equipo",
      fr: "dirige actuellement une équipe. Si vous modifiez le rôle, l'équipe n'existera plus et les membres de l'équipe devront être réaffectés à une nouvelle équipe",
    },
  "Select atleast one recipient": {
    en: "Select atleast one recipient",
    es: "Seleccione al menos una destinataria",
    fr: "Sélectionnez au moins un destinataire",
  },
  "Please provide time value greater than": {
    en: "Please provide time value greater than",
    es: "Proporcione un valor de tiempo superior a",
    fr: "Veuillez fournir une valeur de temps supérieure à",
  },
  Event: {
    en: "Event",
    es: "Evento",
    fr: "un événement",
  },
  Alert: {
    en: "Alert",
    es: "Alerta",
    fr: "Alerte",
  },
  Alerts: {
    en: "Alerts",
    es: "Alertas",
    fr: "Alertes",
  },
  Manage: {
    en: "Manage",
    es: "Gestionar",
    fr: "Gérer",
  },
  Field: {
    en: "Field",
    es: "Campo",
    fr: "Champ",
  },
  is: {
    en: "is",
    es: "es",
    fr: "est",
  },
  before: {
    en: "Before",
    es: "Antes",
    fr: "Avant",
  },
  after: {
    en: "After",
    es: "Después",
    fr: "Après",
  },
  minutes: {
    en: "Minutes",
    es: "Minutos",
    fr: "Minutes",
  },
  hours: {
    en: "Hours",
    es: "Horas",
    fr: "Heures",
  },
  required: {
    en: "required",
    es: "necesario",
    fr: "obligatoire",
  },
  months: {
    en: "Months",
    es: "Meses",
    fr: "Obligatoire",
  },
  web: {
    en: "Web",
    es: "Web",
    fr: "La toile",
  },
  "Select Field": {
    en: "Select Field",
    es: "Seleccionar campo",
    fr: "Sélectionnez un champ",
  },
  "Expiry Date": {
    en: "Expiry Date",
    es: "Fecha de caducidad",
    fr: "Date d'expiration",
  },
  "Inspection Date": {
    en: "Inspection Date",
    es: "Fecha de inspección",
    fr: "Date d'inspection",
  },
  "Location (milepost)": {
    en: "Location (milepost)",
    es: "Ubicación (poste de milla)",
    fr: "Emplacement (milepost)",
  },
  "Signal and crossing": {
    en: "Signal and crossing",
    es: "Signal and crossing",
    fr: "Passage à niveau et Signaux",
  },
  Tables: {
    en: "Tables",
    es: "Mesas",
    fr: "Tables",
  },
  "Please enter your Start Milepost before starting inspection": {
    en: "Please enter your Start Milepost before starting inspection",
    es: "Ingrese su poste de referencia de inicio antes de comenzar la inspección",
    fr: "Veuillez entrer le millage de départ avant de commencer l'inspection",
  },
  "Please enter the start Milepost": {
    en: "Please enter the start Milepost",
    es: "Introduzca el poste de la milla de inicio",
    fr: "Veuillez entrer le millage de départ",
  },
  "End Milepost is not within the range": {
    en: "End Milepost is not within the range",
    es: "End Milepost no está dentro del rango",
    fr: "Le milage finale n'est pas dans la plage",
  },
  "Please enter the end Milepost": {
    en: "Please enter the end Milepost",
    es: "Ingrese el poste de la milla final",
    fr: "Veuillez entrer le millage final",
  },
  "Start Milepost is not within the range": {
    en: "Start Milepost is not within the range",
    es: "Inicio Milepost no está dentro del rango",
    fr: "Le millage de départ n'est pas dans la plage",
  },
  "Fixed Assets": {
    en: "Fixed Assets",
    es: "Activos fijos",
    fr: "Actifs Fixes",
  },
  "Loading Report": {
    en: "Loading Report",
    es: "Cargando informe",
    fr: "Rapport en chargement",
  },
  "Time and GPS Report": {
    en: "Time and GPS Report",
    es: "Informe de tiempo y GPS",
    fr: "Rapport temps et GPS",
  },
  "Select Asset": {
    en: "Select Asset",
    es: "Seleccionar activo",
    fr: "Sélectionnez un actif",
  },
  "Task Dashboard": {
    en: "Task Dashboard",
    es: "Panel de tareas",
    fr: "Tableau de bord des tâches",
  },
  "Do you really want to end run?": {
    en: "Do you really want to end run?",
    es: "De verdad quieres terminar la carrera?",
    fr: "Voulez-vous vraiment terminer la course?",
  },
  "End Run?": {
    en: "End Run?",
    es: "Finalizar ejecución?",
    fr: "Compléter la tournée?",
  },
  "Start Run?": {
    en: "Start Run?",
    es: "Empieza a correr?",
    fr: "Démarrer la tournée?",
  },
  "Do you really want to Start Run?": {
    en: "Do you really want to Start Run?",
    es: "Vía o riel",
    fr: "Voulez-vous vraiment démarrer la trounée?",
  },
  "Please wait! Finishing Inspection": {
    en: "Please wait! Finishing Inspection",
    es: "Por favor espera! Inspección de acabado",
    fr: "S'il vous plaît, attendez! Compléter l'inspection",
  },
  "Please complete all runs to close session": {
    en: "Please complete all runs to close session",
    es: "Complete todas las ejecuciones para cerrar la sesión",
    fr: "Veuillez compléter toutes les routes pour fermer la session",
  },
  "View Active Run": {
    en: "View Active Run",
    es: "Ver ejecución activa",
    fr: "Afficher la tournée active",
  },
  "Run Closed!": {
    en: "Run Closed!",
    es: "Corre cerrado!",
    fr: "Tourné fermé!",
  },
  "Select Inspection Run": {
    en: "Select Inspection Run",
    es: "Seleccionar ejecución de inspección",
    fr: "Sélectionner la trounée d'inspection",
  },
  "Defects / Deficiencies": {
    en: "Defects / Deficiencies",
    es: "Defectos / Deficiencias",
    fr: "Défault /Déviation",
  },
  "Choose File": {
    en: "Choose File",
    es: "Elija el archivo",
    fr: "Choisir le fichier",
  },
  "Alert event": {
    en: "Alert event",
    es: "Evento de alerta",
    fr: "Événement d'alerte",
  },
  "cannot be selected": {
    en: "cannot be selected",
    es: "no se puede seleccionar",
    fr: "ne peut pas être sélectionné",
  },

  "Duplicate alert": {
    en: "Duplicate alert",
    es: "Alerta duplicada",
    fr: "Choisir le fichier",
  },
  "Setup alert for inspection": {
    en: "Setup alert for inspection",
    es: "Configurar alerta para inspección",
    fr: "Alerte de configuration pour inspection",
  },
  "Confirm Role Change": {
    en: "Confirm Role Change",
    es: "Confirmar cambio de rol",
    fr: "Confirmer le changement de rôle",
  },
  "Do you want to proceed": {
    en: "Do you want to proceed",
    es: "Quieres proceder",
    fr: "Voulez-vous poursuivre",
  },
  "Please first save/cancel unsaved rules": {
    en: "Please first save/cancel unsaved rules",
    es: "Primero, guarde / cancele las reglas no guardadas",
    fr: "Veuillez d'abord enregistrer / annuler les règles non enregistrées",
  },
  "Report Name": {
    en: "Report Name",
    es: "Reportar nombre",
    fr: "Nom du rapport",
  },
  Date: {
    en: "Date",
    es: "Fecha",
    fr: "Date",
  },
  "Date / Technician": {
    en: "Date / Technician",
    es: "Fecha / Técnico",
    fr: "Date / Technicien",
  },
  Inspected: {
    en: "Inspected",
    es: "Inspeccionado",
    fr: "Inspecté",
  },
  "Type: SPL 165/10 elements": {
    en: "Type: SPL 165/10 elements",
    es: "Tipo: SPL 165/10 elementos",
    fr: "Type:SPL 165/10 éléments",
  },
  "Installation date": {
    en: "Installation date",
    es: "Fecha de instalación",
    fr: "Date installation",
  },
  charger: {
    en: "charger",
    es: "cargador",
    fr: "chargeur",
  },
  Batteries: {
    en: "Batteries",
    es: "pilas",
    fr: "batteries",
  },
  "Loss to earth (rule 303)": {
    en: "Loss to earth (rule 303)",
    es: "Pérdida a tierra (regla 303)",
    fr: "Loss to earth (rule 303)",
  },
  "Voltage per cell (Without charger)": {
    en: "Voltage per cell (Without charger)",
    es: "Voltaje por celda (sin cargador)",
    fr: "Tension par élément (Sans chargeur)",
  },
  With: {
    en: "With",
    es: "Con",
    fr: "Avec",
  },
  Without: {
    en: "Without",
    es: "Sin",
    fr: "Sans",
  },
  "Comments (addition of distilled water, etc.)": {
    en: "Comments (addition of distilled water, etc.)",
    es: "Comentarios (adición de agua destilada, etc.)",
    fr: "Commentaires (ajout de l’eau distillée, etc.)",
  },
  "Type: SPL 340/20 elements": {
    en: "Type: SPL 340/20 elements",
    es: "Comentarios (adición de agua destilada, etc.)",
    fr: "Type: éléments SPL 340/20",
  },
  "Margins-GI335 tracking": {
    en: "Margins-GI335 tracking",
    es: "Seguimiento de márgenes-GI335",
    fr: "Suivi margins-GI335",
  },
  "Main track": {
    en: "Main track",
    es: "Pista principal",
    fr: "Voie principale",
  },
  Siding: {
    en: "Siding",
    es: "Con",
    fr: "Avec",
  },
  "Length of First Half": {
    en: "Length of First Half",
    es: "Duración de la primera mitad",
    fr: "Longueur de voi First Half",
  },
  "Margin Second Half": {
    en: "Margin Second Half",
    es: "Margen Segunda mitad",
    fr: "Margin Second Half",
  },
  "Second Half Length": {
    en: "Second Half Length",
    es: "Longitud de la segunda mitad",
    fr: "Longueur de voi Second Half",
  },
  "Margin First Half": {
    en: "Margin First Half",
    es: "Margen de la primera mitad",
    fr: "Margin First Half",
  },
  Comments: {
    en: "Comments",
    es: "Comentarios",
    fr: "Commentaires",
  },
  "Verified By": {
    en: "Verified By",
    es: "verificada por",
    fr: "vérifié par",
  },
  "MONTHLY INSPECTION OF SWITCHES": {
    en: "MONTHLY INSPECTION OF SWITCHES",
    es: "INSPECCIÓN MENSUAL DE INTERRUPTORES",
    fr: "INSPECTION MENSUELLE DES INTERRUPTEURS",
  },
  "ANNUAL INSPECTION OF SWITCHES": {
    en: "ANNUAL INSPECTION OF SWITCHES",
    es: "INSPECCIÓN ANUAL DE INTERRUPTORES",
    fr: "INSPECTION ANNUELLE DES INTERRUPTEURS",
  },
  "QNS & L RAILWAY": {
    en: "QNS & L RAILWAY",
    es: "FERROCARRIL QNS Y L",
    fr: "CHEMIN DE FER QNS&L",
  },
  "MONTHLY SWITCH INSPECTION": {
    en: "MONTHLY SWITCH INSPECTION",
    es: "INSPECCIÓN MENSUAL DEL INTERRUPTOR",
    fr: "INSPECTION MENSUELLE DES AIGUILLAGES",
  },
  "PLACE:": {
    en: "PLACE:",
    es: "SITIO:",
    fr: "ENDROIT:",
  },
  "INSPECTOR:": {
    en: "INSPECTOR:",
    es: "INSPECTOR:",
    fr: "INSPECTEUR:",
  },
  CHECKS: {
    en: "CHECKS",
    es: "COMPROBACIONES",
    fr: "VÉRIFICATIONS",
  },
  TOLERANCES: {
    en: "TOLERANCES",
    es: "Tolerancias",
    fr: "TOLÉRANCES",
  },
  MEASURES: {
    en: "MEASURES",
    es: "MEDIDAS",
    fr: "MESURES",
  },
  "NOTES ": {
    en: "NOTES ",
    es: "NOTAS ",
    fr: "REMARQUES ",
  },
  "NEEDLE STROKE LINEARITY OF THE TIP": {
    en: "NEEDLE STROKE LINEARITY OF THE TIP",
    es: "LINEALIDAD DEL TRAZO DE AGUJA DE LA PUNTA",
    fr: "COURSE DES AIGUILLES LINÉARITÉ DE LA POINTE",
  },
  "1st ROD": {
    en: "1ST ROD",
    es: "1ª barra",
    fr: "1ÈRE ROD",
  },
  "2ND ROD": {
    en: "2ND ROD",
    es: "2ª VARILLA",
    fr: "2IÈME ROD",
  },
  "3RD ROD": {
    en: "3RD ROD",
    es: "3ª VARILLA",
    fr: "3IÈME ROD",
  },
  "COUNTER RAIL / GUARD RAIL PROTECTION RATING": {
    en: "COUNTER RAIL / GUARD RAIL PROTECTION RATING",
    es: "CLASIFICACIÓN DE PROTECCIÓN DE RIEL CONTRA / GUARDARRIL",
    fr: "COTE DE PROTECTION DU CONTRE-RAIL / GUARD RAIL",
  },
  "CROSSING HEART POINT PROTECTION RATING": {
    en: "CROSSING HEART POINT PROTECTION RATING",
    es: "CLASIFICACIÓN DE PROTECCIÓN DEL PUNTO CORAZÓN CRUZADO",
    fr: "COTE DE PROTECTION POINTE DU CŒUR DE CROISEMENT",
  },
  "VISUAL INSPECTION": {
    en: "VISUAL INSPECTION",
    es: "INSPECCIÓN VISUAL",
    fr: "INSPECTION VISUELLE",
  },
  "(GOLD COLOR ITEMS = ANNUAL INSPECTION ONLY)": {
    en: "(GOLD COLOR ITEMS = ANNUAL INSPECTION ONLY)",
    es: "(ARTÍCULOS DE COLOR ORO = INSPECCIÓN ANUAL ÚNICAMENTE)",
    fr: "(LES ITEMS COULEUR OR = INSPECTION ANNUELLE SEULEMENT)",
  },
  "GOOD CONDITION": {
    en: "GOOD CONDITION",
    es: "BUEN ESTADO",
    fr: "BON ÉTAT",
  },
  ADJUST: {
    en: "ADJUST",
    es: "AJUSTAR",
    fr: "AJUSTER",
  },
  REPLACE: {
    en: "REPLACE",
    es: "REEMPLAZAR",
    fr: "REMPLACER",
  },
  DESCRIPTION: {
    en: "DESCRIPTION",
    es: "DESCRIPCIÓN",
    fr: "DESCRIPTION",
  },
  "GLUE TIP WELL IN NORMAL POSITION": {
    en: "GLUE TIP WELL IN NORMAL POSITION",
    es: "PUNTA DE PEGAMENTO BIEN EN POSICIÓN NORMAL",
    fr: "POINTE COLLE BIEN EN POSITION NORMALE",
  },
  "GLUE TIP WELL IN INVERTED POSITION": {
    en: "GLUE TIP WELL IN INVERTED POSITION",
    es: "PUNTA DE PEGAMENTO BIEN EN POSICIÓN INVERTIDA",
    fr: "POINTE COLLE BIEN EN POSITION RENVERSÉE",
  },
  'TIP RAISING (1/4") C / E - C / N': {
    en: 'TIP RAISING (1/4") C / E - C / N',
    es: 'Levantamiento de punta (1/4\"\") C/E - C/N',
    fr: 'TIP RAISING (1/4 ") C / E - C / N',
  },
  'TIP RAISING (1/4 ") C / O - C / S': {
    en: 'TIP RAISING (1/4 ") C / O - C / S',
    es: 'Levantamiento de punta (1/4\"\") C/O - C/S',
    fr: 'SURÉLÉVATION DE LA POINTE (1/4") C/O - C/S',
  },
  "C / O - C / S TIP CONDITION": {
    en: "C / O - C / S TIP CONDITION",
    es: "CONDICIÓN DE PUNTA C / O - C / S",
    fr: "CONDITION DE LA POINTE C/O - C/S",
  },
  "C / E POINT CONDITION - C / N": {
    en: "C / E POINT CONDITION - C / N",
    es: "ESTADO PUNTO C / E - C / N",
    fr: "CONDITION DE LA POINTE C/E - C/N",
  },
  "HEEL-BLOCK BOLTS C / O - C / S (HEEL-BLOCK BOLTS)": {
    en: "HEEL-BLOCK BOLTS C / O - C / S (HEEL-BLOCK BOLTS)",
    es: "PERNOS DE BLOQUE DE TALÓN C / O - C / S (PERNOS DE BLOQUE DE TALÓN)",
    fr: "BOULONS TALON DE LA POINTE C/O - C/S (HEEL-BLOCK BOLTS)",
  },
  "HEEL-BLOCK BOLTS C / E - C / N TALON BOLTS": {
    en: "HEEL-BLOCK BOLTS C / E - C / N TALON BOLTS",
    es: "TORNILLOS TALÓN C / E - C / N PERNOS TALON",
    fr: "BOULONS TALON DE LA POINTE C/E - C/N (HEEL-BLOCK BOLTS)",
  },
  "LEVELING HEEL OF POINT C / O - C / S (HEEL-BLOCK)": {
    en: "LEVELING HEEL OF POINT C / O - C / S (HEEL-BLOCK)",
    es: "NIVELADOR DE TALÓN PUNTO C / O - C / S (HEEL-BLOCK)",
    fr: "NIVELLEMENT TALON DE LA POINTE C/O - C/S (HEEL-BLOCK)",
  },
  "LEVELING HEEL OF TIP C / E - C / N (HEEL-BLOCK)": {
    en: "LEVELING HEEL OF TIP C / E - C / N (HEEL-BLOCK)",
    es: "TALÓN NIVELADOR DE PUNTA C / E - C / N (HEEL-BLOCK)",
    fr: "NIVELLEMENT TALON DE LA POINTE C/E - C/N (HEEL-BLOCK)",
  },
  "C / O - C / S COUNTER-PLUG (BRACE-BLOCK)": {
    en: "C / O - C / S COUNTER-PLUG (BRACE-BLOCK)",
    es: "C / O - C / S CONTADOR-ENCHUFE (BLOQUE DE BRIDA)",
    fr: "CONTRE-FICHE C/O - C/S (BRACE-BLOCK)",
  },
  "COUNTER-PLUG C / E - C / N (BRACE-BLOCK)": {
    en: "COUNTER-PLUG C / E - C / N (BRACE-BLOCK)",
    es: "CONTENEDOR C / E - C / N (BRACE-BLOCK)",
    fr: "CONTRE-FICHE C/E - C/N (BRACE-BLOCK)",
  },
  "C / O - C / S STUD BOLTS (BRACE-BLOCK BOLTS)": {
    en: "C / O - C / S STUD BOLTS (BRACE-BLOCK BOLTS)",
    es: "PERNOS DE PERNOS C / O - C / S (PERNOS DE BLOQUE DE APOYO)",
    fr: "BOULONS DE CONTRE-FICHE C/O - C/S (BRACE-BLOCK BOLTS)",
  },
  "C / E - C / N STUD BOLTS (BRACE-BLOCK BOLTS)": {
    en: "C / E - C / N STUD BOLTS (BRACE-BLOCK BOLTS)",
    es: "C / E - PERNOS DE ESPÁRRAGO C / N (PERNOS DE BLOQUE DE REFUERZO)",
    fr: "BOULONS DE CONTRE-FICHE C/E - C/N (BRACE-BLOCK BOLTS)",
  },
  "COUNTER-NEEDLE C / O - C / S (STOCK-RAIL)": {
    en: "COUNTER-NEEDLE C / O - C / S (STOCK-RAIL)",
    es: "CONTRA-AGUJA C / O - C / S (STOCK-RAIL)",
    fr: "CONTRE-AIGUILLE C/O - C/S (STOCK-RAIL)",
  },
  "COUNTER-NEEDLE C / E - C / N (STOCK-RAIL)": {
    en: "COUNTER-NEEDLE C / E - C / N (STOCK-RAIL)",
    es: "CONTRA-AGUJA C / E - C / N (STOCK-RAIL)",
    fr: "CONTRE-AIGUILLE C/E - C/N (STOCK-RAIL)",
  },
  "SPACING RODS (RODS)": {
    en: "SPACING RODS (RODS)",
    es: "VARILLAS ESPACIADORAS (VARILLAS)",
    fr: "TRINGLES D'ÉCARTEMENT (RODS)",
  },
  "SPACING LINK BOLTS(RODS BOLTS)": {
    en: "SPACING LINK BOLTS(RODS BOLTS)",
    es: "PERNOS DE ESLABONES ESPACIADORES",
    fr: "BOULONS DES TRINGLES D'ÉCARTEMENT(RODS BOLTS)",
  },
  PINS: {
    en: "PINS",
    es: "PATAS",
    fr: "GOUPILLES",
  },
  "SLIDING SADDLES (FLAT)": {
    en: "SLIDING SADDLES (FLAT)",
    es: "SILLAS DESLIZANTES (PLANAS)",
    fr: "SELLES DE GLISSEMENT (PLATES)",
  },
  "STUDS AND ATTACHMENT SYSTEM": {
    en: "STUDS AND ATTACHMENT SYSTEM",
    es: "PERNOS Y SISTEMA DE FIJACIÓN",
    fr: "CRAMPONS ET SYSTÈME D'ATTACHE",
  },
  HEART: {
    en: "HEART",
    es: "CORAZÓN",
    fr: "CŒUR",
  },
  "CORE OF GROWTH (FROG)": {
    en: "CORE OF GROWTH (FROG)",
    es: "NÚCLEO DEL CRECIMIENTO (RANA)",
    fr: "CŒUR DE CROISSEMENT (FROG)",
  },
  "BOLTS OF THE GROWTH CORE": {
    en: "BOLTS OF THE GROWTH CORE",
    es: "PERNOS DEL NÚCLEO DE CRECIMIENTO",
    fr: "BOULONS DU CŒUR DE CROISSEMENT",
  },
  "TIP SIDE KEYS WHEELS": {
    en: "TIP SIDE KEYS WHEELS",
    es: "PUNTA LLAVES LATERALES RUEDAS",
    fr: "ROUES TOUCHES CÔTÉ POINTE",
  },
  "WHEELS WING SIDE KEYS": {
    en: "WHEELS WING SIDE KEYS",
    es: "RUEDAS LLAVES LATERALES ALA",
    fr: "ROUES TOUCHES CÔTÉ AILES",
  },
  "CROWD HEART SADDLES (FLAT)": {
    en: "CROWD HEART SADDLES (FLAT)",
    es: "SILLINES CROWD HEART (PLANAS)",
    fr: "SELLES DU CŒUR DE CROISSEMENT (PLATES)",
  },
  "CRAMPONS, ATTACHMENT SYSTEM": {
    en: "CRAMPONS, ATTACHMENT SYSTEM",
    es: "CRAMPONES, SISTEMA DE FIJACIÓN",
    fr: "CRAMPONS, SYSTÈME D'ATTACHE",
  },
  "COUNTER RAIL C / O - C / S (GUARD-RAIL)": {
    en: "COUNTER RAIL C / O - C / S (GUARD-RAIL)",
    es: "CONTRA CARRIL C / O - C / S (GUARD-RAIL)",
    fr: "CONTRE-RAIL C/O - C/S (GUARD-RAIL)",
  },
  "COUNTER RAIL C / E - C / N (GUARD-RAIL)": {
    en: "COUNTER RAIL C / E - C / N (GUARD-RAIL)",
    es: "CONTRA CARRIL C / E - C / N (GUARDARRIL)",
    fr: "CONTRE-RAIL C/E - C/N (GUARD-RAIL)",
  },
  "ADJUST C / O - C / S PROTECTION RATING": {
    en: "ADJUST C / O - C / S PROTECTION RATING",
    es: "AJUSTE CLASIFICACIÓN DE PROTECCIÓN C / O - C / S",
    fr: "AJUSTER COTE DE PROTECTION C/O - C/S",
  },
  "ADJUST PROTECTION RATING C / E - C / N": {
    en: "ADJUST PROTECTION RATING C / E - C / N",
    es: "AJUSTE LA CLASIFICACIÓN DE PROTECCIÓN C / E - C / N",
    fr: "AJUSTER COTE DE PROTECTION C/E - C/N",
  },
  "C / O - C / S COUNTER RAIL BOLTS (GUARD RAIL)": {
    en: "C / O - C / S COUNTER RAIL BOLTS (GUARD RAIL)",
    es: "C / O - PERNOS DE CARRIL CONTRA C / S (CARRIL DE PROTECCIÓN)",
    fr: "BOULONS DU CONTRE-RAIL C/O - C/S (GUARD-RAIL)",
  },
  "C / E - C / N COUNTER RAIL BOLTS (GUARD RAIL)": {
    en: "C / E - C / N COUNTER RAIL BOLTS (GUARD RAIL)",
    es: "C / E - C / N PERNOS DE CARRIL CONTRA (CARRIL DE PROTECCIÓN)",
    fr: "BOULONS DU CONTRE-RAIL C/E - C/N (GUARD-RAIL)",
  },
  "LEVELING AND ALIGNMENT": {
    en: "LEVELING AND ALIGNMENT",
    es: "NIVELACIÓN Y ALINEACIÓN",
    fr: "NIVELLEMENT ET ALIGNEMENT",
  },
  "BALLAST AND SHOULDER CONDITION": {
    en: "BALLAST AND SHOULDER CONDITION",
    es: "ESTADO DE LASTRE Y HOMBROS",
    fr: "ÉTAT DU BALLAST ET DE L'ÉPAULEMENT",
  },
  "LEVELING AND ALIGNMENT (DATA FROM 454)": {
    en: "LEVELING AND ALIGNMENT (DATA FROM 454)",
    es: "NIVELACIÓN Y ALINEACIÓN (DATOS DE 454)",
    fr: "NIVELLEMENT ET ALIGNEMENT (DONNÉES DU 454)",
  },
  "SLEEPING CONDITION (TIES)": {
    en: "SLEEPING CONDITION (TIES)",
    es: "CONDICIÓN PARA DORMIR (LAZOS)",
    fr: "CONDITION DES DORMANTS (TIES)",
  },
  "BEFORE POINTS": {
    en: "BEFORE POINTS",
    es: "ANTES DE LOS PUNTOS",
    fr: "AVANT DES POINTES",
  },
  "BEFORE CROSSING HEART (FROG)": {
    en: "BEFORE CROSSING HEART (FROG)",
    es: "ANTES DE CRUZAR EL CORAZÓN (RANA)",
    fr: "AVANT COEUR DE CROISEMENT (FROG)",
  },
  "INSULATED JOINTS VE C / O - C / S": {
    en: "INSULATED JOINTS VE C / O - C / S",
    es: "JUNTAS AISLADAS VE C / O - C / S",
    fr: "JOINTS ISOLÉS VE C/O - C/S",
  },
  "INSULATED JOINTS VE C / E - C / N": {
    en: "INSULATED JOINTS VE C / E - C / N",
    es: "JUNTAS AISLADAS VE C / E - C / N",
    fr: "JOINTS ISOLÉS VE C/E - C/N",
  },
  "INSULATED GASKETS VP C / O - C / S": {
    en: "INSULATED GASKETS VP C / O - C / S",
    es: "JUNTAS AISLADAS VP C / O - C / S",
    fr: "JOINTS ISOLÉS VP C/O - C/S",
  },
  "INSULATED GASKETS VP C / E - C / N": {
    en: "INSULATED GASKETS VP C / E - C / N",
    es: "JUNTAS AISLADAS VP C / E - C / N",
    fr: "JOINTS ISOLÉS VP C/E - C/N",
  },
  RAIL: {
    en: "RAIL",
    es: "CARRIL",
    fr: "RAIL",
  },
  "OTHER COMPONENTS": {
    en: "OTHER COMPONENTS",
    es: "OTROS COMPONENTES",
    fr: "AUTRES COMPOSANTES",
  },
  "PADLOCKS LOCKED AND IN GOOD CONDITION": {
    en: "PADLOCKS LOCKED AND IN GOOD CONDITION",
    es: "CANDADOS CERRADOS Y EN BUEN ESTADO",
    fr: "CADENAS VÉRROUILLÉ ET EN BON ÉTAT",
  },
  "5 TO 10 FEET BEFORE THE NEEDLES": {
    en: "5 TO 10 FEET BEFORE THE NEEDLES",
    es: "5 A 10 PIES ANTES DE LAS AGUJAS",
    fr: "5 À 10 PIEDS AVANT LES AIGUILLES",
  },
  "V / E AT THE HEEL SPACER": {
    en: "V / E AT THE HEEL SPACER",
    es: "V / E EN EL ESPACIADOR DEL TALÓN",
    fr: "V/E À L'ENTRETOISE DU TALON",
  },
  "V / E AT THE MIDDLE POINT OF THE INTERMEDIATE RAIL": {
    en: "V / E AT THE MIDDLE POINT OF THE INTERMEDIATE RAIL",
    es: "V / E EN EL PUNTO MEDIO DEL RIEL INTERMEDIO",
    fr: "V/E AU POINT MÉDIAN DU RAIL INTERMÉDIAIRE",
  },
  "V / E AFTER THE CROSSING CORE": {
    en: "V / E AFTER THE CROSSING CORE",
    es: "V / E DESPUÉS DEL NÚCLEO CRUZADO",
    fr: "V/E APRÈS LE CŒUR DE CROISEMENT",
  },
  "V / E 20 FEET AFTER THE CROSSING CORE": {
    en: "V / E 20 FEET AFTER THE CROSSING CORE",
    es: "V / E 20 PIES DESPUÉS DEL NÚCLEO QUE CRUCE",
    fr: "V/E 20 PIEDS APRÈS LE CŒUR DE CROISEMENT",
  },
  "V / E 40 FEET AFTER THE CROSSING CORE": {
    en: "V / E 40 FEET AFTER THE CROSSING CORE",
    es: "V / E 40 PIES DESPUÉS DEL NÚCLEO QUE CRUCE",
    fr: "V/E 40 PIEDS APRÈS LE CŒUR DE CROISEMENT",
  },
  "COMMENTS:": {
    en: "COMMENTS:",
    es: "COMENTARIOS:",
    fr: "COMMENTAIRES:",
  },
  "BM CODE": {
    en: "BM CODE",
    es: "CÓDIGO BM",
    fr: "CODE DU BM",
  },
  "BM DATE": {
    en: "BM DATE",
    es: "FECHA BM",
    fr: "DATE DU BM",
  },
  SIGNATURE: {
    en: "SIGNATURE",
    es: "FIRMA",
    fr: "SIGNATURE",
  },
  DATED: {
    en: "DATED",
    es: "CON FECHA DE",
    fr: "DATE",
  },
  "CROWN CORE SECTION": {
    en: "CROWN CORE SECTION",
    es: "SECCIÓN NÚCLEO DE LA CORONA",
    fr: "SECTION DU CŒUR DE CROISSEMENT",
  },
  "GENERAL ASPECT OF SWITCHING": {
    en: "GENERAL ASPECT OF SWITCHING",
    es: "ASPECTO GENERAL DE CONMUTACIÓN",
    fr: "ASPECT GÉNÉRAL DE L'AIGUILLAGE",
  },
  "TRACK DEVIATION": {
    en: "TRACK DEVIATION",
    es: "DESVIACIÓN DE PISTA",
    fr: "ÉCARTEMENT DE LA VOIE",
  },
  "INSPECTION MENSUELLE DES INTERRUPTEURS": {
    en: "MONTHLY INSPECTION OF SWITCHES",
    es: "INSPECCIÓN MENSUAL DE INTERRUPTORES",
    fr: "INSPECTION MENSUELLE DES INTERRUPTEURS",
  },
  "INSPECTION ANNUELLE DES INTERRUPTEURS": {
    en: "ANNUAL INSPECTION OF SWITCHES",
    es: "INSPECCIÓN ANUAL DE INTERRUPTORES",
    fr: "INSPECTION ANNUELLE DES INTERRUPTEURS",
  },
  "TIPS SECTION": {
    en: "TIPS SECTION",
    es: "SECCIÓN DE CONSEJOS",
    fr: "SECTION DES POINTES",
  },
  "is currently assigned to a Team. If you delete this user, this team member will be removed from current team": {
    en: "is currently assigned to a Team. If you delete this user, this team member will be removed from current team",
    es: "Está actualmente asignado a un equipo. Si elimina este usuario, este miembro será removido del equipo actual",
    fr: "est actuellement affecté à une équipe. Si vous supprimez cet utilisateur, ce membre de l'équipe sera supprimé de l'équipe actuelle",
  },
  "is currently leading a Team. If you delete this user, team will no longer exist and team members will need to be re-assigned to a new team":
    {
      en: "is currently leading a Team. If you delete this user, team will no longer exist and team members will need to be re-assigned to a new team",
      es: "Está actualmente liderando un equipo. Si elimina este usuario, el equipo dejará de existir y los miembros deberán ser reasignados a un nuevo equipo",
      fr: "dirige actuellement une équipe. Si vous supprimez cet utilisateur, l'équipe n'existera plus et les membres de l'équipe devront être réaffectés à une nouvelle équipe",
    },
  Notifications: {
    en: "Notifications",
    es: "Notificaciones",
    fr: "Notifications",
  },
  "Email already exist, please use another email": {
    en: "Email already exist, please use another email",
    es: "El correo electrónico ya existe, utilice otro correo electrónico",
    fr: "L'e-mail existe déjà, veuillez utiliser un autre e-mail",
  },
  "Cannot delete user with assigned inspections": {
    en: "Cannot delete user with assigned inspections",
    es: "No se puede eliminar al usuario con inspecciones asignadas",
    fr: "Impossible de supprimer l'utilisateur avec des inspections attribuées",
  },

  "Email is not valid": {
    en: "Email is not valid",
    es: "El correo no es válido",
    fr: "L'email n'est pas valide",
  },
  "Date Repaired": {
    en: "Date Repaired",
    es: "Fecha de reparación",
    fr: "Date de réparation",
  },
  "Line Inspection & Repair Report": {
    en: "Line Inspection & Repair Report",
    es: "Informe de inspección y reparación de línea",
    fr: "Rapport d'inspection et de réparation de ligne",
  },
  "Line Inspection Report": {
    en: "Line Inspection Report",
    es: "Informe de reparación de inspección de línea",
    fr: "Rapport de réparation d'inspection de ligne",
  },
  "Select All": {
    en: "Select All",
    es: "Seleccionar todo",
    fr: "Tout sélectionner",
  },
  "Is this Historical Data": {
    en: "Is this Historical Data",
    es: "Son estos datos históricos",
    fr: "Ces données historiques",
  },
  "This MR has been marked as historical. Saving now will close this MR and cannot be changed later": {
    en: "This MR has been marked as historical. Saving now will close this MR and cannot be changed later",
    es: "Este MR ha sido marcado como histórico. Guardar ahora cerrará este MR y no se puede cambiar más tarde",
    fr: "Ce MR a été marqué comme historique. Enregistrer maintenant fermera ce MR et ne pourra pas être modifié plus tard",
  },
  "Confirm MR To Historical": {
    en: "Confirm MR To Historical",
    es: "Confirmar MR a histórico",
    fr: "Confirmer MR à l'historique",
  },
  "This MR has been marked as historical. Saving now will close this MR and cannot be changed later.": {
    en: "This MR has been marked as historical. Saving now will close this MR and cannot be changed later.",
    es: "Este MR ha sido marcado como histórico. Guardar ahora cerrará este MR y no se puede cambiar más adelante.",
    fr: "Ce MR a été marqué comme historique. Enregistrer maintenant fermera ce MR et ne pourra pas être modifié plus tard.",
  },
  "Do you want to proceed ?": {
    en: "Do you want to proceed ?",
    es: "Quieres proceder ?",
    fr: "Voulez-vous poursuivre ?",
  },
  "Line Inspection and Repair Report": {
    en: "Line Inspection and Repair Report",
    es: "Informe de inspección y reparación de líneas",
    fr: "Rapport d'inspection et de réparation de ligne",
  },
  "Defect / Deficiency Description": {
    en: "Defect / Deficiency Description",
    es: "Descripción del defecto / deficiencia",
    fr: "Description du défaut / défaut",
  },

  Default: {
    en: "Default",
    es: "Defecto",
    fr: "Défaut",
  },
  default: {
    en: "Default",
    es: "Defecto",
    fr: "Défaut",
  },
  "Print Report": {
    en: "Print Report",
    es: "Imprimir reporte",
    fr: "Imprimer le rapport",
  },
  "Length must be greater than or equal to": {
    en: "Length must be greater than or equal to",
    es: "La longitud debe ser mayor o igual a",
    fr: "La longueur doit être supérieure ou égale à",
  },
  "Length must be less than or equal to": {
    en: "Length must be less than or equal to",
    es: "La longitud debe ser menor o igual a",
    fr: "La longueur doit être inférieure ou égale à",
  },
  "Must be greater than or equal to": {
    en: "Must be greater than or equal to",
    es: "Debe ser mayor o igual que",
    fr: "Doit être supérieur ou égal à",
  },
  "Must be less than or equal to": {
    en: "Must be less than or equal to",
    es: "Debe ser menor o igual que",
    fr: "Doit être inférieur ou égal à",
  },
  characters: {
    en: "characters",
    es: "caracteres",
    fr: "personnages",
  },
  "Reports Menu": {
    en: "Reports Menu",
    es: "Menú de informes",
    fr: "Menu Rapports",
  },
  "Switch Reports Menu": {
    en: "Switch Reports Menu",
    es: "Cambiar menú de informes",
    fr: "Changer le menu des rapports",
  },
  "All the children assets of this line will also be deleted": {
    en: "All the children assets of this line will also be deleted",
    es: "Todos los activos secundarios de esta línea también se eliminarán",
    fr: "Tous les éléments enfants de cette ligne seront également supprimés",
  },
  "Apply 213.9b Alert to inspection Template": {
    en: "Apply 213.9b Alert to inspection Template",
    es: "Aplicar alerta 213.9b a la plantilla de inspección",
    fr: "Appliquer l'alerte 213.9b au modèle d'inspection",
  },

  "Expected Alert Time": {
    en: "Expected Alert Time",
    es: "Tiempo de alerta esperado",
    fr: "Temps d'alerte attendu",
  },
  "Expected alert time is in back date, therefore notification will not be generated. For correction, please modify alert settings for this event.":
    {
      en: "Expected alert time is in back date, therefore notification will not be generated. For correction, please modify alert settings for this event.",
      es: "El tiempo de alerta esperado está en la fecha anterior, por lo tanto, no se generará una notificación. Para corregirlo, modifique la configuración de alerta para este evento.",
      fr: "L'heure d'alerte prévue est antérieure à la date, par conséquent, aucune notification ne sera générée. Pour correction, veuillez modifier les paramètres d'alerte pour cet événement.",
    },
  Recipient: {
    en: "Recipient",
    es: "Destinatario",
    fr: "Destinataire",
  },
  "Alert sent.": {
    en: "Alert sent.",
    es: "Alerta enviada.",
    fr: "Alerte envoyée.",
  },
  "Capital Plan": {
    en: "Capital Plan",
    es: "Plan de capital",
    fr: "Plan d'immobilisations",
  },
  "Capital Plan": {
    en: "Capital Plan",
    es: "Planes de capital",
    fr: "Plans d'immobilisations",
  },
  "Assign Maintenance": {
    en: "Assign Maintenance",
    es: "Asignar mantenimiento",
    fr: "Attribuer la maintenance",
  },
  "Edit Capital Plan": {
    en: "Edit Capital Plan",
    es: "Editar plan de capital",
    fr: "Modifier le plan d'immobilisations",
  },
  "Capital Plan Estimate": {
    en: "Capital Plan Estimate",
    es: "Estimación del plan de capital",
    fr: "Estimation du plan d'immobilisations",
  },
  Estimate: {
    en: "Estimate",
    es: "Estimar",
    fr: "Estimation",
  },
  Estimates: {
    en: "Estimates",
    es: "Estimadas",
    fr: "Estimations",
  },
  "to capital plan": {
    en: "to capital plan",
    es: "al plan de capital",
    fr: "au plan d'immobilisations",
  },
  "Capital Plan List": {
    en: "Capital Plan List",
    es: "Lista de planes de capital",
    fr: "Liste des plans d'immobilisations",
  },
  "Add Capital Plan": {
    en: "Add Capital Plan",
    es: "Agregar plan de capital",
    fr: "Ajouter un plan d'immobilisations",
  },
  "Not Assigned": {
    en: "Not Assigned",
    es: "No asignado",
    fr: "Non attribué",
  },
  "Add New Work Order": {
    en: "Add New Work Order",
    es: "Agregar nueva orden de trabajo",
    fr: "Ajouter un nouvel ordre de travail",
  },
  "Work Order Estimate": {
    en: "Work Order Estimate",
    es: "Estimación de la orden de trabajo",
    fr: "Estimation de l'ordre de travail",
  },
  "Work Order Attributes": {
    en: "Work Order Attributes",
    es: "Atributos de la orden de trabajo",
    fr: "Attributs d'ordre de travail",
  },
  "Edit Work Order": {
    en: "Edit Work Order",
    es: "Editar orden de trabajo",
    fr: "Modifier l'ordre de travail",
  },
  "Work Order List": {
    en: "Work Order List",
    es: "Lista de órdenes de trabajo",
    fr: "Liste des bons de travail",
  },
  "Choose Capital Plan": {
    en: "Choose Capital Plan",
    es: "Elija el plan de capital",
    fr: "Choisissez le plan d'immobilisations",
  },
  "Existing capital plan": {
    en: "Existing Capital Plan",
    es: "Plan de Capital Existente",
    fr: "Plan d'immobilisations existant",
  },
  "New capital plan": {
    en: "New Capital Plan",
    es: "Nuevo Plan de Capital",
    fr: "Nouveau plan d'immobilisations",
  },
  "Work Order Detail": {
    en: "Work Order Details",
    es: "Detalles de Orden de Trabajo",
    fr: "Détail de l'ordre de travail",
  },
  Style: {
    en: "Style",
    es: "Estilo",
    fr: "Style",
  },
  "Capital Plans": {
    en: "Capital Plans",
    es: "Planes de capital",
    fr: "Plans d'immobilisations",
  },
  "Capital Plan No": {
    en: "Capital Plan No",
    es: "Plan de capital No",
    fr: "Plan d'immobilisations Non",
  },
  "Asset Updated Successfully": {
    en: "Asset Updated Successfully",
    es: "Activo actualizado con éxito",
    fr: "Élément mis à jour avec succès",
  },
  "Asset Added Successfully": {
    en: "Asset Added Successfully",
    es: "Activo agregado exitosamente",
    fr: "Élément ajouté avec succès",
  },
  "Work Order Created Successfully": {
    en: "Work Order Created Successfully",
    es: "Orden de trabajo creada con éxito",
    fr: "Bon de travail créé avec succès",
  },
  "Work Order Updated Successfully": {
    en: "Work Order Updated Successfully",
    es: "Orden de trabajo actualizada con éxito",
    fr: "Bon de travail mis à jour avec succès",
  },
  "Work Order Removed Successfully": {
    en: "Work Order Removed Successfully",
    es: "Orden de trabajo eliminada con éxito",
    fr: "Bon de travail supprimé avec succès",
  },
  "Capital Plan Created Successfully": {
    en: "Capital Plan Created Successfully",
    es: "Plan de capital creado con éxito",
    fr: "Plan d'immobilisations créé avec succès",
  },
  "Capital Plan Updated Successfully": {
    en: "Capital Plan Updated Successfully",
    es: "Plan de capital actualizado con éxito",
    fr: "Plan d'immobilisations mis à jour avec succès",
  },
  "Capital Plan Removed Successfully": {
    en: "Capital Plan Removed Successfully",
    es: "Plan de capital eliminado con éxito",
    fr: "Plan d'immobilisations supprimé avec succès",
  },
  "No Selected Location": {
    en: "No Selected Location",
    es: "Sin ubicación seleccionada",
    fr: "Aucun emplacement sélectionné",
  },
  "Locations Prefix": {
    en: "Locations Prefix",
    fr: "Préfixe Des Emplacements",
    es: "Prefijo De Ubicaciones",
  },
  Locations: {
    en: "Locations",
    es: "Ubicaciones",
    fr: "Emplacements",
  },
  Prefix: {
    en: "Prefix",
    es: "Prefijo",
    fr: "Préfixe",
  },
  "Start MP": {
    en: "Start MP",
    es: "Iniciar MP",
    fr: "Démarrer MP",
  },
  "End MP": {
    en: "End MP",
    es: "Fin MP",
    fr: "MP de fin",
  },
  "Job Briefing": {
    en: "Job Briefing",
    es: "Informe de Trabajo",
    fr: "Briefing d'emploi",
  },
  "Bulk Print \n All": {
    en: "Bulk Print \n All",
    es: "Impresión masiva \n Todo",
    fr: "Impression groupée \n Tout",
  },
  "app-issue": {
    en: "app-issue",
    es: "Problema de la Aplicación",
    fr: "Problème d'application",
  },
  "Marker Start": {
    en: "Marker Start",
    es: "Marcador de Inicio",
    fr: "Début du Marqueur",
  },
  "Marker End": {
    en: "Marker End",
    es: "Final del Marcador",
    fr: "Fin du Marqueur",
  },
  "MR Number": {
    en: "MR Number",
    es: "Número de MR",
    fr: "Numéro MR",
  },
  "Issue#": {
    en: "Issue#",
    es: "Asunto#",
    fr: "Problème#",
  },
  "Export to CSV": {
    en: "Export to CSV",
    es: "Exportar a CSV",
    fr: "Exporter vers CSV",
  },
  "Defect MP": {
    en: "Defect MP",
    es: "MP Defectuoso",
    fr: "Défaut PM",
  },
  "image not found!": {
    en: "image not found!",
    es: "¡imagen no encontrada!",
    fr: "image non trouvée!",
  },

  Marker: {
    en: "Marker",
    es: "Marcador",
    fr: "Marqueur",
  },
  Complete: {
    en: "Complete",
    fr: "Complet",
    es: "Completo",
  },
  "Hours of Service records for": {
    en: "Hours of Service records for",
    es: "Registros de Horas de Servicio Para",
    fr: "Registres des Heures de Service Pour",
  },
  Maintainer: {
    en: "Maintainer",
    es: "Mantenedor",
    fr: "Mainteneur",
  },
  "Inspector Work": {
    en: "Inspector Work",
    es: "Trabajo de Inspector",
    fr: "Travail d'inspecteur",
  },
  "Days Since Reported": {
    en: "Days Since Reported",
    es: "Días desde que se informó",
    fr: "Jours depuis le signalement",
  },
  Satellite: {
    en: "Satellite",
    es: "Satélite",
    fr: "Satellite",
  },
  Dark: {
    en: "Dark",
    es: "Oscuro",
    fr: "Sombre",
  },
  Light: {
    en: "Light",
    es: "Ligero",
    fr: "Lumière",
  },
  Streets: {
    en: "Streets",
    es: "Calles",
    fr: "Des rues",
  },
  "Missed Test Reports": {
    en: "Missed Test Reports",
    es: "Informes de pruebas perdidas",
    fr: "Rapports de test manqués",
  },
  "Asset Inspection Calendar": {
    en: "Asset Inspection Calendar",
    es: "Calendario de inspección de activos",
    fr: "Calendrier d'inspection des actifs",
  },
  Traversal: {
    en: "Traversal",
    es: "El recorrido",
    fr: "Traversée",
  },
  Search: {
    en: "Search",
    es: "Buscar",
    fr: "Recherche",
  },
  "Report Period": {
    en: "Report Period",
    es: "Período de informe",
    fr: "Période de rapport",
  },
  "Time Period": {
    en: "Time Period",
    es: "Periodo de tiempo",
    fr: "Période de temps",
  },
  Quarter: {
    en: "Quarter",
    es: "Cuarto",
    fr: "Trimestre",
  },
  "Six Month": {
    en: "Six Month",
    es: "Seis meses",
    fr: "Six mois",
  },
  Inspector: {
    en: "Inspector",
    es: "Inspector",
    fr: "Inspecteur",
  },
  "Jan-June": {
    en: "Jan-June",
    es: "enero-junio",
    fr: "Jan-Juin",
  },
  "Missed Tests": {
    en: "Missed Tests",
    es: "Pruebas perdidas",
    fr: "Tests manqués",
  },
  "July-December": {
    en: "July-December",
    es: "julio-diciembre",
    fr: "juillet-décembre",
  },
  "Sub-Division/Yard": {
    en: "Sub-Division/Yard",
    es: "Subdivisión/Patio",
    fr: "Sous-division/cour",
  },
  AssetType: {
    en: "Asset Type",
    es: "Tipo de activo",
    fr: "Type d'actif",
  },
  "Location Identifier": {
    en: "Location Identifier",
    es: "Identificador de ubicación",
    fr: "Identifiant d'emplacement",
  },
  "Lines/Yard": {
    en: "Lines/Yard",
    es: "Líneas/Patio",
    fr: "Lignes/cour",
  },
  "Web Version": {
    en: "Web Version",
    es: "Versión Web",
    fr: "Version Web",
  },
  Customer: {
    en: "Customer",
    es: "Cliente",
    fr: "Client",
  },
  Application: {
    en: "Application",
    es: "Solicitud",
    fr: "Application",
  },
  Migration: {
    en: "Migration",
    es: "Migración",
    fr: "Migration",
  },
  Database: {
    en: "Database",
    es: "Base de datos",
    fr: "Base de données",
  },
  Build: {
    en: "Build",
    es: "Construir",
    fr: "Construire",
  },
  "Defect code": {
    en: "Defect Code",
    es: "Código de defecto",
    fr: "Code défaut",
  },
  "Defect status": {
    en: "Defect Status",
    es: "Estado del defecto",
    fr: "Statut de défaut",
  },
  Original: {
    en: "Original",
    es: "Original",
    fr: "Original",
  },
  Railroad: {
    en: "Railroad",
    es: "Ferrocarril",
    fr: "Chemin de fer",
  },
  "Alert Days Before Expiry": {
    en: "Alert Days Before Expiry",
    es: "Días de alerta antes del vencimiento",
    fr: "Jours d'alerte avant expiration",
  },
  "Configure Assets": {
    en: "Configure Assets",
    es: "Configurar activos",
    fr: "Configurer les actifs",
  },
  "Instruction files": {
    en: "Instruction files",
    es: "Archivos de instrucciones",
    fr: "Fichiers d'instructions",
  },
  "Expiry Status Alert Span": {
    en: "Expiry Status Alert Span",
    es: "Período de alerta de estado de caducidad",
    fr: "Période d'alerte d'état d'expiration",
  },
  "No files available": {
    en: "No files available",
    es: "No hay archivos disponibles",
    fr: "Aucun fichier disponible",
  },
  Preview: {
    en: "Preview",
    es: "Avance",
    fr: "Aperçu",
  },
  "Add Alert": {
    en: "Add Alert",
    es: "Agregar Alerta",
    fr: "Ajouter une alerte",
  },
  "Alert Days": {
    en: "Alert Days",
    es: "Días de alerta",
    fr: "Jours d'alerte",
  },
  Users: {
    en: "Users",
    es: "Usuarios",
    fr: "Utilisateurs",
  },
  "Override Primary Track (Optional): ": {
    en: "Override Primary Track (Optional): ",
    es: "Sobrescribir Vía Principal (Opcional):",
    fr: "Remplacer la voie principale (facultatif):",
  },
  "Run Start": {
    en: "Run Start",
    es: "Ejecutar Inicio",
    fr: "Exécuter Démarrer",
  },
  "Run End": {
    en: "Run End",
    es: "Ejecutar Fin",
    fr: "Exécuter Fin",
  },
  "Production date": {
    en: "Production date",
    es: "Fecha de producción",
    fr: "Date de production",
  },
  "Allow audible alerts in mobile app ": {
    en: "Allow audible alerts in mobile app",
    es: "Permitir alertas audibles en la aplicación móvil",
    fr: "Autoriser les alertes sonores dans l'application mobile",
  },
  "Make job briefing mandatory for inspection/maintenance": {
    en: "Make job briefing mandatory for inspection/maintenance",
    es: "Hacer que la información sobre el trabajo sea obligatoria para la inspección/mantenimiento",
    fr: "Rendre le briefing obligatoire pour l'inspection/la maintenance",
  },
  "Show N/A option for traverse in app": {
    en: "Show N/A option for traverse in app",
    es: "Mostrar opción N/A para poligonal en la aplicación",
    fr: "Afficher l'option N/A pour la traversée dans l'application",
  },
  "Default observe": {
    en: "Default observe",
    es: "Observación predeterminada",
    fr: "Observer par défaut",
  },
  "Working Week Days": {
    en: "Working Week Days",
    es: "Días laborables de la semana",
    fr: "Jours ouvrables de la semaine",
  },
  "Off Week Days": {
    en: "Off Week Days",
    es: "Días de descanso",
    fr: "Hors semaine",
  },
  "Default traverse by": {
    en: "Default traverse by",
    es: "Poligonal por defecto por",
    fr: "Traversée par défaut par",
  },
  "Schedule Start Date": {
    en: "Schedule Start Date",
    es: "Programar fecha de inicio",
    fr: "Date de début de l'horaire",
  },
  "Form Name": {
    en: "Form Name",
    es: "Nombre del formulario",
    fr: "Nom de forme",
  },
  "Assets Tests Configuration": {
    en: "Assets Tests Configuration",
    es: "Configuración de pruebas de activos",
    fr: "Configuration des tests d'actifs",
  },
  "Select all": {
    en: "Select all",
    es: "Seleccionar todo",
    fr: "Tout sélectionner",
  },
  "GeoJSON File": {
    en: "GeoJSON File",
    es: "Archivo GeoJSON",
    fr: "Fichier GeoJSON",
  },
  "GeoJSON Cord": {
    en: "GeoJSON Coordinate",
    es: "Coordenada GeoJSON",
    fr: "Coordonnée GeoJSON",
  },
  LEGEND: {
    en: "LEGEND",
    es: "LEYENDA",
    fr: "LÉGENDE",
  },
  Legend: {
    en: "LEGEND",
    es: "LEYENDA",
    fr: "LÉGENDE",
  },
  "No user selected": {
    en: "No user selected",
    es: "Ningún usuario seleccionado",
    fr: "Aucun utilisateur sélectionné",
  },
  name: {
    en: "name",
    es: "nombre",
    fr: "nom",
  },
  "Failed to load some images in the report.": {
    en: "Failed to load some images in the report.",
    es: "Error al cargar algunas imágenes en el informe.",
    fr: "Échec du chargement de certaines images dans le rapport.",
  },
  Role: {
    en: "Role",
    es: "Role",
    fr: "Rôle",
  },
  "Successfully exported": {
    en: "Successfully exported ",
    es: "Exportation réussie de ",
    fr: "Successfully exported ",
  },
  "records to": {
    en: "records to",
    es: "registros a",
    fr: "records to",
  },
  "No Records Available": {
    en: "No Records Available",
    es: "No hay registros disponibles",
    fr: "Aucun enregistrement disponible",
  },
  Parent: {
    en: "Parent",
    es: "Padre",
    fr: "Parent",
  },
  // hours of service Start
  "My Hours of Service": {
    en: "My Hours of Service",
    es: "Mis Horas de Servicio",
    fr: "Mes Heures de Service",
  },
  "Report Off Duty": {
    en: "Report Off Duty",
    es: "Reportarse Fuera de Servicio",
    fr: "Signaler hors Service",
  },
  "Location Manager": {
    en: "Location Manager",
    es: "Gerente de Locación",
    fr: "Gestionnaire d'Emplacement",
  },
  "Activities List": {
    en: "Activities List",
    es: "Lista de Actividades",
    fr: "Liste des Activités",
  },
  "Configure Users": {
    en: "Configure Users",
    es: "Configurar Usuarios",
    fr: "Configurer les Utilisateurs",
  },
  "HOS Status": {
    en: "HOS Status",
    es: "Estado de HOS",
    fr: "Statut de la SHO",
  },
  "Search Reports": {
    en: "Search Reports",
    es: "Informes de Búsqueda",
    fr: "Rapports de Recherche",
  },
  Back: {
    en: "Back",
    es: "Atrás",
    fr: "Dos",
  },
  Missing: {
    en: "Missing",
    es: "Desaparecido",
    fr: "Manquant",
  },
  Submitted: {
    en: "Submitted",
    es: "Enviado",
    fr: "Soumis",
  },
  Vacation: {
    en: "Vacation",
    es: "Vacation",
    fr: "Vacation",
  },
  "Extended Leave": {
    en: "Extended Leave",
    es: "Extended Leave",
    fr: "Extended Leave",
  },
  "In Progress": {
    en: "In Progress",
    es: "En Curso",
    fr: "En Cours",
  },
  "Add Off Days": {
    en: "Add Off Days",
    es: "Agregar Días Libres",
    fr: "Ajouter Des Jours de Repos",
  },
  "Select Input Mode": {
    en: "Select Input Mode",
    es: "Seleccione el modo de entrada",
    fr: "Sélectionnez le mode d'entrée",
  },
  "Add Activity": {
    en: "Add Activity",
    es: "Agregar actividad",
    fr: "Ajouter une activité",
  },
  Review: {
    en: "Review",
    es: "Revisar",
    fr: "Examen",
  },
  Done: {
    en: "Done",
    es: "Hecho",
    fr: "Fait",
  },
  "Hours of Service": {
    en: "Hours of Service",
    es: "Horas de Servicio",
    fr: "Heures de service",
  },
  "Service Type": {
    en: "Service Type",
    es: "Tipo de Servicio",
    fr: "Type de services",
  },
  "Covered Service": {
    en: "Covered Service",
    es: "Covered Service",
    fr: "Covered Service",
  },
  "Non-covered Service": {
    en: "Non-covered Service",
    es: "Non-covered Service",
    fr: "Non-covered Service",
  },
  "Off Duty": {
    en: "Off Duty",
    es: "Off Duty",
    fr: "Off Duty",
  },
  "Activity Type": {
    en: "Activity Type",
    es: "Tipo de actividad",
    fr: "Type d'activité",
  },
  "Total Time": {
    en: "Total Time",
    es: "Tiempo Total",
    fr: "Temps total",
  },
  "Select from saved templates": {
    en: "Select from saved templates",
    es: "Seleccionar de plantillas guardadas",
    fr: "Sélectionnez parmi les modèles enregistrés",
  },
  or: {
    en: "or",
    es: "o",
    fr: "ou",
  },
  "Enter Manually": {
    en: "Enter Manually",
    es: "Ingresar manualmente",
    fr: "Entrer manuellement",
  },
  "Template Name": {
    en: "Template Name",
    es: "Nombre de la plantilla",
    fr: "Nom du modèle",
  },
  "Created on": {
    en: "Created on",
    es: "Creado en",
    fr: "Créé sur",
  },
  "Updated on": {
    en: "Updated on",
    es: "Actualizado en",
    fr: "Mis à jour le",
  },
  "Previously Served Hours": {
    en: "Previously Served Hours",
    es: "Horas servidas anteriormente",
    fr: "Heures précédemment desservies",
  },
  Activity: {
    en: "Activity",
    es: "Actividad",
    fr: "Activité",
  },
  "Start Date & Time": {
    en: "Start Date & Time",
    es: "Fecha y hora de inicio",
    fr: "Date et heure de début",
  },
  "End Date & Time": {
    en: "End Date & Time",
    es: "Fecha y hora de finalización",
    fr: "Date et heure de fin",
  },
  "Duration (HH:mm)": {
    en: "Duration (HH:mm)",
    es: "Duración (HH:mm)",
    fr: "Durée (HH:mm)",
  },
  "Duty Type": {
    en: "Duty Type",
    es: "Tipo de servicio",
    fr: "Type de service",
  },
  Violations: {
    en: "Violations",
    es: "Violaciones",
    fr: "Infractions",
  },
  "Current Reporting Period": {
    en: "Current Reporting Period",
    es: "Período de informe actual",
    fr: "Période de rapport actuelle",
  },
  "Add HOS Entry": {
    en: "Add HOS Entry",
    es: "Agregar entrada HOS",
    fr: "Ajouter une entrée HOS",
  },
  "Time zone": {
    en: "Time zone",
    es: "Zona horaria",
    fr: "Fuseau horaire",
  },
  HQ: {
    en: "Headquarters",
    es: "Sede",
    fr: "Quartier général",
  },
  Configure: {
    en: "Configure",
    es: "Configurar",
    fr: "Configurer",
  },
  Enable: {
    en: "Enable",
    es: "Permitir",
    fr: "Activer",
  },
  "Configure HOS for the user": {
    en: "Configure HOS for the user",
    es: "Configurar HOS para el usuario",
    fr: "Configurer HOS pour l'utilisateur",
  },
  "HOS User Configurations": {
    en: "HOS User Configurations",
    es: "Configuraciones de usuario HOS",
    fr: "Configurations utilisateur HOS",
  },
  "HOS Status View": {
    en: "HOS Status View",
    es: "Vista de estado de HOS",
    fr: "Affichage de l'état HOS",
  },
  "Fully Rested At": {
    en: "Fully Rested At",
    es: "Totalmente descansado en",
    fr: "Complètement reposé à",
  },
  "Off Duty Status": {
    en: "Off Duty Status",
    es: "Estado fuera de servicio",
    fr: "Statut hors service",
  },
  "Last Time Recorded": {
    en: "Last Time Recorded",
    es: "Última vez grabada",
    fr: "Dernier enregistrement",
  },
  "Employee ID": {
    en: "Employee ID",
    es: "ID de empleado",
    fr: "ID d'employé",
  },
  "Add Duty Time": {
    en: "Add Duty Time",
    es: "Agregar tiempo de servicio",
    fr: "Ajouter du temps de service",
  },
  "Edit Duty Time": {
    en: "Edit Duty Time",
    es: "Editar tiempo de servicio",
    fr: "Modifier le temps de service",
  },
  "Update Duty Time": {
    en: "Update Duty Time",
    es: "Actualizar tiempo de servicio",
    fr: "Mettre à jour le temps de service",
  },
  "Update Duty Location/Activity": {
    en: "Update Duty Location/Activity",
    es: "Actualizar ubicación/actividad de servicio",
    fr: "Mettre à jour le lieu de service/l'activité",
  },
  "Are you sure you want to delete the following entry?": {
    en: "Are you sure you want to delete the following entry?",
    es: "¿Está seguro de que desea eliminar la siguiente entrada?",
    fr: "Voulez-vous vraiment supprimer l'entrée suivante ?",
  },
  Confirm: {
    en: "Confirm",
    es: "Confirmar",
    fr: "Confirmer",
  },
  "End Date": {
    en: "End Date",
    es: "Fecha final",
    fr: "Date de fin",
  },
  "You are currently viewing this chart in": {
    en: "You are currently viewing this chart in",
    es: "Actualmente está viendo este gráfico en",
    fr: "Vous visualisez actuellement ce graphique dans",
  },
  Note: {
    en: "Note",
    es: "Nota",
    fr: "Note",
  },
  "If you have forgotten to enter any time during this period, please click back and correct this record. Once your record is submitted, it cannot be changed.":
    {
      en: "If you have forgotten to enter any time during this period, please click back and correct this record. Once your record is submitted, it cannot be changed.",
      es: "Si olvidó ingresar en algún momento durante este período, haga clic en Atrás y corrija este registro. Una vez que se envía su registro, no se puede cambiar.",
      fr: "Si vous avez oublié d'entrer à n'importe quel moment pendant cette période, veuillez cliquer en arrière et corriger cet enregistrement. Une fois votre dossier soumis, il ne peut plus être modifié.",
    },
  "you are affirming that you have entered all time served between": {
    en: "you are affirming that you have entered all time served between",
    es: "está afirmando que ha ingresado todo el tiempo cumplido entre",
    fr: "vous affirmez que vous avez entré tout le temps servi entre",
  },
  "By clicking confirm": {
    en: "By clicking confirm",
    es: "Al hacer clic en confirmar",
    fr: "En cliquant sur valider",
  },
  "Please confirm that the hours of service records being submitted are correct. Your duty tour is being checked for compliance with FRA regulations.":
    {
      en: "Please confirm that the hours of service records being submitted are correct. Your duty tour is being checked for compliance with FRA regulations.",
      es: "Confirme que los registros de horas de servicio que se envían son correctos. Se está comprobando que su turno de servicio cumpla con las normas de la FRA.",
      fr: "Veuillez confirmer que les relevés d'heures de service soumis sont corrects. Votre tour de service est en cours de vérification pour la conformité aux réglementations de la FRA.",
    },
  "Commingled Service Comments": {
    en: "Commingled Service Comments",
    es: "Comentarios de servicio mezclados",
    fr: "Commentaires de service mélangés",
  },
  Compliance: {
    en: "Compliance",
    es: "Cumplimiento",
    fr: "Conformité",
  },
  "Confirm compliance issues": {
    en: "Confirm compliance issues",
    es: "Confirmar problemas de cumplimiento",
    fr: "Confirmer les problèmes de conformité",
  },
  "Cannot load the template due to overlapping activities.": {
    en: "Cannot load the template due to overlapping activities.",
    es: "No se puede cargar la plantilla debido a actividades superpuestas.",
    fr: "Impossible de charger le modèle en raison d'activités qui se chevauchent.",
  },
  "One or more of your reported periods is in violation of FRA Hours of Service regulations.": {
    en: "One or more of your reported periods is in violation of FRA Hours of Service regulations.",
    es: "Uno o más de sus períodos informados infringen las normas de horas de servicio de la FRA.",
    fr: "Une ou plusieurs de vos périodes signalées sont en violation des réglementations sur les heures de service de la FRA.",
  },
  "You need a Supervisor to add reason for violations.": {
    en: "You need a Supervisor to add reason for violations.",
    es: "Necesita un Supervisor para agregar la razón de las violaciones.",
    fr: "Vous avez besoin d'un superviseur pour ajouter la raison des violations.",
  },
  "Reason (to be filled by the Supervisor)": {
    en: "Reason (to be filled by the Supervisor)",
    es: "Motivo (a ser llenado por el Supervisor)",
    fr: "Raison (à remplir par le Superviseur)",
  },
  Supervisor: {
    en: "Supervisor",
    es: "Supervisor",
    fr: "Superviseur",
  },
  "Note: Unsaved changes will be permanently lost!": {
    en: "Note: Unsaved changes will be permanently lost!",
    es: "Nota: ¡Los cambios no guardados se perderán de forma permanente!",
    fr: "Remarque : Les modifications non enregistrées seront définitivement perdues !",
  },
  "Are you sure you want to discard unsaved changes for current reporting period?": {
    en: "Are you sure you want to discard unsaved changes for current reporting period?",
    es: "¿Está seguro de que desea descartar los cambios no guardados para el período de informe actual?",
    fr: "Voulez-vous vraiment supprimer les modifications non enregistrées pour la période de rapport en cours ?",
  },
  "Confirm Discard": {
    en: "Confirm Discard",
    es: "Confirmar Descartar",
    fr: "Confirmer le rejet",
  },
  "Please provide reason for all the violations.": {
    en: "Please provide reason for all the violations.",
    es: "Proporcione el motivo de todas las infracciones.",
    fr: "Veuillez fournir la raison de toutes les violations.",
  },
  "HOS records invalidated!": {
    en: "HOS records invalidated!",
    es: "¡Registros HOS invalidados!",
    fr: "Enregistrements HOS invalidés !",
  },
  "Search HOS Reports": {
    en: "Search HOS Reports",
    es: "Buscar informes HOS",
    fr: "Rechercher des rapports HOS",
  },
  "View non-compliant records": {
    en: "View non-compliant records",
    es: "Ver registros no conformes",
    fr: "Afficher les enregistrements non conformes",
  },
  "Activity Note": {
    en: "Activity Note",
    es: "Nota de actividad",
    fr: "Remarque sur l'activité",
  },
  "Exceeded 12 hours of consecutive time on duty.": {
    en: "Exceeded 12 hours of consecutive time on duty.",
    es: "Excedió 12 horas de tiempo consecutivo en servicio.",
    fr: "A dépassé 12 heures consécutives de temps de service.",
  },
  "24 hour period served with less than 10 continuous hours off-duty.": {
    en: "24 hour period served with less than 10 continuous hours off-duty.",
    es: "Período de 24 horas servido con menos de 10 horas continuas fuera de servicio.",
    fr: "Période de 24 heures servie avec moins de 10 heures continues de repos.",
  },
  "User is not configured for HOS.": {
    en: "User is not configured for HOS.",
    es: "El usuario no está configurado para HOS.",
    fr: "L'utilisateur n'est pas configuré pour HOS.",
  },
  "Search period start date should not be after the end date.": {
    en: "Search period start date should not be after the end date.",
    es: "La fecha de inicio del período de búsqueda no debe ser posterior a la fecha de finalización.",
    fr: "La date de début de la période de recherche ne doit pas être postérieure à la date de fin.",
  },
  "Showing report for": {
    en: "Showing report for",
    es: "Mostrando informe para",
    fr: "Affichage du rapport pour",
  },
  "records from": {
    en: "records from",
    es: "registros de",
    fr: "enregistrements de",
  },
  to: {
    en: "to",
    es: "a",
    fr: "pour",
  },
  Results: {
    en: "Results",
    es: "Resultados",
    fr: "Résultats",
  },
  "No records found": {
    en: "No records found",
    es: "No se encontraron registros",
    fr: "Aucun enregistrement trouvé",
  },
  "View Report": {
    en: "View Report",
    es: "Vista del informe",
    fr: "Voir le rapport",
  },
  "Hours of Service reported for this day. ": {
    en: "Hours of Service reported for this day. ",
    es: "Horas de Servicio reportadas para este día. ",
    fr: "Heures de service déclarées pour cette journée. ",
  },
  "No Hours of Service records found matching this criteria for this day.": {
    en: "No Hours of Service records found matching this criteria for this day.",
    es: "No se encontraron registros de horas de servicio que coincidan con los criterios para este día.",
    fr: "Aucun enregistrement d'heures de service trouvé correspondant aux critères pour cette journée.",
  },
  "No Hours of service reported for this day.": {
    en: "No Hours of service reported for this day.",
    es: "No se reportaron Horas de servicio para este día.",
    fr: "Aucune heure de service signalée pour ce jour.",
  },
  "Non-compliant": {
    en: "Non-compliant",
    es: "No conforme",
    fr: "Non conforme",
  },
  "Browse Rest Locations": {
    en: "Browse Rest Locations",
    es: "Examinar ubicaciones de descanso",
    fr: "Parcourir les lieux de repos",
  },
  "Add New Rest Location": {
    en: "Add New Rest Location",
    es: "Agregar nueva ubicación de descanso",
    fr: "Ajouter un nouveau lieu de repos",
  },
  "Designated Terminal": {
    en: "Designated Terminal?",
    es: "¿Terminal Designada?",
    fr: "Terminal désigné ?",
  },
  "Make HQ": {
    en: "Make HQ",
    es: "Hacer sede",
    fr: "Faire du QG",
  },
  "Edit Rest Location": {
    en: "Edit Rest Location",
    es: "Editar ubicación de descanso",
    fr: "Modifier l'emplacement de repos",
  },
  "Are you sure you want to delete the following Location?": {
    en: "Are you sure you want to delete the following Location?",
    es: "¿Está seguro de que desea eliminar la siguiente ubicación?",
    fr: "Voulez-vous vraiment supprimer l'emplacement suivant ?",
  },
  Division: {
    en: "Division",
    es: "División",
    fr: "Division",
  },
  State: {
    en: "State",
    es: "Estado",
    fr: "État",
  },
  City: {
    en: "City",
    es: "Ciudad",
    fr: "Ville",
  },
  "Add Off Duty": {
    en: "Add Off Duty",
    es: "Añadir fuera de servicio",
    fr: "Ajouter hors service",
  },
  "Duration (Days)": {
    en: "Duration (Days)",
    es: "Duración (Días)",
    fr: "Durée (jours)",
  },
  "Entered At": {
    en: "Entered At",
    es: "Ingresado en",
    fr: "Entré à",
  },

  // HOS End
  // Line  Inspection and Repair Report
  "Line Inspection and Repair Report": {
    en: "Line Inspection and Repair Report",
    es: "Informe de inspección y reparación de línea",
    fr: "Rapport d'inspection et de réparation de la ligne",
  },
  Date: {
    en: "Date",
    es: "Fecha",
    fr: "Date",
  },
  Line: {
    en: "Line",
    es: "Línea",
    fr: "Ligne",
  },
  Weather: {
    en: "Weather",
    es: "Clima",
    fr: "La météo",
  },
  "Inspection Type": {
    en: "Inspection Type",
    es: "Tipo de inspección",
    fr: "Type d'inspection",
  },
  Required: {
    en: "Required",
    es: "Requerida",
    fr: "Obligatoire",
  },
  Special: {
    en: "Special",
    es: "Especial",
    fr: "Spécial",
  },
  Inspector: {
    en: "Inspector",
    es: "Inspector",
    fr: "Inspecteur",
  },
  Track: {
    en: "Track",
    es: "Pista",
    fr: "Piste",
  },
  From: {
    en: "From",
    es: "desde",
    fr: "De",
  },
  To: {
    en: "To",
    es: "A",
    fr: "Pour",
  },

  Walking: {
    en: "Walking",
    es: "Caminar",
    fr: "En marchant",
  },
  Train: {
    en: "Train",
    es: "Tren",
    fr: "Former",
  },
  Observe: {
    en: "Observe",
    es: "Observar",
    fr: "Observer",
  },
  Asset: {
    en: "Asset",
    es: "Activo",
    fr: "Actif",
  },
  Def: {
    en: "Def",
    es: "Def",
    fr: "Déf",
  },
  Code: {
    en: "Code",
    es: "Código",
    fr: "Code",
  },
  Defect: {
    en: "Defect",
    es: "Defecto",
    fr: "Défaut",
  },
  "Defect / Deficiency Description": {
    en: "Defect / Deficiency Description",
    es: "Descripción del defecto / deficiencia",
    fr: "Description du défaut / défaut",
  },
  "Remedial Action / Comments": {
    en: "Remedial Action / Comments",
    es: "Acción correctiva/Comentarios",
    fr: "Action corrective / Commentaires",
  },
  Maintainer: {
    en: "Maintainer",
    es: "Mantenedor",
    fr: "Mainteneur",
  },

  rail: {
    en: "Rail",
    es: "Rail",
    fr: "Rail",
  },
  Signature: {
    en: "Signature",
    es: "Firma",
    fr: "Signature",
  },
  Repaired: {
    en: "Repaired",
    es: "Reparado",
    fr: "Réparé",
  },
  Comments: {
    en: "Comments",
    es: "Comentarios",
    fr: "Commentaires",
  },
  "Inspector Signature": {
    en: "Inspector Signature",
    es: "Firma del inspector",
    fr: "Signature de l'inspecteur",
  },
  "No Exceptions": {
    en: "No Exceptions",
    es: "Sin Excepciones",
    fr: "Aucune Exception",
  },
  "Additional Comments": {
    en: "Additional Comments",
    es: "Comentarios adicionales",
    fr: "Commentaires Supplémentaires",
  },
  "No Exception Found": {
    en: "No Exception Found",
    es: "No se encontró ninguna excepción",
    fr: "Aucune exception trouvée",
  },
  NOTE: {
    en: "Note",
    es: "Nota",
    fr: "Remarque",
  },
  // Line  Inspection and Repair Report End

  // DETAILED MAINLINE TURNOUT INSPECTION
  "DETAILED MAINLINE TURNOUT INSPECTION FORM": {
    en: "DETAILED MAINLINE TURNOUT INSPECTION FORM",
    es: "FORMULARIO DE INSPECCIÓN DETALLADA DE LA CONDUCCIÓN PRINCIPAL",
    fr: "FORMULAIRE DÉTAILLÉ D'INSPECTION DE LIGNE PRINCIPALE",
  },
  Left: {
    en: "Left",
    es: "Izquierdo",
    fr: "Gauche",
  },
  Right: {
    en: "Right",
    es: "Derecho",
    fr: "Droit",
  },
  "Inspection date": {
    en: "Inspection date",
    es: "Fecha de inspección",
    fr: "Date d'inspection",
  },
  "Type of Turnout": {
    en: "Type of Turnout",
    es: "Tipo de participación",
    fr: "Type de participation",
  },
  "Inspected By": {
    en: "Inspected By",
    es: "Revisado por",
    fr: "Inspecté par",
  },
  "Rail Size": {
    en: "Rail Size",
    es: "Tamaño del riel",
    fr: "Taille des rails",
  },
  "Turnout Name and MLG": {
    en: "Turnout Name and MLG",
    es: "Nombre de participación y MLG",
    fr: "Nom de l'aiguillage et MLG",
  },
  Samson: {
    en: "Samson",
    es: "Sansón",
    fr: "Samson",
  },
  Signature: {
    en: "Signature",
    es: "Firma",
    fr: "Signature",
  },
  "Please indicate Good, Fair or Poor": {
    en: "Please indicate Good, Fair or Poor",
    es: "Por favor indique Bueno, Regular o Malo",
    fr: "Veuillez indiquer Bon, Passable ou Mauvais",
  },
  "Ballast & Drainage": {
    en: "Ballast & Drainage",
    es: "Lastre y Drenaje",
    fr: "Lestage et drainage",
  },
  Gauge: {
    en: "Gauge",
    es: "Indicador",
    fr: "Jauge",
  },
  Line: {
    en: "Line",
    es: "Línea",
    fr: "Doubler",
  },
  Main: {
    en: "Main",
    es: "Principal",
    fr: "Principal",
  },
  Siding: {
    en: "Siding",
    es: "Vía muerta",
    fr: "Bardage",
  },
  Surface: {
    en: "Surface",
    es: "Superficie",
    fr: "Surface",
  },
  Ties: {
    en: "Ties",
    es: "Corbatas",
    fr: "Cravates",
  },
  Plates: {
    en: "Plates",
    es: "Platos",
    fr: "Assiettes",
  },
  Rails: {
    en: "Rails",
    es: "Rieles",
    fr: "Des rails",
  },
  "Cotter Pins": {
    en: "Cotter Pins",
    es: "Pasadores de chaveta",
    fr: "Goupilles fendues",
  },
  Bolts: {
    en: "Bolts",
    es: "Pernos",
    fr: "Boulons",
  },
  "Rail Braces": {
    en: "Rail Braces",
    es: "Tirantes de riel",
    fr: "Renforts de rail",
  },
  Type: {
    en: "Type",
    es: "Tipo",
    fr: "Taper",
  },
  Condition: {
    en: "Condition",
    es: "Condición",
    fr: "Condition",
  },
  "Rail Anchors": {
    en: "Rail Anchors",
    es: "Anclajes de riel",
    fr: "Ancres de rail",
  },
  Points: {
    en: "Points",
    es: "Puntos",
    fr: "Points",
  },
  fit: {
    en: "fit",
    es: "adaptar",
    fr: "adapter",
  },
  "Guard Check": {
    en: "Guard Check",
    es: "Control de guardia",
    fr: "Vérification de la garde",
  },
  "Guard Face": {
    en: "Guard Face",
    es: "Cara de guardia",
    fr: "Visage de garde",
  },
  "running surface": {
    en: "running surface",
    es: "superficie de carrera",
    fr: "surface de course",
  },
  "Flangeway Depth": {
    en: "Flangeway Depth",
    es: "Profundidad de paso de brida",
    fr: "Profondeur de l'embase",
  },
  "Heel Block": {
    en: "Heel Block",
    es: "Bloque de talón",
    fr: "Bloc de talon",
  },
  "Switch Locks/Keepers": {
    en: "Switch Locks/Keepers",
    es: "Interruptor de cerraduras/guardianes",
    fr: "Commutateur Serrures/Gâches",
  },
  "Switch Stand": {
    en: "Switch Stand",
    es: "Soporte de interruptor",
    fr: "Support de commutateur",
  },
  Cond: {
    en: "Cond",
    es: "Cond",
    fr: "Condition",
  },
  "Switch Target": {
    en: "Switch Target",
    es: "Cambiar objetivo",
    fr: "Changer de cible",
  },
  "Frog General": {
    en: "Frog General",
    es: "General Rana",
    fr: "Grenouille générale",
  },
  Lubrication: {
    en: "Lubrication",
    es: "Lubricación",
    fr: "Lubrification",
  },
  "Gauge at heel": {
    en: "Gauge at heel",
    es: "Calibre en el talón",
    fr: "Jauge au talon",
  },
  COMMENTS: {
    en: "Comments",
    es: "Comentarios",
    fr: "Commentaires",
  },
  "Point Elevation": {
    en: "Point Elevation",
    es: "Elevación del punto",
    fr: "Altitude du point",
  },
  "ahead of points": {
    en: "ahead of points",
    es: "por delante de los puntos",
    fr: "devant les points",
  },
  "Crosslevel measurements must be taken at locations": {
    en: "Crosslevel measurements must be taken at locations",
    es: "Las mediciones de nivel transversal deben tomarse en ubicaciones",
    fr: "Les mesures transversales doivent être prises à des endroits",
  },
  "apart on both routes throughout the turnout": {
    en: "apart on both routes throughout the turnout",
    es: "separados en ambas vías durante todo el desvío",
    fr: "à part sur les deux routes tout au long de l'aiguillage",
  },
  "All Gauge and Crosslevel measurements should be taken starting at the switch point and moving out.": {
    en: "All Gauge and Crosslevel measurements should be taken starting at the switch point and moving out.",
    es: "Todas las mediciones de calibre y nivel transversal deben tomarse comenzando en el punto de cambio y avanzando hacia afuera.",
    fr: "Toutes les mesures de jauge et de niveau transversal doivent être prises en partant du point de commutation et en se déplaçant.",
  },
  Crosslevel: {
    en: "Crosslevel",
    es: "nivel cruzado",
    fr: "Niveau transversal",
  },
  // End DETAILED MAINLINE TURNOUT INSPECTION

  // Bridge Inspection
  "MONTHLY BRIDGE INSPECTION REPORT": {
    en: "MONTHLY BRIDGE INSPECTION REPORT",
    es: "INFORME MENSUAL DE INSPECCIÓN DE PUENTE",
    fr: "RAPPORT D'INSPECTION MENSUELLE DES PONTS",
  },
  Location: {
    en: "Location",
    es: "Ubicación",
    fr: "Emplacement",
  },
  Asset: {
    en: "Asset",
    es: "Activo",
    fr: "Actif",
  },
  Mileage: {
    en: "Mileage",
    es: "Kilometraje",
    fr: "Kilométrage",
  },
  Date: {
    en: "Date",
    es: "Fecha",
    fr: "Date",
  },
  "ACTION TAKEN BY ROADMASTER": {
    en: "ACTION TAKEN BY ROADMASTER",
    es: "MEDIDAS TOMADAS POR ROADMASTER",
    fr: "MESURES PRISES PAR ROADMASTER",
  },
  "ACTION TAKEN BY INSPECTOR": {
    en: "ACTION TAKEN BY INSPECTOR",
    es: "ACCIÓN TOMADA POR EL INSPECTOR",
    fr: "MESURE PRISE PAR L'INSPECTEUR",
  },
  SATISFACTORY: {
    en: "SATISFACTORY",
    es: "SATISFACTORIO",
    fr: "SATISFAISANT",
  },
  GOOD: {
    en: "GOOD",
    es: "Bueno",
    fr: "BIEN",
  },
  DEFECT: {
    en: "DEFECT",
    es: "DEFECTO",
    fr: "DÉFAUT",
  },
  "LOCATION OF DEFECT": {
    en: "LOCATION OF DEFECT",
    es: "UBICACIÓN DEL DEFECTO",
    fr: "LOCALISATION DU DÉFAUT",
  },
  "BROKEN JOINT BARS": {
    en: "BROKEN JOINT BAR",
    es: "BARRA DE JUNTA ROTA",
    fr: "BARRE DE JOINT CASSÉ",
  },
  "BROKEN RAIL": {
    en: "BROKEN RAIL",
    es: "CARRIL ROTO",
    fr: "RAIL CASSÉ",
  },
  APPROACHES: {
    en: "APPROACHES",
    es: "ENFOQUES",
    fr: "APPROCHES",
  },
  "BRIDGE TIMBERS": {
    en: "BRIDGE TIMBERS",
    es: "MADERA DE PUENTE",
    fr: "BOIS DE PONT",
  },
  "TIE PLATES": {
    en: "TIE PLATES",
    es: "PLACAS DE AMARRE",
    fr: "PLAQUES D'ATTACHE",
  },
  "PULL APART": {
    en: "PULL APART",
    es: "SEPARAR",
    fr: "DÉMONTER",
  },
  "RAIL ANCHORS": {
    en: "RAIL ANCHORS",
    es: "ANCLAJES DE CARRIL",
    fr: "ANCRES DE RAIL",
  },
  RUST: {
    en: "RUST",
    es: "ÓXIDO",
    fr: "ROUILLER",
  },
  DEBRIS: {
    en: "DEBRIS",
    es: "ESCOMBROS",
    fr: "DÉBRIS",
  },
  "WIDE GAUGE": {
    en: "WIDE GAUGE",
    es: "CALIBRE ANCHO",
    fr: "JAUGE LARGE",
  },
  VEGETATION: {
    en: "VEGETATION",
    es: "VEGETACIÓN",
    fr: "VÉGÉTATION",
  },
  "HOOK BOLTS": {
    en: "HOOK BOLTS",
    es: "PERNOS DE GANCHO",
    fr: "BOULONS À CROCHET",
  },
  "RIVETS OR BOLTS": {
    en: "RIVETS OR BOLTS",
    es: "REMACHES O TORNILLOS",
    fr: "RIVETS OU BOULONS",
  },
  "NOT LISTED": {
    en: "NOT LISTED",
    es: "NO ENLISTADO",
    fr: "NON LISTÉ",
  },
  "OVERALL CONDITION OF BRIDGE INCLUDING": {
    en: "OVERALL CONDITION OF BRIDGE INCLUDING",
    es: "ESTADO GENERAL DEL PUENTE INCLUYENDO",
    fr: "ÉTAT GÉNÉRAL DU PONT COMPRENANT",
  },
  "INSPECTOR CORRECTED": {
    en: "INSPECTOR CORRECTED",
    es: "INSPECTEUR CORRIGÉ",
    fr: "INSPECTEUR CORRIGÉ",
  },
  "SLOW ORDER": {
    en: "SLOW ORDER",
    es: "PEDIDO LENTO",
    fr: "COMMANDE LENTE",
  },
  "OUT OF SERVICE": {
    en: "OUT OF SERVICE",
    es: "FUERA DE SERVICIO",
    fr: "HORS SERVICE",
  },
  "DATE CORRECTED": {
    en: "DATE CORRECTED",
    es: "FECHA CORREGIDA",
    fr: "DATE CORRIGEE",
  },
  "REPORT NOTED": {
    en: "REPORT NOTED",
    es: "INFORME NOTADO",
    fr: "RAPPORT NOTÉ",
  },
  "INSPECTED DEFECT": {
    en: "INSPECTED DEFECT",
    es: "DEFECTO INSPECCIONADO",
    fr: "DÉFAUT INSPECTÉ",
  },
  "INSPECTED CORRECTIVE A": {
    en: "INSPECTED CORRECTIVE A",
    es: "INSPECCIONADO CORRECTIVO A",
    fr: "INSPECTÉ CORRECTIF A",
  },

  Superintendent: {
    en: "Superintendent",
    es: "Superintendente",
    fr: "Surveillant général",
  },
  Inspector: {
    en: "Inspector",
    es: "Inspector",
    fr: "Inspecteur",
  },
  Signature: {
    en: "Signature",
    es: "Firma",
    fr: "Signature",
  },
  "BOTTOM BRACINGS": {
    en: "BOTTOM BRACINGS",
    es: "APOYOS INFERIORES",
    fr: "CONTREVENTIONS INFÉRIEURES",
  },
  BENTS: {
    en: "BENTS",
    es: "DOBLECES",
    fr: "PENTES",
  },
  SPANS: {
    en: "SPANS",
    es: "TRAMOS",
    fr: "PORTÉES",
  },
  STIFFENERS: {
    en: "STIFFENERS",
    es: "REFUERZOS",
    fr: "RENFORTS",
  },
  "BOLT MISSING": {
    en: "BOLT MISSING",
    es: "FALTA TORNILLO",
    fr: "BOULON MANQUANT",
  },
  BROKEN: {
    en: "BROKEN",
    es: "CASSÉ",
    fr: "ROTO",
  },

  // End Bridge Inspection
  "": {
    en: "",
    es: "",
    fr: "",
  },
  "": {
    en: "",
    es: "",
    fr: "",
  },
  "": {
    en: "",
    es: "",
    fr: "",
  },

  maintenance: {
    en: "Maintainer",
    es: "Mantenedora",
    fr: "Mainteneur",
  },
  supervisor: {
    en: "Track/Signal Manager",
    es: "Administrador de pistas/señales",
    fr: "Gestionnaire de pistes/signaux",
  },
  admin: {
    en: "Admin",
    es: "Administradora",
    fr: "Administratrice",
  },
  manager: {
    en: "Management",
    es: "Gestión",
    fr: "Gestion",
  },
  inspector: {
    en: "Inspectors",
    es: "Inspectoras",
    fr: "Inspectrices",
  },

  // new additions | 9/5/2023

  "Gallery View": {
    en: "Gallery View",
    es: "Vista de galería",
    fr: "Vue en galerie",
  },
  Summary: {
    en: "Summary",
    es: "Resumen",
    fr: "Résumé",
  },
  Executions: {
    en: "Executions",
    es: "Ejecuciones",
    fr: "Exécutions",
  },
  "Closed By": {
    en: "Closed By",
    es: "Cerrado por",
    fr: "Fermé par",
  },
  "Comments for Report": {
    en: "Comments for Report",
    es: "Comentarios para el informe",
    fr: "Commentaires pour le rapport",
  },
  Images: {
    en: "Images",
    es: "Imágenes",
    fr: "Images",
  },

  "Material Usage CSV": {
    en: "Material Usage CSV",
    es: "Uso de material en formato CSV",
    fr: "Utilisation des matériaux au format CSV",
  },

  "No file chosen": {
    en: "No file chosen",
    es: "Ningún archivo seleccionado",
    fr: "Aucun fichier choisi",
  },

  "Issue reported on": {
    en: "Issue reported on",
    es: "Problema reportado en",
    fr: "Problème signalé le",
  },
  // new added on 9/27/2023 , in link to Line Inspection Report
  // issue list and issue list view
  "Not Repaired": {
    en: "Not Repaired",
    es: "No Reparado",
    fr: "Non Réparé",
  },

  "Slow Order Applied": {
    en: "Slow Order Applied",
    es: "Orden de Precaucion",
    fr: "Ordre lent appliqué",
  },

  "Slow Order Authority #": {
    en: "Slow Order Authority #",
    es: "Número de OP",
    fr: "Numéro d' OP",
  },
  "Speed restricted to:": {
    en: "Speed restricted to:",
    es: "Velocidad de OP:",
    fr: "Vitesse limitée à:",
  },

  "Speed restricted to": {
    en: "Speed restricted to",
    es: "Velocidad de OP",
    fr: "Vitesse limitée à",
  },

  "Track OOS": {
    en: "Track OOS",
    es: "Via Cancelada",
    fr: "Hors service",
  },

  "Track OOS (Out of Service)": {
    en: "Track OOS (Out of Service)",
    es: "Via Cancelada",
    fr: "Hors service",
  },
  "Please Select Asset": {
    en: "Please Select Asset",
    es: "Por favor seleccione activo",
    fr: "Veuillez sélectionner un actif",
  },
  Load: {
    en: "Load",
    es: "Carga",
    fr: "Charge",
  },

  track: {
    en: "track",
    es: "pista",
    fr: "piste",
  },

  "Traverse By": {
    en: "Traverse By",
    es: "Recorrido por",
    fr: "Parcourir par",
  },
  Notes: {
    en: "Notes",
    es: "Notas",
    fr: "Notes",
  },

  "Priority N/A": {
    en: "Priority N/A",
    es: "Prioridad no aplicable",
    fr: "Priorité non applicable",
  },

  East: {
    en: "East",
    es: "Este",
    fr: "Est",
  },
  West: {
    en: "West",
    es: "Oeste",
    fr: "Ouest",
  },
  North: {
    en: "North",
    es: "Norte",
    fr: "Nord",
  },
  South: {
    en: "South",
    es: "Sur",
    fr: "Sud",
  },

  "Rule 213.9(b)": {
    en: "Rule 213.9(b)",
    es: "Regla 213.9(b)",
    fr: "Règle 213.9(b)",
  },

  //in setup staff

  "Employee Number": {
    en: "Employee Number",
    es: "Número de empleado",
    fr: "Numéro d'employé",
  },

  Role: {
    en: "Role",
    es: "Role",
    fr: "Role",
  },
  Administrator: {
    en: "Administrator",
    es: "Administrador",
    fr: "Administrateur",
  },

  Management: {
    en: "Management",
    es: "Gestión",
    fr: "Gestion",
  },
  "Maintenance Team": {
    en: "Maintenance Team",
    es: "Equipo de Mantenimiento",
    fr: "Équipe de Maintenance",
  },
  "Inspection Team": {
    en: "Inspection Team",
    es: "Equipo de Inspección",
    fr: "Équipe d'Inspection",
  },

  //setup list
  "Slow Orders": {
    en: "Slow Orders",
    es: "Órdenes Lentas",
    fr: "Ordres Lents",
  },

  // assets
  Diamond: {
    en: "Diamond",
    es: "Diamante",
    fr: "Diamant",
  },
  "Storage Track": {
    en: "Storage Track",
    es: "Vía de Almacenamiento",
    fr: "Voie de Stockage",
  },
  Turnout: {
    en: "Turnout",
    es: "Desvío",
    fr: "Aiguillage",
  },
  "Hotbox Detector": {
    en: "Hotbox Detector",
    es: "Detector de Cajas Calientes",
    fr: "Détection de Boîtes Chaudes",
  },
  Spur: {
    en: "Spur",
    es: "Vía de Ramal",
    fr: "Voie de Garage",
  },
  "Grade Crossing Warning": {
    en: "Grade Crossing Warning",
    es: "Advertencia de Paso a Nivel",
    fr: "Avertissement de Passage à Niveau",
  },
  "AEI Reader": {
    en: "AEI Reader",
    es: "Lector AEI",
    fr: "Lecteur AEI",
  },
  "Train Radio": {
    en: "Train Radio",
    es: "Radio de Tren",
    fr: "Radio de Train",
  },
  "High Water Detector": {
    en: "High Water Detector",
    es: "Detector de Agua Alta",
    fr: "Détection d'Eau Haute",
  },
  "Main Track": {
    en: "Main Track",
    es: "Vía Principal",
    fr: "Voie Principale",
  },
  "Customer Switch": {
    en: "Customer Switch",
    es: "Interruptor de Cliente",
    fr: "Interrupteur Client",
  },
  "Customer Track": {
    en: "Customer Track",
    es: "Vía de Cliente",
    fr: "Voie Client",
  },

  "Side Track": {
    en: "Side Track",
    es: "Vía Auxiliar",
    fr: "Voie de Déviation",
  },

  //in setup AssetType Tests
  "Ignore calendar boundary": {
    en: "Ignore calendar boundary",
    es: "Ignorar límite de calendario",
    fr: "Ignorer la limite de calendrier",
  },

  // in setup team
  Members: {
    en: "Members",
    es: "Miembros",
    fr: "Membres",
  },
  //in capital plan create/add
  "Enter Name": {
    en: "Enter Name",
    es: "Ingresar Nombre",
    fr: "Entrer le Nom",
  },

  // somewhere in setup

  "Rule 213.9(b) Issue 30day Expiry": {
    en: "Rule 213.9(b) Issue 30day Expiry",
    es: "Regla 213.9(b) Emitir Vencimiento de 30 Días",
    fr: "Règle 213.9(b) Émission d'Expiration de 30 Jours",
  },

  "Location Assignments": {
    en: "Location Assignments",
    es: "Asignaciones de Ubicación",
    fr: "Affectations de Lieu",
  },
  "Assigned Locations Count": {
    en: "Assigned Locations Count",
    es: "Cantidad de Ubicaciones Asignadas",
    fr: "Nombre de Lieux Assignés",
  },

  //in add asset
  "Bulk Import Assets": {
    en: "Bulk Import Assets",
    es: "Importación Masiva de Activos",
    fr: "Importation en Vrac des Actifs",
  },

  "Import Children": {
    en: "Import Children",
    es: "Importar Hijos",
    fr: "Importer les Enfants",
  },
  "Export Children": {
    en: "Export Children",
    es: "Exportar Hijos",
    fr: "Exporter les Enfants",
  },

  "Import Assets": {
    en: "Import Assets",
    es: "Importar Activos",
    fr: "Importer les Actifs",
  },

  "CSV File": {
    en: "CSV File",
    es: "Archivo CSV",
    fr: "Fichier CSV",
  },
  "Select Columns": {
    en: "Select Columns",
    es: "Seleccionar Columnas",
    fr: "Sélectionner les Colonnes",
  },
  "Skip first row": {
    en: "Skip first row",
    es: "Omitir primera fila",
    fr: "Ignorer la première ligne",
  },
  "Ignore Empty Rows": {
    en: "Ignore Empty Rows",
    es: "Ignorar Filas Vacías",
    fr: "Ignorer les Lignes Vides",
  },
  "Import remaining fields": {
    en: "Import remaining fields",
    es: "Importar campos restantes",
    fr: "Importer les champs restants",
  },

  //defect codes

  "Collapse All": {
    en: "Collapse All",
    es: "Contraer Todo",
    fr: "Réduire Tout",
  },
  "Expand All": {
    en: "Expand All",
    es: "Expandir Todo",
    fr: "Développer Tout",
  },

  //other
  "MWO Number": {
    en: "MWO Number",
    es: "Número de MWO",
    fr: "Numéro de MWO",
  },
  "Or Continue With:": {
    en: "Or Continue With:",
    es: "O continuar con:",
    fr: "Ou continuez avec:",
  },
  "Dashboard Summary": {
    en: "Dashboard Summary",
    es: "Resumen del panel",
    fr: "Résumé du tableau de bord",
  },
  "Missed Tests & Inspections Report": {
    en: "Missed Tests & Inspections Report",
    es: "Informe de pruebas e inspecciones fallidas",
    fr: "Rapport sur les tests et inspections manqués",
  },
  "Performed Executions": {
    en: "Performed Executions",
    es: "Ejecuciones realizadas",
    fr: "Exécutions réalisées",
  },
  "Location Activity Summary": {
    en: "Location Activity Summary",
    es: "Resumen de actividad de ubicación",
    fr: "Résumé de l'activité de localisation",
  },
  Jan: {
    en: "Jan",

    fr: "Janv",

    es: "Ene",
  },
  Feb: {
    en: "Feb",
    fr: "Févr",
    es: "Feb",
  },
  Mar: {
    en: "Mar",
    fr: "Mars",
    es: "Mar",
  },
  Apr: {
    en: "Apr",
    fr: "Avr",
    es: "Abr",
  },
  May: {
    en: "May",
    es: "Mayo",
    fr: "Peut",
  },
  Jun: {
    en: "Jun",
    fr: "Juin",
    es: "Jun",
  },
  Jul: {
    en: "Jul",
    fr: "Juil",
    es: "Jul",
  },
  Aug: {
    en: "Aug",
    fr: "Août",
    es: "Ago",
  },
  Sep: {
    en: "Sep",
    fr: "Sept",
    es: "Sep",
  },
  Oct: {
    en: "Oct",
    fr: "Oct",
    es: "Oct",
  },
  Nov: {
    en: "Nov",
    fr: "Nov",
    es: "Nov",
  },
  Dec: {
    en: "Dec",
    fr: "Déc",
    es: "Dic",
  },
  App: {
    en: "App",
    fr: "Application",
    es: "Aplicación",
  },
  Web: {
    en: "Web",
    fr: "Web",
    es: "Web",
  },
  "Mile Post": {
    en: "Mile Post",
    fr: "Poste kilométrique",
    es: "Poste de milla",
  },
  "View Details": {
    en: "View Details",
    fr: "Afficher les détails",
    es: "Ver detalles",
  },
  "Signal Manager Comments": {
    en: "Signal Manager Comments",
    fr: "Commentaires du gestionnaire de signaux",
    es: "Comentarios del administrador de señales",
  },
  "Track Manager Comments": {
    en: "Track Manager Comments",
    fr: "Commentaires du gestionnaire de suivi",
    es: "Comentarios del administrador de seguimiento",
  },
  "WO Reports": {
    en: "WO Reports",
    fr: "Rapports WO",
    es: "Informes de WO",
  },
  "Perform Maintenance Execution": {
    en: "Perform Maintenance Execution",
    fr: "Exécution de la maintenance",
    es: "Realizar la ejecución del mantenimiento",
  },
  "Work Order Report": {
    en: "Work Order Report",
    fr: "Rapport de bon de travail",
    es: "Informe de orden de trabajo",
  },
  "Work Gang CSV": {
    en: "Work Gang CSV",
    fr: "CSV du groupe de travail",
    es: "Equipo de trabajo CSV",
  },
  "Work Order Reports": {
    en: "Work Order Reports",
    fr: "Rapports de bons de travail",
    es: "Informes de órdenes de trabajo",
  },
  "Work Order Summary Report": {
    en: "Work Order Summary Report",
    es: "Informe Resumen de Reparación",
    fr: "Rapport Résumé de Réparation",
  },
  "Photos of Observation:": {
    en: "Photos of Observation",
    es: "Fotos de Observación:",
    fr: "Photos d’Observation :",
  },
  "Work Order Information": {
    en: "Work Order Information",
    fr: "Commentaires du responsable de la maintenance :",
    es: "Comentarios del mantenedor:",
  },
  "Performed By": {
    en: "Performed By",
    fr: "Interprété par",
    es: "Realizado por",
  },
  "Photos of Repair:": {
    en: "Photos of Repair:",
    fr: "Photos de réparation",
    es: "Fotos de Reparación",
  },
  "Signature Required": {
    en: "Signature Required",
    fr: "Signature requise",
    es: "Firma requerida",
  },
  "You need to upload your profile signature to continue. Please download/install the mobile app and add your signature to proceed.": {
    en: "You need to upload your profile signature to continue. Please download/install the mobile app and add your signature to proceed.",
    fr: "Vous devez ajouter votre signature de profil pour continuer. Veuillez télécharger/installer l'application mobile et ajouter votre signature pour poursuivre.",
    es: "Necesitas subir tu firma de perfil para continuar. Descarga/instala la aplicación móvil y añade tu firma para continuar.",
  },
  " If you have already added the profile signature in mobile app, please re-login to web app in order to proceed with the work order execution.":
    {
      en: " If you have already added the profile signature in mobile app, please re-login to web app in order to proceed with the work order execution.",
      fr: "Si vous avez déjà ajouté la signature de profil dans l'application mobile, veuillez vous reconnecter à l'application Web afin de poursuivre l'exécution de l'ordre de travail.",
      es: "Si ya ha agregado la firma de perfil en la aplicación móvil, vuelva a iniciar sesión en la aplicación web para continuar con la ejecución de la orden de trabajo.",
    },
  "Pending Review": {
    en: "Pending Review",
    fr: "En attente d'examen",
    es: "Revisión pendiente",
  },
  Returned: {
    en: "Returned",
    fr: "Retourné",
    es: "Devuelto",
  },
  "work orders": {
    en: "work orders",
    fr: "ordres de travail",
    es: "órdenes de trabajo",
  },
  "Confirm Removal": {
    en: "Confirm Removal",
    fr: "Confirmer la suppression",
    es: "Confirmar eliminación",
  },
  "Are you sure you want to remove: ": {
    en: "Are you sure you want to remove: ",
    fr: "Êtes-vous sûr de vouloir supprimer :",
    es: "¿Estás seguro de que quieres eliminar? :",
  },
  "Add Form Attribute": {
    en: "Add Form Attribute",
    fr: "Ajouter un attribut de formulaire",
    es: "Agregar atributo de formulario",
  },
  "Field Name": {
    en: "Add Form Attribute",
    fr: "Nom du champ",
    es: "Nombre del campo",
  },
  "Allowed Values": {
    en: "Allowed Values",
    fr: "Valeurs autorisées",
    es: "Valores permitidos",
  },
  "Type any value and press enter": {
    en: "Type any value and press enter",
    fr: "Saisissez une valeur et appuyez sur Entrée.",
    es: "Escriba cualquier valor y presione Enter",
  },
  Add: {
    en: "Add",
    fr: "Ajouter",
    es: "Agregar",
  },
  "Confirm Delete": {
    en: "Confirm Delete",
    fr: "Confirmer la suppression",
    es: "Confirmar eliminación",
  },
  "Note: All children equipment under": {
    en: "Note: All children equipment under",
    fr: "Remarque : Tout équipement pour enfants de moins de 18 ans",
    es: "Nota: Todo el equipo para niños menores de",
  },
  "will also be deleted!": {
    en: "will also be deleted!",
    fr: "sera également supprimé !",
    es: "¡También será eliminado!",
  },
  "Add Equipment": {
    en: "Add Equipment",
    fr: "Ajouter de l'équipement",
    es: "Agregar equipo",
  },
  "Edit Equipment": {
    en: "Edit Equipment",
    fr: "Modifier l'équipement",
    es: "Editar equipo",
  },
  "Equipment Type": {
    en: "Equipment Type",
    es: "Tipo de equipamiento",
    fr: "Type d'équipement",
  },
  "Non-Compliance": {
    en: "Non-Compliance",
    es: "Incumplimiento",
    fr: "Non-conformité",
  },
  "Search Mistaken Reports": {
    en: "Search Mistaken Reports",
    fr: "Recherche de rapports erronés",
    es: "Buscar informes erróneos",
  },
  "Add Location...": {
    en: "Add Location...",
    fr: "Ajouter un emplacement...",
    es: "Agregar ubicación...",
  },
  "Activity Types List": {
    en: "Activity Types List",
    fr: "Liste des types d'activités",
    es: "Lista de tipos de actividades",
  },
  "Associated (Service Types)": {
    en: "Associated (Service Types)",
    fr: "Services associés (Types de services)",
    es: "Asociados (Tipos de servicios)",
  },
  "Add New Activity Type": {
    en: "Add New Activity Type",
    fr: "Ajouter un nouveau type d'activité",
    es: "Agregar nuevo tipo de actividad",
  },
  "Service Types": {
    en: "Service Types",
    fr: "Types de services",
    es: "Tipos de servicio",
  },
  "Is Off Duty": {
    en: "Is Off Duty",
    fr: "Est en congé",
    es: "está fuera de servicio",
  },
  Activty: {
    en: "Activty",
    fr: "Activité",
    es: "Actividad",
  },
  "Edit Activity Type": {
    en: "Edit Activity Type",
    fr: "Modifier le type d'activité",
    es: "Editar tipo de actividad",
  },
  "Are you sure you want to delete the following Activity Type?": {
    en: "Are you sure you want to delete the following Activity Type?",
    fr: "Êtes-vous sûr de vouloir supprimer le type d'activité suivant ?",
    es: "¿Está seguro de que desea eliminar el siguiente tipo de actividad?",
  },
  "Add Template": {
    en: "Add Template",
    fr: "Ajouter un modèle",
    es: "Agregar plantilla",
  },
  "Reporting Period": {
    en: "Reporting Period",
    fr: "Période de déclaration",
    es: "Período de informe",
  },
  "Are you sure you want to discard unsaved changes for this template?": {
    en: "Are you sure you want to discard unsaved changes for this template?",
    fr: "Êtes-vous sûr de vouloir supprimer les modifications non enregistrées pour ce modèle ?",
    es: "¿Está seguro de que desea descartar los cambios no guardados para esta plantilla?",
  },
  "Are you sure you want to delete the following Template?": {
    en: "Are you sure you want to delete the following Template?",
    fr: "Êtes-vous sûr de vouloir supprimer le modèle suivant ?",
    es: "¿Está seguro de que desea eliminar la siguiente plantilla?",
  },
  "Details of Service": {
    en: "Details of Service",
    fr: "Détails du service",
    es: "Detalles del servicio",
  },
  Employee: {
    en: "Employee",
    fr: "Employé",
    es: "Empleado",
  },
  Supervisor: {
    en: "Supervisor",
    fr: "Superviseur",
    es: "Supervisor",
  },
  Headquarters: {
    en: "Headquarters",
    fr: "Quartier général",
    es: "Sede",
  },
  Timezone: {
    en: "Timezone",
    fr: "Fuseau horaire",
    es: "Zona horaria",
  },
  "City/State": {
    en: "City/State",
    fr: "Ville/État",
    es: "Ciudad/Estado",
  },

  "Division/Subdivision": {
    en: "Division/Subdivision",
    fr: "Division/Subdivision",
    es: "División/Subdivisión",
  },
  "Image uploaded successfully": {
    en: "Image uploaded successfully",
    fr: "Image téléchargée avec succès",
    es: "Imagen cargada exitosamente",
  },
  "Manage App Form Attributes": {
    en: "Manage App Form Attributes",
    fr: "Gérer les attributs du formulaire d'application",
    es: "Administrar atributos del formulario de la aplicación",
  },
  "Edit Form Attribute": {
    en: "Edit Form Attribute",
    fr: "Modifier l'attribut du formulaire",
    es: "Editar atributo de formulario",
  },
  Begin: {
    en: "Begin",
    fr: "Commencer",
    es: "Comenzar",
  },
  "Total Hours": {
    en: "Total Hours",
    fr: "Heures totales",
    es: "Horas totales",
  },
  "Prior Time Off Duty": {
    en: "Prior Time Off Duty",
    fr: "Congé antérieur",
    es: "Tiempo libre previo",
  },
  "Date Reported": {
    en: "Date Reported",
    fr: "Date de déclaration",
    es: "Fecha reportada",
  },
  "Begin Location": {
    en: "Begin Location",
    fr: "Emplacement de début",
    es: "Ubicación inicial",
  },
  "Approved Supervisor": {
    en: "Approved Supervisor",
    fr: "Superviseur agréé",
    es: "Supervisor aprobado",
  },
  "Prior Off Duty": {
    en: "Prior Off Duty",
    fr: "Avant le congé",
    es: "Fuera de servicio previo",
  },
  "Time Served": {
    en: "Time Served",
    fr: "Temps purgé",
    es: "Tiempo cumplido",
  },
  "Service Chart": {
    en: "Service Chart",
    fr: "Tableau des services",
    es: "Cuadro de servicios",
  },
  "Search Mistaken HOS Reports": {
    en: "Search Mistaken HOS Reports",
    fr: "Recherche de rapports HOS erronés",
    es: "Buscar informes HOS erróneos",
  },
  "Please configure the Start Date for HOS": {
    en: "Please configure the Start Date for HOS",
    fr: "Veuillez configurer la date de début pour les heures de service.",
    es: "Por favor configure la fecha de inicio para HOS",
  },
  "Please select the Time zone in order to proceed!": {
    en: "Please select the Time zone in order to proceed!",
    fr: "Veuillez sélectionner le fuseau horaire pour continuer !",
    es: "¡Por favor seleccione la zona horaria para continuar!",
  },
  "Report Type": {
    en: "Report Type",
    fr: "Type de rapport",
    es: "Tipo de informe",
  },
  "W/O MT Usage Summary CSV": {
    en: "W/O MT Usage Summary CSV",
    fr: "Résumé d'utilisation sans MT (CSV)",
    es: "Resumen de uso de W/O MT CSV",
  },
  "Work Order Material Usage Summary CSV": {
    en: "Work Order Material Usage Summary CSV",
    fr: "Récapitulatif CSV de l'utilisation des matériaux pour les ordres de travail",
    es: "Resumen de uso de material de la orden de trabajo CS",
  },
  "Passwords must match and contain at least 8 characters, 1 number, 1 uppercase letter, 1 lowercase letter, and 1 special character": {
    en: "Passwords must match and contain at least 8 characters, 1 number, 1 uppercase letter, 1 lowercase letter, and 1 special character",
    fr: "Les mots de passe doivent correspondre et contenir au moins 8 caractères, 1 chiffre, 1 lettre majuscule, 1 lettre minuscule et 1 caractère spécial.",
    es: "Las contraseñas deben coincidir y contener al menos 8 caracteres, 1 número, 1 letra mayúscula, 1 letra minúscula y 1 carácter especial.",
  },
  "Leftover Assets": {
    en: "Leftover Assets",
    fr: "Actifs restants",
    es: "Activos sobrantes",
  },
  "Following assets have not been made part of any inspection plan and also not been removed from asset type test configurations.": {
    en: "Following assets have not been made part of any inspection plan and also not been removed from asset type test configurations.",
    fr: "Les actifs suivants n'ont été inclus dans aucun plan d'inspection et n'ont pas non plus été supprimés des configurations de tests de type d'actif.",
    es: "Los siguientes activos no se han incluido en ningún plan de inspección ni se han eliminado de las configuraciones de pruebas del tipo de activo.",
  },
  'As a result, these are being marked "Missed" on all places and alert notifications.': {
    en: 'As a result, these are being marked "Missed" on all places and alert notifications.',
    fr: "Par conséquent, ils sont marqués « Manqué » à tous les emplacements et dans les notifications d'alerte.",
    es: 'Como resultado, se están marcando como \"\"Perdidos\"\" en todos los lugares y notificaciones de alerta.',
  },
  "These assets need to be either excluded from asset type tests configurations or included in any desired inspection plan.": {
    en: "These assets need to be either excluded from asset type tests configurations or included in any desired inspection plan.",
    fr: "Ces actifs doivent soit être exclus des configurations de tests de type d'actif, soit être inclus dans un plan d'inspection souhaité.",
    es: "Estos activos deben excluirse de las configuraciones de pruebas del tipo de activo o incluirse en cualquier plan de inspección deseado.",
  },
  "Please take appropriate action.": {
    en: "Please take appropriate action.",
    fr: "Veuillez prendre les mesures appropriées.",
    es: "Por favor, tome las medidas adecuadas.",
  },
  "Disable All Tests": {
    en: "Disable All Tests",
    fr: "Désactiver tous les tests",
    es: "Deshabilitar todas las pruebas",
  },
  "Confirm Disable": {
    en: "Confirm Disable",
    fr: "Confirmer Désactiver",
    es: "Confirmar Desactivar",
  },
  "Are you sure you want to disable test?": {
    en: "Are you sure you want to disable test?",
    fr: "Êtes-vous sûr de vouloir désactiver le test ?",
    es: "¿Estás seguro de que quieres desactivar la prueba?",
  },
  "Disable Test": {
    en: "Disable Test",
    fr: "Désactiver le test",
    es: "Deshabilitar prueba",
  },
  "Tour Plan": {
    en: "Tour Plan",
    fr: "Plan de visite",
    es: "Plan de viaje",
  },
  Tours: {
    en: "Tours",
    fr: "Visites",
    es: "Visitas guiadas",
  },
  "Enter new tour name": {
    en: "Enter new tour name",
    fr: "Entrez le nouveau nom de la tournée",
    es: "Introduce el nuevo nombre del recorrido",
  },
  "Tour name is required.": {
    en: "Tour name is required.",
    fr: "Le nom du circuit est obligatoire.",
    es: "El nombre del tour es obligatorio.",
  },
  "Tour created successfully": {
    en: "Tour created successfully",
    fr: "Visite créée avec succès",
    es: "Tour creado exitosamente",
  },
  "Tour deleted successfully": {
    en: "Tour deleted successfully",
    fr: "Visite supprimée avec succès",
    es: "Tour eliminado exitosamente",
  },
  "Tour updated successfully": {
    en: "Tour updated successfully",
    fr: "Visite mise à jour avec succès",
    es: "Tour actualizado exitosamente",
  },
  "Inspection Assignment": {
    en: "Inspection Assignment",
    fr: "Mission d'inspection",
    es: "Asignación de inspección",
  },
  "User Assignment": {
    en: "User Assignment",
    fr: "Affectation des utilisateur",
    es: "Asignación de usuarios",
  },
  " * Click on": {
    en: " * Click on",
    fr: "* Cliquez sur",
    es: "*Haga clic en",
  },
  "for User Assignment": {
    en: "for User Assignment",
    fr: "pour l'attribution des utilisateurs",
    es: "para la asignación de usuarios",
  },
  "* Drag and Drop for User Assignment": {
    en: "* Drag and Drop for User Assignment",
    fr: "* Glisser-déposer pour l'attribution des utilisateurs",
    es: "* Arrastrar y soltar para la asignación de usuarios",
  },
  "Search inspections...": {
    en: "Search inspections...",
    fr: "Rechercher des inspections...",
    es: "Inspecciones de búsqueda...",
  },
  "Primary Users": {
    en: "Primary Users",
    fr: "Utilisateurs principaux",
    es: "Usuarios primarios",
  },
  "Secondary Users": {
    en: "Secondary Users",
    fr: "Utilisateurs secondaires",
    es: "Usuarios secundarios",
  },
  "No users": {
    en: "No users",
    fr: "Aucun utilisateur",
    es: "Sin usuarios",
  },
  "Search available users...": {
    en: "Search available users...",
    fr: "Rechercher les utilisateurs disponibles...",
    es: "Buscar usuarios disponibles ...",
  },
  "Unsaved Changes": {
    en: "Unsaved Changes",
    fr: "Modifications non enregistrées",
    es: "Cambios no guardados",
  },
  "This tour contains unsaved changes. If you proceed, all changes will be lost.": {
    en: "This tour contains unsaved changes. If you proceed, all changes will be lost.",
    fr: "Cette visite guidée contient des modifications non enregistrées. Si vous poursuivez, toutes les modifications seront perdues.",
    es: "Este tour contiene cambios sin guardar. Si continúa, se perderán todos los cambios.",
  },
  "Are you sure you want to delete this tour?": {
    en: "Are you sure you want to delete this tour?",
    fr: "Êtes-vous sûr de vouloir supprimer cette visite ?",
    es: "¿Estás seguro de que quieres eliminar este tour?",
  },
  "Tour description is required.": {
    en: "Tour description is required.",
    fr: "Une description du circuit est requise.",
    es: "Se requiere descripción del tour.",
  },
  "Tour not found or not yet saved properly.": {
    en: "Tour not found or not yet saved properly.",
    fr: "Circuit introuvable ou pas encore correctement enregistré.",
    es: "STour no encontrado o aún no guardado correctamente.",
  },
  Materials: {
    en: "Materials",
    fr: "Matériels",
    es: "Materiales",
  },
  "Material Type List": {
    en: "Material Type List",
    fr: "Matériels",
    es: "Liste des types de matériaux",
  },
  "Add Material Type": {
    en: "Add Material Type",
    fr: "Ajouter un type de matériau",
    es: "Agregar tipo de material",
  },
  "Edit Material Type": {
    en: "Edit Material Type",
    fr: "Modifier le type de matériau",
    es: "Editar tipo de material",
  },
  Unit: {
    en: "Unit",
    fr: "Unité",
    es: "Unidad",
  },
  "Item No.": {
    en: "Item No.",
    fr: "Numéro d'article.",
    es: "Número de artículo.",
  },
  "Material Type added successfully.": {
    en: "Material Type added successfully.",
    fr: "Type de matériau ajouté avec succès.",
    es: "Tipo de material agregado exitosamente.",
  },
  "Material Type updated successfully.": {
    en: "Material Type updated successfully.",
    fr: "Type de matériau mis à jour avec succès.",
    es: "Tipo de material actualizado exitosamente.",
  },
  "Material Type deleted successfully.": {
    en: "Material Type deleted successfully.",
    fr: "Unité",
    es: "Type de matériau supprimé avec succès.",
  },
  "Description already exists": {
    en: "Description already exists",
    fr: "La description existe déjà",
    es: "La descripción ya existe",
  },
  "Assigned Locations": {
    en: "Assigned Locations",
    fr: "Emplacements attribués",
    es: "Ubicaciones asignadas",
  },
  'Any "Not Configured" user will by default be assigned to all locations unless explicitly changed': {
    en: 'Any "Not Configured" user will by default be assigned to all locations unless explicitly changed',
    fr: "Tout utilisateur « Non configuré » sera affecté par défaut à tous les emplacements, sauf modification explicite.",
    es: 'Cualquier usuario \"\"No Configurado\"\" será asignado por defecto a todas las ubicaciones a menos que se cambie explícitamente',
  },
  "Not Configured": {
    en: "Not Configured",
    fr: "Non configuré",
    es: "No configurado",
  },
  "Error un-assigning locations, as some work orders/inspections in these locations are still in progress for the selected user.": {
    en: "Error un-assigning locations, as some work orders/inspections in these locations are still in progress for the selected user.",
    fr: "Erreur lors de la désaffectation des emplacements, car certains ordres de travail/inspections sont encore en cours pour l’utilisateur sélectionné.",
    es: "Error al desasignar ubicaciones, ya que algunas órdenes de trabajo/inspecciones aún están en curso para el usuario seleccionado.",
  },
  "Please complete all, and then retry.": {
    en: "Please complete all, and then retry.",
    fr: "Veuillez tout terminer, puis réessayer.",
    es: "Por favor complete todo y luego vuelva a intentarlo.",
  },
  "Details of in progress work orders/inspections are as below:": {
    en: "Details of in progress work orders/inspections are as below:",
    fr: "Les détails des ordres de travail/inspections en cours sont indiqués ci-dessous :",
    es: "Los detalles de las órdenes de trabajo/inspecciones en curso se muestran a continuación:",
  },
  "Update Assets Config": {
    en: "Update Assets Config",
    fr: "Mise à jour de la configuration des ressources",
    es: "Actualizar configuración de activos",
  },
  "Set Assets Config": {
    en: "Set Assets Config",
    fr: "Configurer les ressources",
    es: "Establecer configuración de activos",
  },
  "Enable Test Grouping Functionality": {
    en: "Enable Test Grouping Functionality",
    fr: "Activer la fonctionnalité de regroupement des tests",
    es: "Habilitar la funcionalidad de agrupación de pruebas",
  },
  Dear: {
    en: "Dear",
    fr: "Cher",
    es: "Estimado",
  },

  "You are receiving this email because your user account has been recently created on": {
    en: "You are receiving this email because your user account has been recently created on",
    fr: "Vous recevez cet e-mail car votre compte utilisateur a été récemment créé sur",
    es: "Recibe este correo electrónico porque su cuenta de usuario ha sido creada recientemente en",
  },

  "You are receiving this email because your password has recently been changed for": {
    en: "You are receiving this email because your password has recently been changed for",
    fr: "Vous recevez cet e-mail car votre mot de passe a récemment été modifié pour",
    es: "Recibe este correo electrónico porque su contraseña ha sido cambiada recientemente para",
  },

  on: {
    en: "on",
    fr: "le",
    es: "el",
  },

  "For your security, we recommend that you log in to the": {
    en: "For your security, we recommend that you log in to the",
    fr: "Pour votre sécurité, nous vous recommandons de vous connecter au",
    es: "Por su seguridad, le recomendamos que inicie sesión en el",
  },

  "Portal and change your temporary password to a new, unique password as soon as possible.": {
    en: "Portal and change your temporary password to a new, unique password as soon as possible.",
    fr: "portail et de modifier votre mot de passe temporaire en un nouveau mot de passe unique dès que possible.",
    es: "portal y cambie su contraseña temporal por una nueva contraseña única lo antes posible.",
  },

  "Please click on the following link or paste the same in your web browser to reset your password:": {
    en: "Please click on the following link or paste the same in your web browser to reset your password:",
    fr: "Veuillez cliquer sur le lien suivant ou le coller dans votre navigateur Web pour réinitialiser votre mot de passe :",
    es: "Haga clic en el siguiente enlace o péguelo en su navegador web para restablecer su contraseña:",
  },

  "For your security, please click on the following link or paste the same in your web browser to reset your password and change your password to a new, unique password immediately:":
    {
      en: "For your security, please click on the following link or paste the same in your web browser to reset your password and change your password to a new, unique password immediately:",
      fr: "Pour votre sécurité, veuillez cliquer sur le lien suivant ou le coller dans votre navigateur Web pour réinitialiser votre mot de passe et le modifier immédiatement par un nouveau mot de passe unique :",
      es: "Por su seguridad, haga clic en el siguiente enlace o péguelo en su navegador web para restablecer su contraseña y cambiarla inmediatamente por una nueva contraseña única:",
    },

  "This is to help ensure a secure user experience.": {
    en: "This is to help ensure a secure user experience.",
    fr: "Cela permet de garantir une expérience utilisateur sécurisée.",
    es: "Esto ayuda a garantizar una experiencia de usuario segura.",
  },

  "For any further assistance, please contact system administrator.": {
    en: "For any further assistance, please contact system administrator.",
    fr: "Pour toute assistance supplémentaire, veuillez contacter l’administrateur système.",
    es: "Para cualquier asistencia adicional, póngase en contacto con el administrador del sistema.",
  },

  Regards: {
    en: "Regards",
    fr: "Cordialement",
    es: "Saludos",
  },

  "Reset Password": {
    en: "Reset Password",
    fr: "Réinitialiser le mot de passe",
    es: "Restablecer contraseña",
  },
  "Password Updated Successfully": {
    en: "Password Updated Successfully",
    fr: "Mot de passe mis à jour avec succès",
    es: "Contraseña actualizada exitosamente",
  },

  "To Login": {
    en: "To Login",
    fr: "Pour vous connecter",
    es: "Para iniciar sesión",
  },
  "Select a tour to view details.": {
    en: "Select a tour to view details.",
    fr: "Sélectionnez une visite pour en afficher les détails.",
    es: "Seleccione un tour para ver los detalles.",
  },
  "Monthly On-duty hours exceeded 276 hours.": {
    en: "Monthly On-duty hours exceeded 276 hours.",
    es: "Las horas de servicio mensual superaron las 276 horas.",
    fr: "Les heures de service mensuelles ont dépassé 276 heures.",
  },
  "Delete Off Duty": {
    en: "Delete Off Duty",
    es: "Eliminar fuera de servicio",
    fr: "Supprimer hors service",
  },
  "View Template": {
    en: "View Template",
    es: "Ver plantilla",
    fr: "Voir le modèle",
  },
  "Edit Template": {
    en: "Edit Template",
    es: "Editar plantilla",
    fr: "Modifier le modèle",
  },
  "Daily Material Usage Report": {
    en: "Daily Material Usage Report",
    es: "Informe diario de uso de materiales",
    fr: "Rapport quotidien d'utilisation des matériaux",
  },
  "Work Gang Report": {
    en: "Work Gang Report",
    es: "Informe del grupo de trabajo",
    fr: "Rapport de l'équipe de travail",
  },
  Performed: {
    en: "Performed",
    es: "Realizado",
    fr: "Effectué",
  },
  "App Version": {
    en: "App Version",
    es: "Versión de la aplicación",
    fr: "Version de l'application",
  },
  "App Type": {
    en: "App Type",
    es: "Tipo de aplicación",
    fr: "Type d'application",
  },
  "Work Gangs": {
    en: "Work Gangs",
    es: "Cuadrillas de trabajo",
    fr: "Équipes de travail",
  },
  "Comments for FRA Report": {
    en: "Comments for FRA Report",
    es: "Comentarios sobre el informe de la FRA",
    fr: "Commentaires concernant le rapport de la FRA",
  },
  "Exceeded 12 hours of duty time in 24 hours period.": {
    en: "Exceeded 12 hours of duty time in 24 hours period.",
    es: "Superó las 12 horas de tiempo de servicio en un período de 24 horas.",
    fr: "Dépassement de 12 heures de service sur une période de 24 heures",
  },
  "Historical?": {
    en: "Historical?",
    es: "¿Histórico?",
    fr: "Historique?",
  },
  "AFE Number": {
    en: "AFE Number",
    es: "Número AFE",
    fr: "Numéro AFE",
  },
  "Document uploaded successfully": {
    en: "Document uploaded successfully",
    es: "Documento cargado exitosamente",
    fr: "Document téléchargé avec succès",
  },
  "App Form Attributes": {
    en: "App Form Attributes",
    es: "Atributos del formulario de la aplicación",
    fr: "Attributs du formulaire d'application",
  },
  "Password must contain at least 8 characters, 1 number, 1 uppercase letter, 1 lowercase letter, and 1 special character": {
    en: "Password must contain at least 8 characters, 1 number, 1 uppercase letter, 1 lowercase letter, and 1 special character",
    es: "La contraseña debe contener al menos 8 caracteres, 1 número, 1 letra mayúscula, 1 letra minúscula y 1 carácter especial.",
    fr: "Le mot de passe doit contenir au moins 8 caractères, 1 chiffre, 1 lettre majuscule, 1 lettre minuscule et 1 caractère spécial.",
  },
  "Item No. already exists": {
    en: "Item No. already exists",
    es: "El número de artículo ya existe",
    fr: "L'article n° existe déjà.",
  },
};



// WEBPACK FOOTER //
// ./src/Language/Dictionery.js